import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateArray: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
};

export type AcceptsDogs = {
  __typename?: 'AcceptsDogs';
  giant: Scalars['Boolean']['output'];
  large: Scalars['Boolean']['output'];
  medium: Scalars['Boolean']['output'];
  puppy: Scalars['Boolean']['output'];
  small: Scalars['Boolean']['output'];
};

export type AcceptsDogsInput = {
  giant: Scalars['Boolean']['input'];
  large: Scalars['Boolean']['input'];
  medium: Scalars['Boolean']['input'];
  puppy: Scalars['Boolean']['input'];
  small: Scalars['Boolean']['input'];
};

/** Autogenerated input type of AddBookmark */
export type AddBookmarkInput = {
  caregiverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddBookmark */
export type AddBookmarkPayload = {
  __typename?: 'AddBookmarkPayload';
  caregiver?: Maybe<Caregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AddCaregiverPhotos */
export type AddCaregiverPhotosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  photosInput: Array<CaregiverPhotoInput>;
};

/** Autogenerated return type of AddCaregiverPhotos */
export type AddCaregiverPhotosPayload = {
  __typename?: 'AddCaregiverPhotosPayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AddCaregiverReview */
export type AddCaregiverReviewInput = {
  bookingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentForAdmins?: InputMaybe<Scalars['String']['input']>;
  privateContent?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};

/** Autogenerated return type of AddCaregiverReview */
export type AddCaregiverReviewPayload = {
  __typename?: 'AddCaregiverReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  review?: Maybe<Review>;
};

/** Autogenerated input type of AddDog */
export type AddDogInput = {
  activityLevel?: InputMaybe<DogActivityLevel>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthday: Scalars['ISO8601Date']['input'];
  breedId?: InputMaybe<Scalars['ID']['input']>;
  chip?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyFood?: InputMaybe<Scalars['String']['input']>;
  dailyFoodServings?: InputMaybe<DayPeriodInput>;
  dailyWalks?: InputMaybe<DayPeriodInput>;
  gender: Scalars['String']['input'];
  healthInfo?: InputMaybe<Scalars['String']['input']>;
  homeAlone?: InputMaybe<Scalars['String']['input']>;
  indoorPrecautions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  petType?: InputMaybe<Scalars['String']['input']>;
  playsCats?: InputMaybe<Scalars['Boolean']['input']>;
  playsCatsDesc?: InputMaybe<Scalars['String']['input']>;
  playsChildren?: InputMaybe<Scalars['Boolean']['input']>;
  playsChildrenDesc?: InputMaybe<Scalars['String']['input']>;
  playsDogs?: InputMaybe<Scalars['Boolean']['input']>;
  playsDogsDesc?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  walkingInstructions?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddDog */
export type AddDogPayload = {
  __typename?: 'AddDogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dog?: Maybe<Dog>;
  errors: Array<Error>;
};

/** Autogenerated input type of AddDogPhotos */
export type AddDogPhotosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  photosInput: Array<DogPhotoInput>;
};

/** Autogenerated return type of AddDogPhotos */
export type AddDogPhotosPayload = {
  __typename?: 'AddDogPhotosPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dog?: Maybe<Dog>;
  errors: Array<Error>;
};

/** Autogenerated input type of AddDogReviews */
export type AddDogReviewsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reviewsInput: Array<DogReviewInput>;
};

/** Autogenerated return type of AddDogReviews */
export type AddDogReviewsPayload = {
  __typename?: 'AddDogReviewsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reviews?: Maybe<Array<Review>>;
};

/** Autogenerated input type of AddJob */
export type AddJobInput = {
  bookingDates: BookingDatesInput;
  city: CityInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  dogIds: Array<Scalars['ID']['input']>;
  playsCats?: InputMaybe<Scalars['Boolean']['input']>;
  playsChildren?: InputMaybe<Scalars['Boolean']['input']>;
  playsDogs?: InputMaybe<Scalars['Boolean']['input']>;
  serviceTypeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddJob */
export type AddJobPayload = {
  __typename?: 'AddJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  job?: Maybe<Job>;
};

/** Autogenerated input type of AddMessage */
export type AddMessageInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  type?: InputMaybe<MessageType>;
};

/** Autogenerated return type of AddMessage */
export type AddMessagePayload = {
  __typename?: 'AddMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of AddService */
export type AddServiceInput = {
  acceptsDogs?: InputMaybe<AcceptsDogsInput>;
  additionalCatPrice?: InputMaybe<Scalars['Int']['input']>;
  additionalDogPrice?: InputMaybe<Scalars['Int']['input']>;
  catPrice?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogPrice?: InputMaybe<Scalars['Int']['input']>;
  extraTimePrice?: InputMaybe<Scalars['Int']['input']>;
  holidayCatPrice?: InputMaybe<Scalars['Int']['input']>;
  holidayPrice?: InputMaybe<Scalars['Int']['input']>;
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
  meetAndGreetPrice?: InputMaybe<Scalars['Int']['input']>;
  pickUpDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  pickUpDropOffDistance?: InputMaybe<Scalars['Int']['input']>;
  pickUpDropOffPrice?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  puppyPrice?: InputMaybe<Scalars['Int']['input']>;
  serviceTypeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddService */
export type AddServicePayload = {
  __typename?: 'AddServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  service?: Maybe<Service>;
};

export type Application = {
  __typename?: 'Application';
  caregiver: Caregiver;
  estimatedPaymentTotal?: Maybe<Money>;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of ApplyCouponRedemption */
export type ApplyCouponRedemptionInput = {
  bookingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponRedemptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyCouponRedemption */
export type ApplyCouponRedemptionPayload = {
  __typename?: 'ApplyCouponRedemptionPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AuthenticateWithApple */
export type AuthenticateWithAppleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  idToken: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AuthenticateWithApple */
export type AuthenticateWithApplePayload = {
  __typename?: 'AuthenticateWithApplePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CurrentUser>;
};

/** Autogenerated input type of AuthenticateWithFacebook */
export type AuthenticateWithFacebookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookToken: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AuthenticateWithFacebook */
export type AuthenticateWithFacebookPayload = {
  __typename?: 'AuthenticateWithFacebookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CurrentUser>;
};

export type Availability = {
  __typename?: 'Availability';
  /** Dates when the caregiver is booked */
  booked: Array<Scalars['ISO8601Date']['output']>;
  /** Dates when the caregiver is not available */
  unavailable: Array<Scalars['ISO8601Date']['output']>;
};

/** Data requiered to update availability */
export type AvailabilityInput = {
  dates: Array<Scalars['ISO8601Date']['input']>;
  spacesAvailable: Scalars['Int']['input'];
};

export type BillingBankAccount = {
  __typename?: 'BillingBankAccount';
  accountNumber?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ownerAddress: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  sortCode?: Maybe<Scalars['String']['output']>;
};

export type BillingBankRewardWire = {
  __typename?: 'BillingBankRewardWire';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  rewardCaregiverId: Scalars['String']['output'];
  status?: Maybe<BillingBankRewardWireStatus>;
  token: Scalars['String']['output'];
  total: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum BillingBankRewardWireStatus {
  /** CREATED */
  Created = 'CREATED',
  /** FAILED */
  Failed = 'FAILED',
  /** SUCCEEDED */
  Succeeded = 'SUCCEEDED'
}

export type BillingBankWire = {
  __typename?: 'BillingBankWire';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<BillingBankWireStatus>;
  token: Scalars['String']['output'];
  total: Money;
  transferId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum BillingBankWireStatus {
  /** CREATED */
  Created = 'CREATED',
  /** FAILED */
  Failed = 'FAILED',
  /** SUCCEEDED */
  Succeeded = 'SUCCEEDED'
}

export type BillingCard = {
  __typename?: 'BillingCard';
  alias: Scalars['String']['output'];
  currency?: Maybe<Currency>;
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  provider: Scalars['String']['output'];
};

export type BillingCardRegistration = {
  __typename?: 'BillingCardRegistration';
  accessKey: Scalars['String']['output'];
  cardRegistrationUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  preregistrationData: Scalars['String']['output'];
};

export type BillingCaregiverReward = {
  __typename?: 'BillingCaregiverReward';
  amount?: Maybe<Money>;
  bankRewardWire?: Maybe<BillingBankRewardWire>;
  id: Scalars['ID']['output'];
};

export type BillingPayment = {
  __typename?: 'BillingPayment';
  amount?: Maybe<Money>;
  booking: Booking;
  id: Scalars['ID']['output'];
  isCardPayment: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<PaymentMethodInfo>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  /** @deprecated Use `redirectUrl` instead */
  threeDSecureUrl?: Maybe<Scalars['String']['output']>;
};

export type BillingProfile = {
  __typename?: 'BillingProfile';
  id?: Maybe<Scalars['ID']['output']>;
  identityStatus: Scalars['String']['output'];
  taxpayerIdNumber?: Maybe<Scalars['String']['output']>;
  taxpayerIdNumberCountry?: Maybe<Scalars['String']['output']>;
};

export type Blog = {
  __typename?: 'Blog';
  posts?: Maybe<Array<BlogPost>>;
  url: Scalars['String']['output'];
};

export type BlogPost = {
  __typename?: 'BlogPost';
  excerpt?: Maybe<Scalars['String']['output']>;
  featuredMedia?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BookedAvailability = {
  __typename?: 'BookedAvailability';
  booking: Booking;
  date: Scalars['ISO8601Date']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  address?: Maybe<Scalars['String']['output']>;
  amountToRefund?: Maybe<Money>;
  availableEvents?: Maybe<Array<BookingEvent>>;
  bankWire?: Maybe<BillingBankWire>;
  baseFee: Money;
  bookingDogs?: Maybe<Array<BookingDog>>;
  canBeTransferredToBankAccount?: Maybe<Scalars['Boolean']['output']>;
  canCaregiverBeReviewed?: Maybe<Scalars['Boolean']['output']>;
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['ID']['output'];
  caregiverReview?: Maybe<Review>;
  contact?: Maybe<Contact>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  costAdjustment?: Maybe<Money>;
  country: Country;
  countryServiceType: CountryServiceType;
  couponRedemption?: Maybe<CouponRedemption>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  dogIds: Array<Scalars['ID']['output']>;
  dogReviews?: Maybe<Array<Review>>;
  dogs: Array<Dog>;
  eligibleForFreeCancellation: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fee: Money;
  freeCancellationLimit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fromDogley?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  latePickUpPrice?: Maybe<Money>;
  meetAndGreet?: Maybe<Scalars['Boolean']['output']>;
  meetAndGreetPrice?: Maybe<Money>;
  numberOfTrips?: Maybe<Scalars['Int']['output']>;
  parentBookingId?: Maybe<Scalars['ID']['output']>;
  payment?: Maybe<BillingPayment>;
  paymentConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentTotal: Money;
  pickUpDropOff?: Maybe<Scalars['Boolean']['output']>;
  pickUpDropOffPrice?: Maybe<Money>;
  price: Money;
  refundAmount?: Maybe<Money>;
  service?: Maybe<Service>;
  serviceDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  serviceQuantity?: Maybe<Scalars['Int']['output']>;
  serviceTotal: Money;
  serviceType: ServiceType;
  serviceTypeId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  total: Money;
  totalFee: Money;
  totalFeeVat: Money;
  transferAmount?: Maybe<Money>;
  unitPrice: Money;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

/** Dates value (date range or multiple dates) for a booking */
export type BookingDatesInput = {
  dates?: InputMaybe<Array<Scalars['ISO8601DateTime']['input']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  extraTime?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type BookingDog = {
  __typename?: 'BookingDog';
  booking: Booking;
  bookingId: Scalars['ID']['output'];
  canDogBeReviewed?: Maybe<Scalars['Boolean']['output']>;
  dog?: Maybe<Dog>;
  dogId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  price?: Maybe<Money>;
  priceType?: Maybe<PriceTypeEnum>;
};

export enum BookingEvent {
  /** Caregiver can accept the booking request */
  CaregiverApprove = 'CAREGIVER_APPROVE',
  /** Caregiver can cancel the booking */
  CaregiverCancel = 'CAREGIVER_CANCEL',
  /** Caregiver can confirm an owner preapproved booking */
  CaregiverConfirm = 'CAREGIVER_CONFIRM',
  /** Caregiver can reject the booking request */
  CaregiverReject = 'CAREGIVER_REJECT',
  /** User (owner / caregiver) can edit the booking request */
  EditRequest = 'EDIT_REQUEST',
  /** Owner can cancel the booking */
  OwnerCancel = 'OWNER_CANCEL',
  /** Owner can confirm booking request */
  OwnerConfirm = 'OWNER_CONFIRM',
  /** Owner can preapprove the booking request */
  OwnerPreapprove = 'OWNER_PREAPPROVE',
  /** Owner can reject the booking request */
  OwnerReject = 'OWNER_REJECT'
}

export type BookingHistory = {
  __typename?: 'BookingHistory';
  past: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type BookingPriceDogsInput = {
  id: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
};

export type BookingPriceEstimation = {
  __typename?: 'BookingPriceEstimation';
  additionalCatServicePrice?: Maybe<PriceForDogs>;
  additionalDogServicePrice?: Maybe<PriceForDogs>;
  duration: Scalars['Int']['output'];
  extraTimePrice?: Maybe<Money>;
  fee: Money;
  holidayCatServicePrice?: Maybe<PriceForDogs>;
  holidayServicePrice?: Maybe<PriceForDogs>;
  latePickUpPrice?: Maybe<Money>;
  meetAndGreetPrice?: Maybe<Money>;
  pickUpDropOffPrice?: Maybe<Money>;
  pricePer: Scalars['String']['output'];
  puppyServicePrice?: Maybe<PriceForDogs>;
  serviceTotal: Money;
  standardCatServicePrice?: Maybe<PriceForDogs>;
  standardServicePrice?: Maybe<PriceForDogs>;
  total: Money;
};

/** Dates value (date range or multiple dates) for a booking */
export type BookingPriceInput = {
  costAdjustment?: InputMaybe<Scalars['Float']['input']>;
  dogs?: InputMaybe<Array<BookingPriceDogsInput>>;
  meetAndGreetPrice?: InputMaybe<Scalars['Float']['input']>;
  pickUpDropOffPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of BookingUpdated */
export type BookingUpdatedPayload = {
  __typename?: 'BookingUpdatedPayload';
  booking?: Maybe<Booking>;
};

export type BookingWithReward = {
  __typename?: 'BookingWithReward';
  booking: Booking;
  reward?: Maybe<ReferralRewardUnion>;
};

export type Breed = {
  __typename?: 'Breed';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  tName?: Maybe<Scalars['String']['output']>;
};

export type BrowserInfoInput = {
  colorDepth: Scalars['Int']['input'];
  javascriptEnabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timeZoneOffset: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export type BusinessInfo = {
  __typename?: 'BusinessInfo';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/** Data requiered to update caregiver business info */
export type BusinessInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum CancelationReason {
  /** accident */
  Accident = 'ACCIDENT',
  /** dont_like_caregiver */
  DontLikeCaregiver = 'DONT_LIKE_CAREGIVER',
  /** other */
  Other = 'OTHER',
  /** trip_canceled */
  TripCanceled = 'TRIP_CANCELED',
  /** unnecessary */
  Unnecessary = 'UNNECESSARY'
}

export enum CardType {
  Amex = 'AMEX',
  Bcmc = 'BCMC',
  CbVisaMastercard = 'CB_VISA_MASTERCARD',
  Diners = 'DINERS',
  Ideal = 'IDEAL',
  Maestro = 'MAESTRO',
  Masterpass = 'MASTERPASS',
  P24 = 'P24',
  Paylib = 'PAYLIB'
}

export type Caregiver = User & {
  __typename?: 'Caregiver';
  answerRatio?: Maybe<Scalars['String']['output']>;
  atHomeAvailability?: Maybe<CaregiverAvailability>;
  atHomeServicePreferences?: Maybe<ServicePreferences>;
  availableHolidays?: Maybe<Scalars['String']['output']>;
  availablePromotions?: Maybe<Array<CaregiverPromotion>>;
  avatar?: Maybe<UserAvatar>;
  billingProfile?: Maybe<BillingProfile>;
  bookingEstimation?: Maybe<Money>;
  bookingsRatio?: Maybe<Scalars['String']['output']>;
  bookmarked?: Maybe<Scalars['String']['output']>;
  businessInfo?: Maybe<BusinessInfo>;
  calendarUpToDate?: Maybe<Scalars['Boolean']['output']>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  caregiverActive?: Maybe<Scalars['Boolean']['output']>;
  caregiverCalendarUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  caregiverCanAdministerInjectedMeds?: Maybe<Scalars['Boolean']['output']>;
  caregiverCanAdministerOralMeds?: Maybe<Scalars['Boolean']['output']>;
  caregiverCompletedBookingsCount?: Maybe<Scalars['Int']['output']>;
  caregiverDeactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  caregiverDescription?: Maybe<Scalars['String']['output']>;
  caregiverHasAnimalCertificate?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasCats?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasKidsUnder18?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasPppLicense?: Maybe<Scalars['Boolean']['output']>;
  caregiverHeadline?: Maybe<Scalars['String']['output']>;
  caregiverNoob?: Maybe<Scalars['String']['output']>;
  caregiverOwnVehicle?: Maybe<Scalars['Boolean']['output']>;
  caregiverPremium?: Maybe<Scalars['String']['output']>;
  caregiverProvideCustomerReviews?: Maybe<Scalars['Boolean']['output']>;
  caregiverReviewsCount?: Maybe<Scalars['Int']['output']>;
  caregiverReviewsScore?: Maybe<Scalars['Float']['output']>;
  caregiverScore?: Maybe<Scalars['String']['output']>;
  caregiverSeoFixedSlug?: Maybe<Scalars['String']['output']>;
  caregiverStatus?: Maybe<CaregiverStatus>;
  caregiverStep?: Maybe<Scalars['String']['output']>;
  caregiverVolunteerAnimalGroups?: Maybe<Scalars['Boolean']['output']>;
  caregiverXpAcommodatingDogs?: Maybe<Scalars['Boolean']['output']>;
  caregiverXpAsDogWalker?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  cleanHeadline?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  featuredReview?: Maybe<Review>;
  id: Scalars['ID']['output'];
  isSuperCaregiver?: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  minPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outsideAvailability?: Maybe<CaregiverAvailability>;
  outsideServicePreferences?: Maybe<ServicePreferences>;
  photos?: Maybe<Array<UserPhoto>>;
  price?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  publicAddress?: Maybe<Scalars['String']['output']>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  repeatCustomersCount?: Maybe<Scalars['Int']['output']>;
  repeatCustomersRatio?: Maybe<Scalars['Float']['output']>;
  responseTime?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<PaginatedReviews>;
  searchDistanceAwayKm?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Service>>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};


export type CaregiverBookingEstimationArgs = {
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type CaregiverPriceArgs = {
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type CaregiverReviewsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CaregiverApplyForJob */
export type CaregiverApplyForJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CaregiverApplyForJob */
export type CaregiverApplyForJobPayload = {
  __typename?: 'CaregiverApplyForJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CaregiverApproveBooking */
export type CaregiverApproveBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CaregiverApproveBooking */
export type CaregiverApproveBookingPayload = {
  __typename?: 'CaregiverApproveBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type CaregiverAvailability = {
  __typename?: 'CaregiverAvailability';
  /** Dates when the caregiver as altered the spaces available */
  available: Array<SpacesAvailable>;
  /** Dates when the caregiver is booked */
  booked: Array<BookedAvailability>;
  /** Dates when the caregiver is not available */
  unavailable: Array<Scalars['ISO8601Date']['output']>;
};

export type CaregiverBookings = {
  __typename?: 'CaregiverBookings';
  past: PaginatedBookings;
  upcoming: PaginatedBookings;
};

/** Autogenerated input type of CaregiverCancelBooking */
export type CaregiverCancelBookingInput = {
  cancelationReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meetAndGreetCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CaregiverCancelBooking */
export type CaregiverCancelBookingPayload = {
  __typename?: 'CaregiverCancelBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CaregiverConfirmBooking */
export type CaregiverConfirmBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CaregiverConfirmBooking */
export type CaregiverConfirmBookingPayload = {
  __typename?: 'CaregiverConfirmBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CaregiverDismissJob */
export type CaregiverDismissJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
};

/** Autogenerated return type of CaregiverDismissJob */
export type CaregiverDismissJobPayload = {
  __typename?: 'CaregiverDismissJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CaregiverPayoutBooking */
export type CaregiverPayoutBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CaregiverPayoutBooking */
export type CaregiverPayoutBookingPayload = {
  __typename?: 'CaregiverPayoutBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CaregiverPayoutReward */
export type CaregiverPayoutRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CaregiverPayoutReward */
export type CaregiverPayoutRewardPayload = {
  __typename?: 'CaregiverPayoutRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  rewardCaregiver?: Maybe<BillingCaregiverReward>;
};

export enum CaregiverPhotoCategory {
  /** Photos of the caregiver's available area for profile */
  Area = 'AREA',
  /** Photos of dogs for caregiver profile */
  Dog = 'DOG',
  /** Photos of the caregiver's home for profile */
  Home = 'HOME'
}

/** Data required to create/update a caregiver photo */
export type CaregiverPhotoInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  caregiverPhotoId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<CaregiverPhotoCategory>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CaregiverPromotion = {
  __typename?: 'CaregiverPromotion';
  id: Scalars['ID']['output'];
  tLabel: Scalars['String']['output'];
};

/** Autogenerated input type of CaregiverRejectBooking */
export type CaregiverRejectBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonType: CaregiverRejectionReason;
  shouldUpdateCalendar?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CaregiverRejectBooking */
export type CaregiverRejectBookingPayload = {
  __typename?: 'CaregiverRejectBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum CaregiverRejectionReason {
  /** as_admin */
  AsAdmin = 'AS_ADMIN',
  /** dog_not_suitable */
  DogNotSuitable = 'DOG_NOT_SUITABLE',
  /** inoperative */
  Inoperative = 'INOPERATIVE',
  /** no_response */
  NoResponse = 'NO_RESPONSE',
  /** other */
  Other = 'OTHER',
  /** unavailable */
  Unavailable = 'UNAVAILABLE',
  /** unavailable_outside */
  UnavailableOutside = 'UNAVAILABLE_OUTSIDE'
}

export enum CaregiverStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CaregiverTips = {
  __typename?: 'CaregiverTips';
  tips?: Maybe<Array<Tip>>;
};

export type CategorizedUserPhoto = {
  __typename?: 'CategorizedUserPhoto';
  area?: Maybe<Array<UserPhoto>>;
  dog?: Maybe<Array<UserPhoto>>;
  home?: Maybe<Array<UserPhoto>>;
};

/** Autogenerated input type of ChangeJobsBoardEnabledState */
export type ChangeJobsBoardEnabledStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ChangeJobsBoardEnabledState */
export type ChangeJobsBoardEnabledStatePayload = {
  __typename?: 'ChangeJobsBoardEnabledStatePayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type City = {
  __typename?: 'City';
  activeCaregiversCount?: Maybe<Scalars['Int']['output']>;
  avgCaregiverReviewsScore?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxServicePriceCents?: Maybe<Scalars['String']['output']>;
  minServicePriceCents?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nearbyCities?: Maybe<Array<City>>;
  placeId?: Maybe<Scalars['String']['output']>;
  seoLandingNoindexTag: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<CityStats>;
  sumCaregiverReviewsCount?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type CityMaxServicePriceCentsArgs = {
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type CityMinServicePriceCentsArgs = {
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CityInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  placeDetails?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  placeTypes?: InputMaybe<Scalars['String']['input']>;
};

export type CityStats = {
  __typename?: 'CityStats';
  activeSitters: Scalars['Int']['output'];
  boardingActiveSitters: Scalars['Int']['output'];
  boardingAvgBookingPrice: Scalars['Int']['output'];
  boardingAvgNights: Scalars['Int']['output'];
  boardingAvgPricePerNight: Scalars['Int']['output'];
  boardingCompletedBookings: Scalars['Int']['output'];
  boardingMinSitterRate: Scalars['Int']['output'];
  boardingRatePlusSecondDog: Scalars['Int']['output'];
  boardingRequestDayInAdvance: Scalars['Int']['output'];
  boardingSitterReviews: Scalars['Int']['output'];
  completedBookings: Scalars['Int']['output'];
  daycareActiveSitters: Scalars['Int']['output'];
  daycareAvgBookingPrice: Scalars['Int']['output'];
  daycareAvgDays: Scalars['Int']['output'];
  daycareAvgPricePerDay: Scalars['Int']['output'];
  daycareCompletedBookings: Scalars['Int']['output'];
  daycareMinSitterRate: Scalars['Int']['output'];
  daycareRatePlusSecondDog: Scalars['Int']['output'];
  daycareRequestDayInAdvance: Scalars['Int']['output'];
  daycareSitterReviews: Scalars['Int']['output'];
  minSitterRate: Scalars['Int']['output'];
  sitterReviews: Scalars['Int']['output'];
  walkingActiveSitters: Scalars['Int']['output'];
  walkingAvgBookingPrice: Scalars['Int']['output'];
  walkingAvgPricePerWalk: Scalars['Int']['output'];
  walkingAvgWalks: Scalars['Int']['output'];
  walkingCompletedBookings: Scalars['Int']['output'];
  walkingMinSitterRate: Scalars['Int']['output'];
  walkingRatePlusSecondDog: Scalars['Int']['output'];
  walkingRequestDayInAdvance: Scalars['Int']['output'];
  walkingSitterReviews: Scalars['Int']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ContactCaregiver */
export type ContactCaregiverInput = {
  bookingDates: BookingDatesInput;
  caregiverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogIds: Array<Scalars['ID']['input']>;
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  parentBookingId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickUpDropOff?: InputMaybe<PickUpDropOffInput>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactCaregiver */
export type ContactCaregiverPayload = {
  __typename?: 'ContactCaregiverPayload';
  alternativeCaregivers?: Maybe<Array<Caregiver>>;
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors: Array<Error>;
  potentialJob?: Maybe<PotentialJob>;
};

export type Conversation = {
  __typename?: 'Conversation';
  bookings: ConversationBookings;
  caregiver: User;
  id?: Maybe<Scalars['ID']['output']>;
  /** Messages for the conversation paginated and starting by most recent */
  messages?: Maybe<PaginatedMessages>;
  /** The other user (not the current user) in the conversation */
  partner: User;
  user: User;
};


export type ConversationMessagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationBookings = {
  __typename?: 'ConversationBookings';
  past: Array<Booking>;
  requests: Array<Booking>;
  upcoming: Array<Booking>;
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  bookingHistory: BookingHistory;
  id?: Maybe<Scalars['ID']['output']>;
  lastMessage: Message;
  /** The other user (not the current user) in the conversation */
  partner: User;
  unreadMessages: Scalars['Int']['output'];
};

/** The connection type for ConversationSummary. */
export type ConversationSummaryConnection = {
  __typename?: 'ConversationSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversationSummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ConversationSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConversationSummaryEdge = {
  __typename?: 'ConversationSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConversationSummary>;
};

export type Country = {
  __typename?: 'Country';
  countryServiceTypes?: Maybe<Array<CountryServiceType>>;
  currency: Currency;
  fullDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  iso3661Alpha2?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paymentMethods: Array<PaymentMethod>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  vat: Scalars['String']['output'];
};

export type CountryServiceType = {
  __typename?: 'CountryServiceType';
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionForCaregivers?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meetAndGreet?: Maybe<Scalars['Boolean']['output']>;
  minimumPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  petTypes?: Maybe<Array<PetType>>;
  seoName?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<ServiceType>;
};

export type Coupon = {
  __typename?: 'Coupon';
  canBeTransferredToBankAccount?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  currency: Currency;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fixedDiscount?: Maybe<Money>;
  id: Scalars['ID']['output'];
  minimumAmount?: Maybe<Money>;
  percentageDiscount?: Maybe<Scalars['Float']['output']>;
  rewardBankWire?: Maybe<BillingBankRewardWire>;
  startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  type: Scalars['String']['output'];
};

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  coupon: Coupon;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateBillingBankAccount */
export type CreateBillingBankAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  ownerAddress: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBillingBankAccount */
export type CreateBillingBankAccountPayload = {
  __typename?: 'CreateBillingBankAccountPayload';
  billingBankAccount?: Maybe<BillingBankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateBillingCard */
export type CreateBillingCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBillingCard */
export type CreateBillingCardPayload = {
  __typename?: 'CreateBillingCardPayload';
  billingCard?: Maybe<BillingCard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateJobFromBooking */
export type CreateJobFromBookingInput = {
  bookingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateJobFromBooking */
export type CreateJobFromBookingPayload = {
  __typename?: 'CreateJobFromBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  job?: Maybe<Job>;
};

export enum Currency {
  /** Danish krone currency */
  Dkk = 'DKK',
  /** Euro currency */
  Eur = 'EUR',
  /** British pounds currency */
  Gbp = 'GBP',
  /** Nowegian Krone currency */
  Nok = 'NOK',
  /** Swedish krona currency */
  Sek = 'SEK'
}

export type CurrentCaregiver = CurrentUser & User & {
  __typename?: 'CurrentCaregiver';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  answerRatio?: Maybe<Scalars['String']['output']>;
  appMagicLink: Scalars['String']['output'];
  atHomeAvailability?: Maybe<CaregiverAvailability>;
  atHomeServicePreferences?: Maybe<ServicePreferences>;
  availableHolidays?: Maybe<Scalars['String']['output']>;
  availablePromotions?: Maybe<Array<CaregiverPromotion>>;
  avatar?: Maybe<UserAvatar>;
  billingBankAccount?: Maybe<BillingBankAccount>;
  billingCards?: Maybe<Array<BillingCard>>;
  billingProfile?: Maybe<BillingProfile>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  bookingEstimation?: Maybe<Money>;
  bookingsRatio?: Maybe<Scalars['String']['output']>;
  bookingsStartingInNext7Days: Array<Booking>;
  bookmarked?: Maybe<Scalars['String']['output']>;
  bookmarks?: Maybe<Array<Caregiver>>;
  businessInfo?: Maybe<BusinessInfo>;
  calendarUpToDate?: Maybe<Scalars['Boolean']['output']>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  caregiverActive?: Maybe<Scalars['Boolean']['output']>;
  caregiverCalendarUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  caregiverCanAdministerInjectedMeds?: Maybe<Scalars['Boolean']['output']>;
  caregiverCanAdministerOralMeds?: Maybe<Scalars['Boolean']['output']>;
  caregiverCompletedBookingsCount?: Maybe<Scalars['Int']['output']>;
  caregiverDeactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  caregiverDescription?: Maybe<Scalars['String']['output']>;
  caregiverHasAnimalCertificate?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasCats?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasJobsBoardEnabled?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasKidsUnder18?: Maybe<Scalars['Boolean']['output']>;
  caregiverHasPppLicense?: Maybe<Scalars['Boolean']['output']>;
  caregiverHeadline?: Maybe<Scalars['String']['output']>;
  caregiverMetrics?: Maybe<CurrentCaregiverMetrics>;
  caregiverNoob?: Maybe<Scalars['String']['output']>;
  caregiverOwnVehicle?: Maybe<Scalars['Boolean']['output']>;
  caregiverPremium?: Maybe<Scalars['String']['output']>;
  caregiverProvideCustomerReviews?: Maybe<Scalars['Boolean']['output']>;
  caregiverReviewsCount?: Maybe<Scalars['Int']['output']>;
  caregiverReviewsScore?: Maybe<Scalars['Float']['output']>;
  caregiverScore?: Maybe<Scalars['String']['output']>;
  caregiverSeoFixedSlug?: Maybe<Scalars['String']['output']>;
  caregiverStatus?: Maybe<CaregiverStatus>;
  caregiverStep?: Maybe<Scalars['String']['output']>;
  caregiverVolunteerAnimalGroups?: Maybe<Scalars['Boolean']['output']>;
  caregiverXpAcommodatingDogs?: Maybe<Scalars['Boolean']['output']>;
  caregiverXpAsDogWalker?: Maybe<Scalars['Boolean']['output']>;
  categorizedPhotos?: Maybe<CategorizedUserPhoto>;
  city?: Maybe<City>;
  cleanHeadline?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  couponRedemptions?: Maybe<Array<CouponRedemption>>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  email?: Maybe<Scalars['String']['output']>;
  featuredReview?: Maybe<Review>;
  hasPendingProfileInfo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incompleteDogs?: Maybe<Array<Dog>>;
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  intercomUserHashAndroid?: Maybe<Scalars['String']['output']>;
  intercomUserHashIos?: Maybe<Scalars['String']['output']>;
  isSuperCaregiver?: Maybe<Scalars['Boolean']['output']>;
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  minPrice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Notification>;
  outsideAvailability?: Maybe<CaregiverAvailability>;
  outsideServicePreferences?: Maybe<ServicePreferences>;
  phone?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<UserPhoto>>;
  price?: Maybe<Scalars['String']['output']>;
  promotionalAgreement?: Maybe<Scalars['Boolean']['output']>;
  property?: Maybe<Property>;
  publicAddress?: Maybe<Scalars['String']['output']>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  recentUnansweredBookings: Array<Booking>;
  referralCode?: Maybe<Scalars['String']['output']>;
  repeatCustomersCount?: Maybe<Scalars['Int']['output']>;
  repeatCustomersRatio?: Maybe<Scalars['Float']['output']>;
  responseTime?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<PaginatedReviews>;
  searchDistanceAwayKm?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Service>>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type CurrentCaregiverBookingEstimationArgs = {
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type CurrentCaregiverPriceArgs = {
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
};


export type CurrentCaregiverReviewsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrentCaregiverDac7Report = {
  __typename?: 'CurrentCaregiverDAC7Report';
  activitiesCompletedQ1?: Maybe<Scalars['Int']['output']>;
  activitiesCompletedQ2?: Maybe<Scalars['Int']['output']>;
  activitiesCompletedQ3?: Maybe<Scalars['Int']['output']>;
  activitiesCompletedQ4?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  addressCountryCode?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<BillingBankAccount>;
  caregiverPlatformCommissionsQ1?: Maybe<Scalars['Float']['output']>;
  caregiverPlatformCommissionsQ2?: Maybe<Scalars['Float']['output']>;
  caregiverPlatformCommissionsQ3?: Maybe<Scalars['Float']['output']>;
  caregiverPlatformCommissionsQ4?: Maybe<Scalars['Float']['output']>;
  considerationCredited?: Maybe<Scalars['Float']['output']>;
  considerationCreditedQ1?: Maybe<Scalars['Float']['output']>;
  considerationCreditedQ2?: Maybe<Scalars['Float']['output']>;
  considerationCreditedQ3?: Maybe<Scalars['Float']['output']>;
  considerationCreditedQ4?: Maybe<Scalars['Float']['output']>;
  countryCurrency?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  totalActivitiesCompleted?: Maybe<Scalars['Int']['output']>;
  totalCaregiverPlatformCommissions?: Maybe<Scalars['Float']['output']>;
};

export type CurrentCaregiverMetrics = {
  __typename?: 'CurrentCaregiverMetrics';
  answersRatio?: Maybe<Scalars['String']['output']>;
  bookingsRatio?: Maybe<Scalars['String']['output']>;
  calendarUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  isSuperCaregiver?: Maybe<Scalars['Boolean']['output']>;
  metricsMultiplier?: Maybe<Scalars['String']['output']>;
  metricsScore?: Maybe<Scalars['String']['output']>;
  paidBookingsCount?: Maybe<Scalars['String']['output']>;
  repeatCustomersCount?: Maybe<Scalars['String']['output']>;
  repeatCustomersRatio?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  reviewsCount?: Maybe<Scalars['String']['output']>;
  reviewsScore?: Maybe<Scalars['String']['output']>;
  totalCaregiverProfitCents?: Maybe<Scalars['String']['output']>;
};

export type CurrentOwner = CurrentUser & User & {
  __typename?: 'CurrentOwner';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  appMagicLink: Scalars['String']['output'];
  avatar?: Maybe<UserAvatar>;
  billingCards?: Maybe<Array<BillingCard>>;
  billingProfile?: Maybe<BillingProfile>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  bookmarks?: Maybe<Array<Caregiver>>;
  businessInfo?: Maybe<BusinessInfo>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  couponRedemptions?: Maybe<Array<CouponRedemption>>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  email?: Maybe<Scalars['String']['output']>;
  hasPendingProfileInfo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incompleteDogs?: Maybe<Array<Dog>>;
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  intercomUserHashAndroid?: Maybe<Scalars['String']['output']>;
  intercomUserHashIos?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Notification>;
  phone?: Maybe<Scalars['String']['output']>;
  promotionalAgreement?: Maybe<Scalars['Boolean']['output']>;
  property?: Maybe<Property>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type CurrentUser = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  appMagicLink: Scalars['String']['output'];
  avatar?: Maybe<UserAvatar>;
  billingCards?: Maybe<Array<BillingCard>>;
  billingProfile?: Maybe<BillingProfile>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  bookmarks?: Maybe<Array<Caregiver>>;
  businessInfo?: Maybe<BusinessInfo>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  couponRedemptions?: Maybe<Array<CouponRedemption>>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  email?: Maybe<Scalars['String']['output']>;
  hasPendingProfileInfo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incompleteDogs?: Maybe<Array<Dog>>;
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  intercomUserHashAndroid?: Maybe<Scalars['String']['output']>;
  intercomUserHashIos?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Notification>;
  phone?: Maybe<Scalars['String']['output']>;
  promotionalAgreement?: Maybe<Scalars['Boolean']['output']>;
  property?: Maybe<Property>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type DayPeriod = {
  __typename?: 'DayPeriod';
  afternoon: Scalars['Boolean']['output'];
  morning: Scalars['Boolean']['output'];
  night: Scalars['Boolean']['output'];
};

export type DayPeriodInput = {
  afternoon: Scalars['Boolean']['input'];
  morning: Scalars['Boolean']['input'];
  night: Scalars['Boolean']['input'];
};

/** Autogenerated input type of DeleteBillingCard */
export type DeleteBillingCardInput = {
  billingCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBillingCard */
export type DeleteBillingCardPayload = {
  __typename?: 'DeleteBillingCardPayload';
  billingCards?: Maybe<Array<BillingCard>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteBookmark */
export type DeleteBookmarkInput = {
  caregiverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBookmark */
export type DeleteBookmarkPayload = {
  __typename?: 'DeleteBookmarkPayload';
  caregiver?: Maybe<Caregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteCaregiverPhoto */
export type DeleteCaregiverPhotoInput = {
  caregiverPhotoId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteCaregiverPhoto */
export type DeleteCaregiverPhotoPayload = {
  __typename?: 'DeleteCaregiverPhotoPayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteDog */
export type DeleteDogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDog */
export type DeleteDogPayload = {
  __typename?: 'DeleteDogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteDogPhoto */
export type DeleteDogPhotoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogId: Scalars['ID']['input'];
  dogPhotoId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDogPhoto */
export type DeleteDogPhotoPayload = {
  __typename?: 'DeleteDogPhotoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dog?: Maybe<Dog>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteJob */
export type DeleteJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteJob */
export type DeleteJobPayload = {
  __typename?: 'DeleteJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteMobileDevice */
export type DeleteMobileDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteMobileDevice */
export type DeleteMobileDevicePayload = {
  __typename?: 'DeleteMobileDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteService */
export type DeleteServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteService */
export type DeleteServicePayload = {
  __typename?: 'DeleteServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteUser */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum DirectDebitMethod {
  /** Giropay payment */
  Giropay = 'GIROPAY',
  /** Sofort payment */
  Sofort = 'SOFORT'
}

export type Dog = {
  __typename?: 'Dog';
  activityLevel?: Maybe<DogActivityLevel>;
  avatar?: Maybe<DogAvatar>;
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  breed?: Maybe<Breed>;
  canDogBeReviewed?: Maybe<Scalars['Boolean']['output']>;
  chip?: Maybe<Scalars['String']['output']>;
  dailyFood?: Maybe<Scalars['String']['output']>;
  dailyFoodServings?: Maybe<DayPeriod>;
  dailyWalks?: Maybe<DayPeriod>;
  gender?: Maybe<Scalars['String']['output']>;
  healthInfo?: Maybe<Scalars['String']['output']>;
  homeAlone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indoorPrecautions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  petType?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<DogPhoto>>;
  playsCats?: Maybe<Scalars['Boolean']['output']>;
  playsCatsDesc?: Maybe<Scalars['String']['output']>;
  playsChildren?: Maybe<Scalars['Boolean']['output']>;
  playsChildrenDesc?: Maybe<Scalars['String']['output']>;
  playsDogs?: Maybe<Scalars['Boolean']['output']>;
  playsDogsDesc?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<Review>>;
  sameBreedDogs?: Maybe<Array<Dog>>;
  size?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  spayedNeutered?: Maybe<Scalars['Boolean']['output']>;
  stats?: Maybe<Array<DogStats>>;
  tAge?: Maybe<Scalars['String']['output']>;
  tAgeShort?: Maybe<Scalars['String']['output']>;
  tGender?: Maybe<Scalars['String']['output']>;
  tSize?: Maybe<Scalars['String']['output']>;
  user: User;
  walkingInstructions?: Maybe<Scalars['String']['output']>;
};


export type DogCanDogBeReviewedArgs = {
  id: Scalars['ID']['input'];
};

export enum DogActivityLevel {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type DogAvatar = {
  __typename?: 'DogAvatar';
  big?: Maybe<Scalars['String']['output']>;
  circle?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  slider: Scalars['String']['output'];
  sliderThumb?: Maybe<Scalars['String']['output']>;
};

/** Attributes for filtering by dog */
export type DogFilter = {
  puppy?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type DogPhoto = {
  __typename?: 'DogPhoto';
  id: Scalars['ID']['output'];
  miniThumb: Scalars['String']['output'];
  original: Scalars['String']['output'];
  slider: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Data required to create/update a dog photo */
export type DogPhotoInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  dogPhotoId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Data requiered to create a dog review */
export type DogReviewInput = {
  bookingId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  dogId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
};

export type DogStats = {
  __typename?: 'DogStats';
  bookingsCount: Scalars['Int']['output'];
  serviceType: ServiceType;
};

/** Autogenerated input type of EditDog */
export type EditDogInput = {
  activityLevel?: InputMaybe<DogActivityLevel>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthday: Scalars['ISO8601Date']['input'];
  breedId?: InputMaybe<Scalars['ID']['input']>;
  chip?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyFood?: InputMaybe<Scalars['String']['input']>;
  dailyFoodServings?: InputMaybe<DayPeriodInput>;
  dailyWalks?: InputMaybe<DayPeriodInput>;
  gender: Scalars['String']['input'];
  healthInfo?: InputMaybe<Scalars['String']['input']>;
  homeAlone?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  indoorPrecautions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  observations?: InputMaybe<Scalars['String']['input']>;
  petType?: InputMaybe<Scalars['String']['input']>;
  playsCats?: InputMaybe<Scalars['Boolean']['input']>;
  playsCatsDesc?: InputMaybe<Scalars['String']['input']>;
  playsChildren?: InputMaybe<Scalars['Boolean']['input']>;
  playsChildrenDesc?: InputMaybe<Scalars['String']['input']>;
  playsDogs?: InputMaybe<Scalars['Boolean']['input']>;
  playsDogsDesc?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  spayedNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  walkingInstructions?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditDog */
export type EditDogPayload = {
  __typename?: 'EditDogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dog?: Maybe<Dog>;
  errors: Array<Error>;
};

/** A user-readable error message */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** The location of the value that caused the error */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of ForgotPassword */
export type ForgotPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ForgotPassword */
export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum InboxType {
  /** Inbox as a dog sitter */
  Caregiver = 'CAREGIVER',
  /** Inbox as a dog owner */
  Owner = 'OWNER'
}

/** Autogenerated return type of InboxUpdated */
export type InboxUpdatedPayload = {
  __typename?: 'InboxUpdatedPayload';
  conversation?: Maybe<ConversationSummary>;
};

/** Autogenerated input type of InitBillingCardRegistration */
export type InitBillingCardRegistrationInput = {
  cardType?: InputMaybe<CardType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
};

/** Autogenerated return type of InitBillingCardRegistration */
export type InitBillingCardRegistrationPayload = {
  __typename?: 'InitBillingCardRegistrationPayload';
  cardRegistrationData?: Maybe<BillingCardRegistration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type Job = {
  city: City;
  countryServiceType: CountryServiceType;
  datesRequested: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogs: Array<Dog>;
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  playsCats: Scalars['Boolean']['output'];
  playsChildren: Scalars['Boolean']['output'];
  playsDogs: Scalars['Boolean']['output'];
  serviceDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  serviceType: ServiceType;
  startDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  user: User;
};

export type JobAuthor = Job & {
  __typename?: 'JobAuthor';
  applications?: Maybe<Array<Application>>;
  city: City;
  countryServiceType: CountryServiceType;
  datesRequested: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dogs: Array<Dog>;
  endDate: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  playsCats: Scalars['Boolean']['output'];
  playsChildren: Scalars['Boolean']['output'];
  playsDogs: Scalars['Boolean']['output'];
  serviceDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  serviceType: ServiceType;
  startDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  user: User;
};

export type JobPublic = Job & {
  __typename?: 'JobPublic';
  city: City;
  countryServiceType: CountryServiceType;
  datesRequested: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Int']['output']>;
  dogs: Array<Dog>;
  endDate: Scalars['ISO8601DateTime']['output'];
  estimatedEarnings?: Maybe<Money>;
  id: Scalars['ID']['output'];
  playsCats: Scalars['Boolean']['output'];
  playsChildren: Scalars['Boolean']['output'];
  playsDogs: Scalars['Boolean']['output'];
  serviceDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  serviceType: ServiceType;
  startDate: Scalars['ISO8601DateTime']['output'];
  status: Scalars['String']['output'];
  user: User;
};

/** Autogenerated input type of Login */
export type LoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CurrentUser>;
};

export type Message = {
  __typename?: 'Message';
  attachment?: Maybe<MessageImage>;
  booking?: Maybe<Booking>;
  content?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fromUser?: Maybe<User>;
  id?: Maybe<Scalars['ID']['output']>;
  toUser?: Maybe<User>;
  type: MessageType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of MessageAdded */
export type MessageAddedPayload = {
  __typename?: 'MessageAddedPayload';
  message?: Maybe<Message>;
};

export type MessageImage = {
  __typename?: 'MessageImage';
  big?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  small: Scalars['String']['output'];
};

export enum MessageType {
  /** Automattic message related to a booking */
  Booking = 'BOOKING',
  /** Message with a custom booking */
  DeprecatedCustomBooking = 'DEPRECATED_CUSTOM_BOOKING',
  /** Automattic message when a caregiver is not available */
  DeprecatedRejection = 'DEPRECATED_REJECTION',
  /** Message with an image */
  Image = 'IMAGE',
  /** Normal text message */
  Normal = 'NORMAL'
}

/** An object representing money, with an amount and currency. */
export type Money = {
  __typename?: 'Money';
  /** Numerical amount of the money. */
  amount: Scalars['Float']['output'];
  currency: Currency;
  /** Displayable string (i.e. "$1.00"). */
  toS: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBookmark?: Maybe<AddBookmarkPayload>;
  addCaregiverPhotos?: Maybe<AddCaregiverPhotosPayload>;
  addCaregiverReview?: Maybe<AddCaregiverReviewPayload>;
  addDog?: Maybe<AddDogPayload>;
  addDogPhoto?: Maybe<AddDogPhotosPayload>;
  addDogReviews?: Maybe<AddDogReviewsPayload>;
  addJob?: Maybe<AddJobPayload>;
  addMessage?: Maybe<AddMessagePayload>;
  addService?: Maybe<AddServicePayload>;
  applyCouponRedemption?: Maybe<ApplyCouponRedemptionPayload>;
  authenticateWithApple?: Maybe<AuthenticateWithApplePayload>;
  authenticateWithFacebook?: Maybe<AuthenticateWithFacebookPayload>;
  caregiverApplyForJob?: Maybe<CaregiverApplyForJobPayload>;
  caregiverApproveBooking?: Maybe<CaregiverApproveBookingPayload>;
  caregiverCancelBooking?: Maybe<CaregiverCancelBookingPayload>;
  caregiverConfirmBooking?: Maybe<CaregiverConfirmBookingPayload>;
  caregiverDismissJob?: Maybe<CaregiverDismissJobPayload>;
  caregiverPayoutBooking?: Maybe<CaregiverPayoutBookingPayload>;
  caregiverPayoutReward?: Maybe<CaregiverPayoutRewardPayload>;
  caregiverRejectBooking?: Maybe<CaregiverRejectBookingPayload>;
  changeJobsBoardEnabledState?: Maybe<ChangeJobsBoardEnabledStatePayload>;
  contactCaregiver?: Maybe<ContactCaregiverPayload>;
  createBillingBankAccount?: Maybe<CreateBillingBankAccountPayload>;
  createBillingCard?: Maybe<CreateBillingCardPayload>;
  createJobFromBooking?: Maybe<CreateJobFromBookingPayload>;
  deleteBillingCard?: Maybe<DeleteBillingCardPayload>;
  deleteBookmark?: Maybe<DeleteBookmarkPayload>;
  deleteCaregiverPhoto?: Maybe<DeleteCaregiverPhotoPayload>;
  deleteDog?: Maybe<DeleteDogPayload>;
  deleteDogPhoto?: Maybe<DeleteDogPhotoPayload>;
  deleteJob?: Maybe<DeleteJobPayload>;
  deleteMobileDevice?: Maybe<DeleteMobileDevicePayload>;
  deleteService?: Maybe<DeleteServicePayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  editDog?: Maybe<EditDogPayload>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  initBillingCardRegistration?: Maybe<InitBillingCardRegistrationPayload>;
  login?: Maybe<LoginPayload>;
  onboardOwner?: Maybe<OnboardOwnerPayload>;
  ownerAcceptJobApplication?: Maybe<OwnerAcceptJobApplicationPayload>;
  ownerCancelBooking?: Maybe<OwnerCancelBookingPayload>;
  ownerConfirmBooking?: Maybe<OwnerConfirmBookingPayload>;
  ownerDeclineJobApplication?: Maybe<OwnerDeclineJobApplicationPayload>;
  ownerPreapproveBooking?: Maybe<OwnerPreapproveBookingPayload>;
  ownerRejectBooking?: Maybe<OwnerRejectBookingPayload>;
  redeemCoupon?: Maybe<RedeemCouponPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  sendSmsWithAppMagicLink?: Maybe<SendSmsWithAppMagicLinkPayload>;
  signUp?: Maybe<SignUpPayload>;
  updateAvailability?: Maybe<UpdateAvailabilityPayload>;
  updateBooking?: Maybe<UpdateBookingPayload>;
  updateCaregiver?: Maybe<UpdateCaregiverPayload>;
  updateCaregiverDeactivate?: Maybe<UpdateCaregiverDeactivatePayload>;
  updateService?: Maybe<UpdateServicePayload>;
  updateServiceAvailable?: Maybe<UpdateServiceAvailablePayload>;
  updateServicePreferences?: Maybe<UpdateServicePreferencesPayload>;
  updateServiceUnavailable?: Maybe<UpdateServiceUnavailablePayload>;
  updateTaxpayerIdNumber?: Maybe<UpdateTaxpayerIdNumberPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserEmail?: Maybe<UpdateUserEmailPayload>;
  updateUserPassword?: Maybe<UpdateUserPasswordPayload>;
  updateUserPromotionalAgreement?: Maybe<UpdateUserPromotionalAgreementPayload>;
  uploadIdentityProof?: Maybe<UploadIdentityProofPayload>;
  upsertMobileDevice?: Maybe<UpsertMobileDevicePayload>;
};


export type MutationAddBookmarkArgs = {
  input: AddBookmarkInput;
};


export type MutationAddCaregiverPhotosArgs = {
  input: AddCaregiverPhotosInput;
};


export type MutationAddCaregiverReviewArgs = {
  input: AddCaregiverReviewInput;
};


export type MutationAddDogArgs = {
  input: AddDogInput;
};


export type MutationAddDogPhotoArgs = {
  input: AddDogPhotosInput;
};


export type MutationAddDogReviewsArgs = {
  input: AddDogReviewsInput;
};


export type MutationAddJobArgs = {
  input: AddJobInput;
};


export type MutationAddMessageArgs = {
  input: AddMessageInput;
};


export type MutationAddServiceArgs = {
  input: AddServiceInput;
};


export type MutationApplyCouponRedemptionArgs = {
  input: ApplyCouponRedemptionInput;
};


export type MutationAuthenticateWithAppleArgs = {
  input: AuthenticateWithAppleInput;
};


export type MutationAuthenticateWithFacebookArgs = {
  input: AuthenticateWithFacebookInput;
};


export type MutationCaregiverApplyForJobArgs = {
  input: CaregiverApplyForJobInput;
};


export type MutationCaregiverApproveBookingArgs = {
  input: CaregiverApproveBookingInput;
};


export type MutationCaregiverCancelBookingArgs = {
  input: CaregiverCancelBookingInput;
};


export type MutationCaregiverConfirmBookingArgs = {
  input: CaregiverConfirmBookingInput;
};


export type MutationCaregiverDismissJobArgs = {
  input: CaregiverDismissJobInput;
};


export type MutationCaregiverPayoutBookingArgs = {
  input: CaregiverPayoutBookingInput;
};


export type MutationCaregiverPayoutRewardArgs = {
  input: CaregiverPayoutRewardInput;
};


export type MutationCaregiverRejectBookingArgs = {
  input: CaregiverRejectBookingInput;
};


export type MutationChangeJobsBoardEnabledStateArgs = {
  input: ChangeJobsBoardEnabledStateInput;
};


export type MutationContactCaregiverArgs = {
  input: ContactCaregiverInput;
};


export type MutationCreateBillingBankAccountArgs = {
  input: CreateBillingBankAccountInput;
};


export type MutationCreateBillingCardArgs = {
  input: CreateBillingCardInput;
};


export type MutationCreateJobFromBookingArgs = {
  input: CreateJobFromBookingInput;
};


export type MutationDeleteBillingCardArgs = {
  input: DeleteBillingCardInput;
};


export type MutationDeleteBookmarkArgs = {
  input: DeleteBookmarkInput;
};


export type MutationDeleteCaregiverPhotoArgs = {
  input: DeleteCaregiverPhotoInput;
};


export type MutationDeleteDogArgs = {
  input: DeleteDogInput;
};


export type MutationDeleteDogPhotoArgs = {
  input: DeleteDogPhotoInput;
};


export type MutationDeleteJobArgs = {
  input: DeleteJobInput;
};


export type MutationDeleteMobileDeviceArgs = {
  input: DeleteMobileDeviceInput;
};


export type MutationDeleteServiceArgs = {
  input: DeleteServiceInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationEditDogArgs = {
  input: EditDogInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationInitBillingCardRegistrationArgs = {
  input: InitBillingCardRegistrationInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationOnboardOwnerArgs = {
  input: OnboardOwnerInput;
};


export type MutationOwnerAcceptJobApplicationArgs = {
  input: OwnerAcceptJobApplicationInput;
};


export type MutationOwnerCancelBookingArgs = {
  input: OwnerCancelBookingInput;
};


export type MutationOwnerConfirmBookingArgs = {
  input: OwnerConfirmBookingInput;
};


export type MutationOwnerDeclineJobApplicationArgs = {
  input: OwnerDeclineJobApplicationInput;
};


export type MutationOwnerPreapproveBookingArgs = {
  input: OwnerPreapproveBookingInput;
};


export type MutationOwnerRejectBookingArgs = {
  input: OwnerRejectBookingInput;
};


export type MutationRedeemCouponArgs = {
  input: RedeemCouponInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSendSmsWithAppMagicLinkArgs = {
  input: SendSmsWithAppMagicLinkInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationUpdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateCaregiverArgs = {
  input: UpdateCaregiverInput;
};


export type MutationUpdateCaregiverDeactivateArgs = {
  input: UpdateCaregiverDeactivateInput;
};


export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};


export type MutationUpdateServiceAvailableArgs = {
  input: UpdateServiceAvailableInput;
};


export type MutationUpdateServicePreferencesArgs = {
  input: UpdateServicePreferencesInput;
};


export type MutationUpdateServiceUnavailableArgs = {
  input: UpdateServiceUnavailableInput;
};


export type MutationUpdateTaxpayerIdNumberArgs = {
  input: UpdateTaxpayerIdNumberInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationUpdateUserPromotionalAgreementArgs = {
  input: UpdateUserPromotionalAgreementInput;
};


export type MutationUploadIdentityProofArgs = {
  input: UploadIdentityProofInput;
};


export type MutationUpsertMobileDeviceArgs = {
  input: UpsertMobileDeviceInput;
};

export type Notification = {
  __typename?: 'Notification';
  inbox?: Maybe<Scalars['Int']['output']>;
  unreadMessagesCountCaregiver?: Maybe<Scalars['Int']['output']>;
  unreadMessagesCountUser?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of OnboardOwner */
export type OnboardOwnerInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  city: CityInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OnboardOwner */
export type OnboardOwnerPayload = {
  __typename?: 'OnboardOwnerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<CurrentUser>;
};

export type Owner = User & {
  __typename?: 'Owner';
  avatar?: Maybe<UserAvatar>;
  billingProfile?: Maybe<BillingProfile>;
  businessInfo?: Maybe<BusinessInfo>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Autogenerated input type of OwnerAcceptJobApplication */
export type OwnerAcceptJobApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobMatchId: Scalars['ID']['input'];
};

/** Autogenerated return type of OwnerAcceptJobApplication */
export type OwnerAcceptJobApplicationPayload = {
  __typename?: 'OwnerAcceptJobApplicationPayload';
  applications?: Maybe<Array<Application>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors: Array<Error>;
};

/** Autogenerated input type of OwnerCancelBooking */
export type OwnerCancelBookingInput = {
  cancelationReason?: InputMaybe<Scalars['String']['input']>;
  cancelationReasonType: CancelationReason;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  meetAndGreetCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of OwnerCancelBooking */
export type OwnerCancelBookingPayload = {
  __typename?: 'OwnerCancelBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of OwnerConfirmBooking */
export type OwnerConfirmBookingInput = {
  billingCardId?: InputMaybe<Scalars['ID']['input']>;
  browserInfo?: InputMaybe<BrowserInfoInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  directDebitMethod?: InputMaybe<DirectDebitMethod>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OwnerConfirmBooking */
export type OwnerConfirmBookingPayload = {
  __typename?: 'OwnerConfirmBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<BillingPayment>;
};

/** Autogenerated input type of OwnerDeclineJobApplication */
export type OwnerDeclineJobApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobMatchId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OwnerDeclineJobApplication */
export type OwnerDeclineJobApplicationPayload = {
  __typename?: 'OwnerDeclineJobApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of OwnerPreapproveBooking */
export type OwnerPreapproveBookingInput = {
  billingCardId: Scalars['ID']['input'];
  browserInfo: BrowserInfoInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OwnerPreapproveBooking */
export type OwnerPreapproveBookingPayload = {
  __typename?: 'OwnerPreapproveBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<BillingPayment>;
};

/** Autogenerated input type of OwnerRejectBooking */
export type OwnerRejectBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonType: OwnerRejectionReason;
};

/** Autogenerated return type of OwnerRejectBooking */
export type OwnerRejectBookingPayload = {
  __typename?: 'OwnerRejectBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum OwnerRejectionReason {
  /** as_admin */
  AsAdmin = 'AS_ADMIN',
  /** found_another_option */
  FoundAnotherOption = 'FOUND_ANOTHER_OPTION',
  /** found_another_option_outside */
  FoundAnotherOptionOutside = 'FOUND_ANOTHER_OPTION_OUTSIDE',
  /** incorrect_parameters */
  IncorrectParameters = 'INCORRECT_PARAMETERS',
  /** inquiring */
  Inquiring = 'INQUIRING',
  /** no_response */
  NoResponse = 'NO_RESPONSE',
  /** other */
  Other = 'OTHER',
  /** sitter_not_suitable */
  SitterNotSuitable = 'SITTER_NOT_SUITABLE'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedBookings = PaginationInterface & {
  __typename?: 'PaginatedBookings';
  currentPage?: Maybe<Scalars['Int']['output']>;
  results: Array<Booking>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedConversation = PaginationInterface & {
  __typename?: 'PaginatedConversation';
  currentPage?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Conversation>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedMessages = PaginationInterface & {
  __typename?: 'PaginatedMessages';
  currentPage?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Message>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedReviews = PaginationInterface & {
  __typename?: 'PaginatedReviews';
  currentPage?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Review>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Something that can be paginated */
export type PaginationInterface = {
  currentPage?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum PaymentMethod {
  /** Credit/debit card payment */
  Card = 'CARD',
  /** Giropay payment */
  Giropay = 'GIROPAY',
  /** Sofort payment */
  Sofort = 'SOFORT'
}

export type PaymentMethodInfo = {
  __typename?: 'PaymentMethodInfo';
  alias?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type: PaymentMethod;
};

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  PaymentThreeDSecure = 'PAYMENT_THREE_D_SECURE',
  Pending = 'PENDING',
  PreauthorizationThreeDSecure = 'PREAUTHORIZATION_THREE_D_SECURE',
  Preauthorized = 'PREAUTHORIZED'
}

export enum PetType {
  /** Cat */
  Cat = 'cat',
  /** Dog */
  Dog = 'dog'
}

/** pick up / drop off for booking */
export type PickUpDropOffInput = {
  numberOfTrips: Scalars['Int']['input'];
  pickUpAtHome: Scalars['Boolean']['input'];
};

export type PotentialJob = {
  __typename?: 'PotentialJob';
  bookingId?: Maybe<Scalars['ID']['output']>;
  city: City;
  cityName?: Maybe<Scalars['String']['output']>;
  dogIds: Array<Scalars['ID']['output']>;
  dogs: Array<Dog>;
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  serviceDates?: Maybe<Array<Scalars['ISO8601DateTime']['output']>>;
  serviceType: ServiceType;
  serviceTypeId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type PriceForDogs = {
  __typename?: 'PriceForDogs';
  count: Scalars['Int']['output'];
  dogs: Array<Dog>;
  price: Money;
};

export enum PriceTypeEnum {
  /** additional_cat_price */
  AdditionalCatPrice = 'additional_cat_price',
  /** additional_dog_price */
  AdditionalDogPrice = 'additional_dog_price',
  /** holiday_cat_price */
  HolidayCatPrice = 'holiday_cat_price',
  /** holiday_price */
  HolidayPrice = 'holiday_price',
  /** puppy_price */
  PuppyPrice = 'puppy_price',
  /** standard_cat_price */
  StandardCatPrice = 'standard_cat_price',
  /** standard_dog_price */
  StandardDogPrice = 'standard_dog_price'
}

export type Property = {
  __typename?: 'Property';
  balcony?: Maybe<Scalars['Boolean']['output']>;
  garden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  outdoorSize?: Maybe<Scalars['Int']['output']>;
  terrace?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<PropertyType>;
};

/** Data requiered to updat a property */
export type PropertyInput = {
  balcony?: InputMaybe<Scalars['Boolean']['input']>;
  garden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  outdoorSize?: InputMaybe<Scalars['Int']['input']>;
  terrace?: InputMaybe<Scalars['Boolean']['input']>;
  type: PropertyType;
};

export enum PropertyType {
  /** Apartment */
  Apartment = 'APARTMENT',
  /** House */
  House = 'HOUSE',
  /** Farm house */
  Ranch = 'RANCH'
}

export type Query = {
  __typename?: 'Query';
  /** Availability for a specific sitter in a given month? */
  availability: Availability;
  /** Return the latest entries for the blog */
  blog?: Maybe<Blog>;
  /** A single booking belonging to the current user */
  booking: Booking;
  /** Booking estimated price */
  bookingPrice?: Maybe<BookingPriceEstimation>;
  breeds: Array<Breed>;
  /** A single caregiver with a public profile */
  caregiver?: Maybe<Caregiver>;
  /** A list of bookings belonging to the current caregiver */
  caregiverBookings: CaregiverBookings;
  /** Return tips to improve caregiver profiles */
  caregiverTips?: Maybe<CaregiverTips>;
  /** A single City */
  city?: Maybe<City>;
  /** A single conversation belonging to the current user */
  conversation: Conversation;
  /** Conversations for the user paginated and starting by most recent */
  conversations?: Maybe<PaginatedConversation>;
  countries: Array<Country>;
  /** A single Country */
  country?: Maybe<Country>;
  /** The current user */
  currentUser?: Maybe<CurrentUser>;
  /** Last year DAC7 report */
  dac7Report?: Maybe<CurrentCaregiverDac7Report>;
  /** A single Dog */
  dog: Dog;
  /** Conversations summary for the current user paginated and starting by most recent */
  inbox: ConversationSummaryConnection;
  /** A single job belonging to the current user */
  job: Job;
  /** Job listings board */
  jobsAvailable?: Maybe<Array<Job>>;
  /** A list of bookings belonging to the current user */
  ownerBookings: PaginatedBookings;
  /** Jobs created by current user */
  ownerJobs: Array<Job>;
  /** A single payment belonging to the current user */
  payment: BillingPayment;
  /** Potential jobs to be published from a booking request */
  potentialJobs: Array<PotentialJob>;
  /** Referral Info for Current User */
  referral?: Maybe<Referral>;
  /** Search caregivers */
  search?: Maybe<SearchResult>;
  /** Search caregivers */
  searchCity?: Maybe<SearchResult>;
  /** Search caregivers */
  searchCityServiceType?: Maybe<SearchResult>;
  /** Search caregivers */
  searchServiceType?: Maybe<SearchResult>;
  /** Application settings */
  settings?: Maybe<Settings>;
  /** A list of top 20 reviews for any given country */
  topReviewsByCountry: Array<Review>;
  /** A single user */
  user?: Maybe<User>;
};


export type QueryAvailabilityArgs = {
  caregiverId: Scalars['ID']['input'];
  serviceTypeId: Scalars['ID']['input'];
};


export type QueryBlogArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingPriceArgs = {
  bookingDates: BookingDatesInput;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
  pickUpDropOff?: InputMaybe<PickUpDropOffInput>;
  serviceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCaregiverArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCaregiverBookingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDac7ReportArgs = {
  year: Scalars['String']['input'];
};


export type QueryDogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<InboxType>;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOwnerBookingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  near?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchCityArgs = {
  city: Scalars['String']['input'];
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  near?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchCityServiceTypeArgs = {
  city: Scalars['String']['input'];
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  near?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchServiceTypeArgs = {
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dogs?: InputMaybe<Array<DogFilter>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  near?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTopReviewsByCountryArgs = {
  countryId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of RedeemCoupon */
export type RedeemCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
};

/** Autogenerated return type of RedeemCoupon */
export type RedeemCouponPayload = {
  __typename?: 'RedeemCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  couponRedemption?: Maybe<CouponRedemption>;
  errors: Array<Error>;
};

export type Referral = {
  __typename?: 'Referral';
  referralCode: Scalars['String']['output'];
  referredBookings: Array<BookingWithReward>;
};

/** Represents either a caregiver reward or a single user coupon reward */
export type ReferralRewardUnion = BillingCaregiverReward | Coupon;

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CurrentUser>;
};

export type Review = {
  __typename?: 'Review';
  author: User;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  reviewable: Reviewable;
  reviewableType: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

/** Objects which may be reviewed on */
export type Reviewable = Caregiver | Dog;

export type SearchResult = {
  __typename?: 'SearchResult';
  blogPosts?: Maybe<Array<BlogPost>>;
  caregivers: Array<Caregiver>;
  city?: Maybe<City>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  richSnippets?: Maybe<Scalars['String']['output']>;
  seoHtmlContent?: Maybe<Scalars['String']['output']>;
  seoHtmlIntro?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<ServiceType>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topCities?: Maybe<Array<City>>;
  totalEntries?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of SendSMSWithAppMagicLink */
export type SendSmsWithAppMagicLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  telephone: Scalars['String']['input'];
};

/** Autogenerated return type of SendSMSWithAppMagicLink */
export type SendSmsWithAppMagicLinkPayload = {
  __typename?: 'SendSMSWithAppMagicLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type Service = {
  __typename?: 'Service';
  acceptsDogs?: Maybe<AcceptsDogs>;
  additionalCatPrice?: Maybe<Scalars['Float']['output']>;
  additionalDogPrice?: Maybe<Scalars['Float']['output']>;
  catPrice?: Maybe<Scalars['Float']['output']>;
  countryServiceType?: Maybe<CountryServiceType>;
  currency?: Maybe<Scalars['String']['output']>;
  dogPrice?: Maybe<Scalars['Float']['output']>;
  extraTimePrice?: Maybe<Scalars['Float']['output']>;
  holidayCatPrice?: Maybe<Scalars['Float']['output']>;
  holidayPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  meetAndGreet?: Maybe<Scalars['Boolean']['output']>;
  meetAndGreetPrice?: Maybe<Scalars['Float']['output']>;
  pickUpDropOff?: Maybe<Scalars['Boolean']['output']>;
  pickUpDropOffDistance?: Maybe<Scalars['Int']['output']>;
  pickUpDropOffPrice?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  puppyPrice?: Maybe<Scalars['Float']['output']>;
  serviceType?: Maybe<ServiceType>;
  serviceTypeId?: Maybe<Scalars['ID']['output']>;
  unavailable?: Maybe<Scalars['Boolean']['output']>;
};

export type ServicePreferences = {
  __typename?: 'ServicePreferences';
  caregiverId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  friday?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  monday?: Maybe<Scalars['Boolean']['output']>;
  saturday?: Maybe<Scalars['Boolean']['output']>;
  spacesAvailable?: Maybe<Scalars['Int']['output']>;
  sunday?: Maybe<Scalars['Boolean']['output']>;
  thursday?: Maybe<Scalars['Boolean']['output']>;
  tuesday?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  wednesday?: Maybe<Scalars['Boolean']['output']>;
};

/** Data requiered to create/update service preferences */
export type ServicePreferencesInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  spacesAvailable: Scalars['Int']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type ServiceType = {
  __typename?: 'ServiceType';
  alwaysPickUpDropOff?: Maybe<Scalars['Boolean']['output']>;
  fullDayAvailability?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pricePer?: Maybe<Scalars['String']['output']>;
  routeServiceParam?: Maybe<Scalars['String']['output']>;
};

export type Settings = {
  __typename?: 'Settings';
  showSupportPhoneNumber: Scalars['Boolean']['output'];
  supportPhoneNumber: Scalars['String']['output'];
};

/** Autogenerated input type of SignUp */
export type SignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  promotionalAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaToken: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignUp */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CurrentUser>;
};

export type SpacesAvailable = {
  __typename?: 'SpacesAvailable';
  date: Scalars['ISO8601Date']['output'];
  spacesAvailable: Scalars['Int']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  bookingUpdated: BookingUpdatedPayload;
  inboxUpdated: InboxUpdatedPayload;
  messageAdded: MessageAddedPayload;
};


export type SubscriptionBookingUpdatedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionMessageAddedArgs = {
  conversationId: Scalars['ID']['input'];
};

export type Tip = {
  __typename?: 'Tip';
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateAvailability */
export type UpdateAvailabilityInput = {
  atHome?: InputMaybe<AvailabilityInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outside?: InputMaybe<AvailabilityInput>;
};

/** Autogenerated return type of UpdateAvailability */
export type UpdateAvailabilityPayload = {
  __typename?: 'UpdateAvailabilityPayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateBooking */
export type UpdateBookingInput = {
  bookingDates?: InputMaybe<BookingDatesInput>;
  bookingPrice?: InputMaybe<BookingPriceInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateBooking */
export type UpdateBookingPayload = {
  __typename?: 'UpdateBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateCaregiverDeactivate */
export type UpdateCaregiverDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCaregiverDeactivate */
export type UpdateCaregiverDeactivatePayload = {
  __typename?: 'UpdateCaregiverDeactivatePayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateCaregiver */
export type UpdateCaregiverInput = {
  caregiverCanAdministerInjectedMeds?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverCanAdministerOralMeds?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverDescription?: InputMaybe<Scalars['String']['input']>;
  caregiverHasAnimalCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverHasCats?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverHasKidsUnder18?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverHasPppLicense?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverHeadline?: InputMaybe<Scalars['String']['input']>;
  caregiverOwnVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverProvideCustomerReviews?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverVolunteerAnimalGroups?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverXpAcommodatingDogs?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverXpAsDogWalker?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<PropertyInput>;
};

/** Autogenerated return type of UpdateCaregiver */
export type UpdateCaregiverPayload = {
  __typename?: 'UpdateCaregiverPayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateServiceAvailable */
export type UpdateServiceAvailableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateServiceAvailable */
export type UpdateServiceAvailablePayload = {
  __typename?: 'UpdateServiceAvailablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  service?: Maybe<Service>;
};

/** Autogenerated input type of UpdateService */
export type UpdateServiceInput = {
  acceptsDogs?: InputMaybe<AcceptsDogsInput>;
  additionalCatPrice?: InputMaybe<Scalars['Int']['input']>;
  additionalDogPrice?: InputMaybe<Scalars['Int']['input']>;
  catPrice?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dogPrice?: InputMaybe<Scalars['Int']['input']>;
  extraTimePrice?: InputMaybe<Scalars['Int']['input']>;
  holidayCatPrice?: InputMaybe<Scalars['Int']['input']>;
  holidayPrice?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
  meetAndGreetPrice?: InputMaybe<Scalars['Int']['input']>;
  pickUpDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  pickUpDropOffDistance?: InputMaybe<Scalars['Int']['input']>;
  pickUpDropOffPrice?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  puppyPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateService */
export type UpdateServicePayload = {
  __typename?: 'UpdateServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  service?: Maybe<Service>;
};

/** Autogenerated input type of UpdateServicePreferences */
export type UpdateServicePreferencesInput = {
  atHome?: InputMaybe<ServicePreferencesInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outside?: InputMaybe<ServicePreferencesInput>;
};

/** Autogenerated return type of UpdateServicePreferences */
export type UpdateServicePreferencesPayload = {
  __typename?: 'UpdateServicePreferencesPayload';
  caregiver?: Maybe<CurrentCaregiver>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateServiceUnavailable */
export type UpdateServiceUnavailableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateServiceUnavailable */
export type UpdateServiceUnavailablePayload = {
  __typename?: 'UpdateServiceUnavailablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  service?: Maybe<Service>;
};

/** Autogenerated input type of UpdateTaxpayerIdNumber */
export type UpdateTaxpayerIdNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taxpayerIdNumber: Scalars['String']['input'];
  taxpayerIdNumberCountry: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTaxpayerIdNumber */
export type UpdateTaxpayerIdNumberPayload = {
  __typename?: 'UpdateTaxpayerIdNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<CurrentUser>;
};

/** Autogenerated input type of UpdateUserEmail */
export type UpdateUserEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserEmail */
export type UpdateUserEmailPayload = {
  __typename?: 'UpdateUserEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthday: Scalars['ISO8601Date']['input'];
  businessInfo?: InputMaybe<BusinessInfoInput>;
  city: CityInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateUserPassword */
export type UpdateUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserPassword */
export type UpdateUserPasswordPayload = {
  __typename?: 'UpdateUserPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<Error>;
};

/** Autogenerated return type of UpdateUser */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<CurrentUser>;
};

/** Autogenerated input type of UpdateUserPromotionalAgreement */
export type UpdateUserPromotionalAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  promotionalAgreement: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateUserPromotionalAgreement */
export type UpdateUserPromotionalAgreementPayload = {
  __typename?: 'UpdateUserPromotionalAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  currentUser?: Maybe<CurrentUser>;
  errors: Array<Error>;
};

/** Autogenerated input type of UploadIdentityProof */
export type UploadIdentityProofInput = {
  back?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  front: Scalars['String']['input'];
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  taxpayerIdNumber: Scalars['String']['input'];
  taxpayerIdNumberCountry: Scalars['String']['input'];
};

/** Autogenerated return type of UploadIdentityProof */
export type UploadIdentityProofPayload = {
  __typename?: 'UploadIdentityProofPayload';
  billingProfile?: Maybe<BillingProfile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpsertMobileDevice */
export type UpsertMobileDeviceInput = {
  appId: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  idfa?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertMobileDevice */
export type UpsertMobileDevicePayload = {
  __typename?: 'UpsertMobileDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type User = {
  avatar?: Maybe<UserAvatar>;
  billingProfile?: Maybe<BillingProfile>;
  businessInfo?: Maybe<BusinessInfo>;
  canCreateABillingProfile?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  dogs?: Maybe<Array<Dog>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Property>;
  publicFullName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  circle?: Maybe<Scalars['String']['output']>;
  profile: Scalars['String']['output'];
  thumb?: Maybe<Scalars['String']['output']>;
};

export type UserPhoto = {
  __typename?: 'UserPhoto';
  id: Scalars['ID']['output'];
  original: Scalars['String']['output'];
  slider: Scalars['String']['output'];
  sliderThumb: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type OwnerRejectBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  rejectionReasonType: OwnerRejectionReason;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type OwnerRejectBookingMutation = { __typename?: 'Mutation', ownerRejectBooking?: { __typename?: 'OwnerRejectBookingPayload', booking?: { __typename?: 'Booking', id?: string | null, conversationId?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CaregiverRejectBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  rejectionReasonType: CaregiverRejectionReason;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateCalendar?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CaregiverRejectBookingMutation = { __typename?: 'Mutation', caregiverRejectBooking?: { __typename?: 'CaregiverRejectBookingPayload', booking?: { __typename?: 'Booking', id?: string | null, conversationId?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetDataForBookingInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDataForBookingInvoiceQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id?: string | null, status: string, paymentConfirmedAt?: any | null, address?: string | null, total: { __typename?: 'Money', toS: string }, totalFee: { __typename?: 'Money', toS: string }, totalFeeVat: { __typename?: 'Money', toS: string }, baseFee: { __typename?: 'Money', toS: string }, country: { __typename?: 'Country', iso3661Alpha2?: string | null, vat: string }, user?: { __typename?: 'Caregiver', id: string } | { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | { __typename?: 'Owner', id: string } | null, caregiver?: { __typename?: 'Caregiver', publicAddress?: string | null } | null }, currentUser?: { __typename?: 'CurrentCaregiver', name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null } | { __typename?: 'CurrentOwner', name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null } | null };

export type GetCurrentUserForPaymentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForPaymentQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null, zip?: string | null, birthday?: any | null, canCreateABillingProfile?: boolean | null, billingCards?: Array<{ __typename?: 'BillingCard', id: string, alias: string, provider: string, expirationYear: string, expirationMonth: string }> | null, city?: { __typename?: 'City', id: string, slug?: string | null, name?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null } | null, country?: { __typename?: 'Country', id: string, name?: string | null, locale: string, currency: Currency, fullDomain: string, iso3661Alpha2?: string | null, paymentMethods: Array<PaymentMethod> } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null, zip?: string | null, birthday?: any | null, canCreateABillingProfile?: boolean | null, billingCards?: Array<{ __typename?: 'BillingCard', id: string, alias: string, provider: string, expirationYear: string, expirationMonth: string }> | null, city?: { __typename?: 'City', id: string, slug?: string | null, name?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null } | null, country?: { __typename?: 'Country', id: string, name?: string | null, locale: string, currency: Currency, fullDomain: string, iso3661Alpha2?: string | null, paymentMethods: Array<PaymentMethod> } | null } | null };

export type GetBookingForPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingForPaymentQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id?: string | null, fromDogley?: boolean | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, caregiverId: string, userId: string, conversationId?: string | null, numberOfTrips?: number | null, pickUpDropOff?: boolean | null, meetAndGreet?: boolean | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, gender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null } | null }> | null, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, meetAndGreetPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, latePickUpPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null, currency?: string | null, meetAndGreetPrice?: number | null, meetAndGreet?: boolean | null } | null } };

export type BookingPartsFragment = { __typename?: 'Booking', id?: string | null, fromDogley?: boolean | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, caregiverId: string, userId: string, conversationId?: string | null, numberOfTrips?: number | null, pickUpDropOff?: boolean | null, meetAndGreet?: boolean | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, gender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null } | null }> | null, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, meetAndGreetPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, latePickUpPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null, currency?: string | null, meetAndGreetPrice?: number | null, meetAndGreet?: boolean | null } | null };

export type UpdateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  birthday: Scalars['ISO8601Date']['input'];
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
  city: CityInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null, zip?: string | null, birthday?: any | null, currency?: Currency | null, city?: { __typename?: 'City', id: string, slug?: string | null, name?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, address1?: string | null, address2?: string | null, zip?: string | null, birthday?: any | null, currency?: Currency | null, city?: { __typename?: 'City', id: string, slug?: string | null, name?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, country?: { __typename?: 'Country', id: string, name?: string | null } | null } | null } | null } | null };

export type InitBillingCardRegistrationMutationVariables = Exact<{
  currency: Currency;
  cardType?: InputMaybe<CardType>;
}>;


export type InitBillingCardRegistrationMutation = { __typename?: 'Mutation', initBillingCardRegistration?: { __typename?: 'InitBillingCardRegistrationPayload', cardRegistrationData?: { __typename?: 'BillingCardRegistration', accessKey: string, cardRegistrationUrl: string, id: string, preregistrationData: string } | null } | null };

export type CreateBillingCardMutationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CreateBillingCardMutationMutation = { __typename?: 'Mutation', createBillingCard?: { __typename?: 'CreateBillingCardPayload', billingCard?: { __typename?: 'BillingCard', id: string, alias: string, expirationMonth: string, expirationYear: string, provider: string, currency?: Currency | null } | null } | null };

export type DeleteBillingCardMutationVariables = Exact<{
  billingCardId: Scalars['ID']['input'];
}>;


export type DeleteBillingCardMutation = { __typename?: 'Mutation', deleteBillingCard?: { __typename?: 'DeleteBillingCardPayload', billingCards?: Array<{ __typename?: 'BillingCard', id: string, alias: string, provider: string, expirationYear: string, expirationMonth: string }> | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type OwnerConfirmBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  billingCardId?: InputMaybe<Scalars['ID']['input']>;
  browserInfo?: InputMaybe<BrowserInfoInput>;
  directDebitMethod?: InputMaybe<DirectDebitMethod>;
}>;


export type OwnerConfirmBookingMutation = { __typename?: 'Mutation', ownerConfirmBooking?: { __typename?: 'OwnerConfirmBookingPayload', booking?: { __typename?: 'Booking', id?: string | null, conversationId?: string | null } | null, payment?: { __typename?: 'BillingPayment', id: string, status: PaymentStatus, redirectUrl?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type OwnerPreapproveBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  billingCardId: Scalars['ID']['input'];
  browserInfo: BrowserInfoInput;
}>;


export type OwnerPreapproveBookingMutation = { __typename?: 'Mutation', ownerPreapproveBooking?: { __typename?: 'OwnerPreapproveBookingPayload', booking?: { __typename?: 'Booking', id?: string | null, fromDogley?: boolean | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, caregiverId: string, userId: string, conversationId?: string | null, numberOfTrips?: number | null, pickUpDropOff?: boolean | null, meetAndGreet?: boolean | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, gender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null } | null }> | null, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, meetAndGreetPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, latePickUpPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null, currency?: string | null, meetAndGreetPrice?: number | null, meetAndGreet?: boolean | null } | null } | null, payment?: { __typename?: 'BillingPayment', id: string, status: PaymentStatus, redirectUrl?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BookingPartsForPaymentFragment = { __typename?: 'Booking', id?: string | null, fromDogley?: boolean | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, caregiverId: string, userId: string, conversationId?: string | null, numberOfTrips?: number | null, pickUpDropOff?: boolean | null, meetAndGreet?: boolean | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, gender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null } | null }> | null, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, meetAndGreetPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, latePickUpPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null, meetAndGreetPrice?: number | null, currency?: string | null, meetAndGreet?: boolean | null } | null };

export type UpdateBookingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking?: { __typename?: 'UpdateBookingPayload', booking?: { __typename?: 'Booking', id?: string | null, fromDogley?: boolean | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, caregiverId: string, userId: string, conversationId?: string | null, numberOfTrips?: number | null, pickUpDropOff?: boolean | null, meetAndGreet?: boolean | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, gender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null } | null }> | null, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, meetAndGreetPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, latePickUpPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null, meetAndGreetPrice?: number | null, currency?: string | null, meetAndGreet?: boolean | null } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetDataForBookingReceiptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDataForBookingReceiptQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id?: string | null, status: string, startDate?: any | null, endDate?: any | null, serviceDates?: Array<any> | null, serviceQuantity?: number | null, paymentConfirmedAt?: any | null, freeCancellationLimit?: any | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, fixedDiscount?: { __typename?: 'Money', amount: number, currency: Currency } | null } } | null, unitPrice: { __typename?: 'Money', toS: string }, total: { __typename?: 'Money', toS: string }, totalFee: { __typename?: 'Money', toS: string }, service?: { __typename?: 'Service', price?: number | null, currency?: string | null } | null, countryServiceType: { __typename?: 'CountryServiceType', name?: string | null, serviceType?: { __typename?: 'ServiceType', pricePer?: string | null } | null }, bookingDogs?: Array<{ __typename?: 'BookingDog', dog?: { __typename?: 'Dog', name?: string | null } | null }> | null, user?: { __typename?: 'Caregiver', id: string, name?: string | null, publicFullName?: string | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, publicFullName?: string | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, publicFullName?: string | null } | { __typename?: 'Owner', id: string, name?: string | null, publicFullName?: string | null } | null, caregiver?: { __typename?: 'Caregiver', name?: string | null, publicAddress?: string | null, publicFullName?: string | null } | null, payment?: { __typename?: 'BillingPayment', paymentMethod?: { __typename?: 'PaymentMethodInfo', type: PaymentMethod, alias?: string | null, provider?: string | null } | null } | null }, currentUser?: { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | null };

export type GetCurrenUserWithMagicLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenUserWithMagicLinkQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', appMagicLink: string, id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | { __typename?: 'CurrentOwner', appMagicLink: string, id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | null };

export type SmsMagicLinkMutationVariables = Exact<{
  input: SendSmsWithAppMagicLinkInput;
}>;


export type SmsMagicLinkMutation = { __typename?: 'Mutation', sendSmsWithAppMagicLink?: { __typename?: 'SendSMSWithAppMagicLinkPayload', errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetCountryServiceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryServiceTypesQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id: string, iso3661Alpha2?: string | null, countryServiceTypes?: Array<{ __typename?: 'CountryServiceType', id: string, seoName?: string | null, description?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null }> | null } | null };

export type DogProfilePartsFragment = { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null };

export type AddDogMutationVariables = Exact<{
  input: AddDogInput;
}>;


export type AddDogMutation = { __typename?: 'Mutation', addDog?: { __typename?: 'AddDogPayload', dog?: { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EditDogMutationVariables = Exact<{
  input: EditDogInput;
}>;


export type EditDogMutation = { __typename?: 'Mutation', editDog?: { __typename?: 'EditDogPayload', dog?: { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type DeleteDogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDogMutation = { __typename?: 'Mutation', deleteDog?: { __typename?: 'DeleteDogPayload', errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetInboxQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<InboxType>;
}>;


export type GetInboxQuery = { __typename?: 'Query', inbox: { __typename?: 'ConversationSummaryConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, nodes?: Array<{ __typename?: 'ConversationSummary', id?: string | null, unreadMessages: number, partner: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null }, lastMessage: { __typename?: 'Message', id?: string | null, createdAt: any, content?: string | null, type: MessageType, booking?: { __typename?: 'Booking', id?: string | null, user?: { __typename?: 'Caregiver', id: string } | { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | { __typename?: 'Owner', id: string } | null, caregiver?: { __typename?: 'Caregiver', id: string } | null } | null }, bookingHistory: { __typename?: 'BookingHistory', requests: number, upcoming: number, past: number } } | null> | null }, potentialJobs: Array<{ __typename?: 'PotentialJob', bookingId?: string | null, startDate?: any | null, endDate?: any | null, serviceDates?: Array<any> | null, serviceTypeId: string, cityName?: string | null, dogs: Array<{ __typename?: 'Dog', name?: string | null }> }> };

export type InboxUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type InboxUpdatedSubscription = { __typename?: 'Subscription', inboxUpdated: { __typename?: 'InboxUpdatedPayload', conversation?: { __typename?: 'ConversationSummary', id?: string | null, unreadMessages: number, partner: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null }, lastMessage: { __typename?: 'Message', id?: string | null, createdAt: any, content?: string | null, type: MessageType, booking?: { __typename?: 'Booking', id?: string | null, user?: { __typename?: 'Caregiver', id: string } | { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | { __typename?: 'Owner', id: string } | null, caregiver?: { __typename?: 'Caregiver', id: string } | null } | null }, bookingHistory: { __typename?: 'BookingHistory', requests: number, upcoming: number, past: number } } | null } };

export type ConversationSummaryPartsFragment = { __typename?: 'ConversationSummary', id?: string | null, unreadMessages: number, partner: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', name?: string | null }> | null }, lastMessage: { __typename?: 'Message', id?: string | null, createdAt: any, content?: string | null, type: MessageType, booking?: { __typename?: 'Booking', id?: string | null, user?: { __typename?: 'Caregiver', id: string } | { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | { __typename?: 'Owner', id: string } | null, caregiver?: { __typename?: 'Caregiver', id: string } | null } | null }, bookingHistory: { __typename?: 'BookingHistory', requests: number, upcoming: number, past: number } };

export type GetOwnerJobsForConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnerJobsForConversationsQuery = { __typename?: 'Query', ownerJobs: Array<{ __typename?: 'JobAuthor', id: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, applications?: Array<{ __typename?: 'Application', id: string, estimatedPaymentTotal?: { __typename?: 'Money', toS: string } | null, caregiver: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } }> | null, city: { __typename?: 'City', name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null }> } | { __typename?: 'JobPublic', id: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, city: { __typename?: 'City', name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null }> }> };

export type OwnerDeclineJobApplicationMutationVariables = Exact<{
  input: OwnerDeclineJobApplicationInput;
}>;


export type OwnerDeclineJobApplicationMutation = { __typename?: 'Mutation', ownerDeclineJobApplication?: { __typename?: 'OwnerDeclineJobApplicationPayload', errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type OwnerAcceptJobApplicationMutationVariables = Exact<{
  input: OwnerAcceptJobApplicationInput;
}>;


export type OwnerAcceptJobApplicationMutation = { __typename?: 'Mutation', ownerAcceptJobApplication?: { __typename?: 'OwnerAcceptJobApplicationPayload', conversation?: { __typename?: 'Conversation', id?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

type CurrentUserParts_CurrentCaregiver_Fragment = { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null };

type CurrentUserParts_CurrentOwner_Fragment = { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null };

export type CurrentUserPartsFragment = CurrentUserParts_CurrentCaregiver_Fragment | CurrentUserParts_CurrentOwner_Fragment;

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, intercomUserHash?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, intercomUserHash?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | null };

export type GetCurrentUserIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserIdQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string } | { __typename?: 'CurrentOwner', id: string } | null };

export type GetCurrentCaregiverDac7ReportQueryVariables = Exact<{
  year: Scalars['String']['input'];
}>;


export type GetCurrentCaregiverDac7ReportQuery = { __typename?: 'Query', dac7Report?: { __typename?: 'CurrentCaregiverDAC7Report', id: string, fullName?: string | null, address?: string | null, addressCountryCode?: string | null, dateOfBirth?: any | null, taxIdentificationNumber?: string | null, totalActivitiesCompleted?: number | null, activitiesCompletedQ1?: number | null, activitiesCompletedQ2?: number | null, activitiesCompletedQ3?: number | null, activitiesCompletedQ4?: number | null, considerationCredited?: number | null, considerationCreditedQ1?: number | null, considerationCreditedQ2?: number | null, considerationCreditedQ3?: number | null, considerationCreditedQ4?: number | null, totalCaregiverPlatformCommissions?: number | null, caregiverPlatformCommissionsQ1?: number | null, caregiverPlatformCommissionsQ2?: number | null, caregiverPlatformCommissionsQ3?: number | null, caregiverPlatformCommissionsQ4?: number | null, countryCurrency?: string | null, bankAccount?: { __typename?: 'BillingBankAccount', id: string, iban?: string | null, accountNumber?: string | null, sortCode?: string | null } | null } | null };

export type GetDogProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDogProfileQuery = { __typename?: 'Query', dog: { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, user: { __typename?: 'Caregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null, placeId?: string | null, activeCaregiversCount?: number | null }> | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null, placeId?: string | null, activeCaregiversCount?: number | null }> | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null, placeId?: string | null, activeCaregiversCount?: number | null }> | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null, placeId?: string | null, activeCaregiversCount?: number | null }> | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null }, stats?: Array<{ __typename?: 'DogStats', bookingsCount: number, serviceType: { __typename?: 'ServiceType', alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, id: string, name?: string | null, pricePer?: string | null } }> | null, sameBreedDogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, tAgeShort?: string | null, gender?: string | null, slug?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, reviews?: Array<{ __typename?: 'Review', id: string, content?: string | null, createdAt: any, score: number, author: { __typename?: 'Caregiver', slug?: string | null, id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null, thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null, thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null, thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null, thumb?: string | null } | null } }> | null } };

export type UpdateTaxpayerIdNumberMutationVariables = Exact<{
  input: UpdateTaxpayerIdNumberInput;
}>;


export type UpdateTaxpayerIdNumberMutation = { __typename?: 'Mutation', updateTaxpayerIdNumber?: { __typename?: 'UpdateTaxpayerIdNumberPayload', user?: { __typename?: 'CurrentCaregiver', id: string, billingProfile?: { __typename?: 'BillingProfile', taxpayerIdNumber?: string | null, taxpayerIdNumberCountry?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, billingProfile?: { __typename?: 'BillingProfile', taxpayerIdNumber?: string | null, taxpayerIdNumberCountry?: string | null } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetCurrentUserForLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForLayoutQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, intercomUserHash?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string, taxpayerIdNumber?: string | null, taxpayerIdNumberCountry?: string | null } | null, notifications?: { __typename?: 'Notification', unreadMessagesCountUser?: number | null, unreadMessagesCountCaregiver?: number | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, intercomUserHash?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string, taxpayerIdNumber?: string | null, taxpayerIdNumberCountry?: string | null } | null, notifications?: { __typename?: 'Notification', unreadMessagesCountUser?: number | null, unreadMessagesCountCaregiver?: number | null } | null } | null };

export type GetCurrentUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserNotificationsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', notifications?: { __typename?: 'Notification', unreadMessagesCountUser?: number | null, unreadMessagesCountCaregiver?: number | null } | null } | { __typename?: 'CurrentOwner', notifications?: { __typename?: 'Notification', unreadMessagesCountUser?: number | null, unreadMessagesCountCaregiver?: number | null } | null } | null };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment: { __typename?: 'BillingPayment', id: string, status: PaymentStatus, booking: { __typename?: 'Booking', id?: string | null, conversationId?: string | null } } };

export type UpdateCaregiverDeactivateMutationVariables = Exact<{
  input: UpdateCaregiverDeactivateInput;
}>;


export type UpdateCaregiverDeactivateMutation = { __typename?: 'Mutation', updateCaregiverDeactivate?: { __typename?: 'UpdateCaregiverDeactivatePayload', caregiver?: { __typename?: 'CurrentCaregiver', id: string, caregiverStatus?: CaregiverStatus | null, caregiverDeactivatedAt?: any | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetCurrentUserReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserReferralQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', caregiverStatus?: CaregiverStatus | null, type: string } | { __typename?: 'CurrentOwner', type: string } | null, referral?: { __typename?: 'Referral', referralCode: string, referredBookings: Array<{ __typename?: 'BookingWithReward', booking: { __typename?: 'Booking', id?: string | null, status: string, endDate?: any | null, createdAt: any, user?: { __typename?: 'Caregiver', publicFullName?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'CurrentCaregiver', publicFullName?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'CurrentOwner', publicFullName?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'Owner', publicFullName?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | null }, reward?: { __typename: 'BillingCaregiverReward', id: string, bankRewardWire?: { __typename?: 'BillingBankRewardWire', status?: BillingBankRewardWireStatus | null } | null, amount?: { __typename?: 'Money', amount: number, currency: Currency } | null } | { __typename: 'Coupon', id: string, percentageDiscount?: number | null, fixedDiscount?: { __typename?: 'Money', amount: number } | null } | null }> } | null };

export type CaregiverPayoutRewardMutationVariables = Exact<{
  input: CaregiverPayoutRewardInput;
}>;


export type CaregiverPayoutRewardMutation = { __typename?: 'Mutation', caregiverPayoutReward?: { __typename?: 'CaregiverPayoutRewardPayload', errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GetCountryAndCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryAndCurrentUserQuery = { __typename?: 'Query', country?: { __typename?: 'Country', id: string, iso3661Alpha2?: string | null, countryServiceTypes?: Array<{ __typename?: 'CountryServiceType', id: string, seoName?: string | null, description?: string | null, name?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null }> | null } | null, currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | null };

export type SearchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dogs?: InputMaybe<Array<DogFilter> | DogFilter>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchResult', totalPages?: number | null, totalEntries?: number | null, currentPage?: number | null, serviceType?: { __typename?: 'ServiceType', id: string, name?: string | null, pricePer?: string | null, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, routeServiceParam?: string | null } | null, city?: { __typename?: 'City', id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, slug?: string | null, activeCaregiversCount?: number | null }> | null } | null, topCities?: Array<{ __typename?: 'City', id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, slug?: string | null, activeCaregiversCount?: number | null }> | null, caregivers: Array<{ __typename?: 'Caregiver', id: string, isSuperCaregiver?: boolean | null, caregiverHeadline?: string | null, name?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, currency?: Currency | null, repeatCustomersCount?: number | null, latitude?: string | null, longitude?: string | null, searchDistanceAwayKm?: string | null, publicAddress?: string | null, availableHolidays?: string | null, calendarUpToDate?: boolean | null, slug?: string | null, price?: string | null, minPrice?: string | null, caregiverCalendarUpdatedAt?: any | null, services?: Array<{ __typename?: 'Service', serviceTypeId?: string | null }> | null, featuredReview?: { __typename?: 'Review', id: string, content?: string | null, author: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, city?: { __typename?: 'City', id: string, slug?: string | null, name?: string | null } | null, bookingEstimation?: { __typename?: 'Money', currency: Currency, amount: number, toS: string } | null, availablePromotions?: Array<{ __typename?: 'CaregiverPromotion', id: string, tLabel: string }> | null, reviews?: { __typename?: 'PaginatedReviews', results?: Array<{ __typename?: 'Review', content?: string | null, author: { __typename?: 'Caregiver', avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } }> | null } | null }> } | null };

export type SearchCityQueryVariables = Exact<{
  city: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dogs?: InputMaybe<Array<DogFilter> | DogFilter>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchCityQuery = { __typename?: 'Query', searchCity?: { __typename?: 'SearchResult', metaTitle?: string | null, metaDescription?: string | null, richSnippets?: string | null, subtitle?: string | null, seoTitle?: string | null, seoHtmlContent?: string | null, seoHtmlIntro?: string | null, title?: string | null, totalEntries?: number | null, totalPages?: number | null, currentPage?: number | null, blogPosts?: Array<{ __typename?: 'BlogPost', link: string, excerpt?: string | null, title: string, featuredMedia?: string | null }> | null, serviceType?: { __typename?: 'ServiceType', id: string, name?: string | null, pricePer?: string | null, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, routeServiceParam?: string | null } | null, city?: { __typename?: 'City', minServicePriceCents?: string | null, maxServicePriceCents?: string | null, avgCaregiverReviewsScore?: string | null, id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, zip?: string | null, slug?: string | null, seoLandingNoindexTag: boolean, sumCaregiverReviewsCount?: number | null, nearbyCities?: Array<{ __typename?: 'City', id: string, name?: string | null, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, activeCaregiversCount?: number | null }> | null, stats?: { __typename?: 'CityStats', activeSitters: number, boardingActiveSitters: number, walkingActiveSitters: number, daycareActiveSitters: number, completedBookings: number, boardingCompletedBookings: number, walkingCompletedBookings: number, daycareCompletedBookings: number, sitterReviews: number, boardingSitterReviews: number, walkingSitterReviews: number, daycareSitterReviews: number, boardingRequestDayInAdvance: number, walkingRequestDayInAdvance: number, daycareRequestDayInAdvance: number, boardingAvgPricePerNight: number, walkingAvgPricePerWalk: number, daycareAvgPricePerDay: number, minSitterRate: number, boardingMinSitterRate: number, walkingMinSitterRate: number, daycareMinSitterRate: number, boardingRatePlusSecondDog: number, walkingRatePlusSecondDog: number, daycareRatePlusSecondDog: number, boardingAvgNights: number, walkingAvgWalks: number, daycareAvgDays: number, boardingAvgBookingPrice: number, walkingAvgBookingPrice: number, daycareAvgBookingPrice: number } | null, country?: { __typename?: 'Country', locale: string, currency: Currency, iso3661Alpha2?: string | null } | null } | null, caregivers: Array<{ __typename?: 'Caregiver', id: string, isSuperCaregiver?: boolean | null, caregiverHeadline?: string | null, name?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, currency?: Currency | null, repeatCustomersCount?: number | null, latitude?: string | null, longitude?: string | null, searchDistanceAwayKm?: string | null, publicAddress?: string | null, availableHolidays?: string | null, calendarUpToDate?: boolean | null, slug?: string | null, price?: string | null, minPrice?: string | null, services?: Array<{ __typename?: 'Service', serviceTypeId?: string | null }> | null, featuredReview?: { __typename?: 'Review', id: string, content?: string | null, author: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, city?: { __typename?: 'City', id: string, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null } | null, bookingEstimation?: { __typename?: 'Money', currency: Currency, amount: number, toS: string } | null, availablePromotions?: Array<{ __typename?: 'CaregiverPromotion', id: string, tLabel: string }> | null }> } | null, country?: { __typename?: 'Country', id: string, iso3661Alpha2?: string | null, countryServiceTypes?: Array<{ __typename?: 'CountryServiceType', id: string, name?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null }> | null } | null, currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | null };

export type SearchCityServiceTypeQueryVariables = Exact<{
  service: Scalars['String']['input'];
  city: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dogs?: InputMaybe<Array<DogFilter> | DogFilter>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchCityServiceTypeQuery = { __typename?: 'Query', searchCityServiceType?: { __typename?: 'SearchResult', metaTitle?: string | null, metaDescription?: string | null, richSnippets?: string | null, title?: string | null, subtitle?: string | null, seoTitle?: string | null, seoHtmlContent?: string | null, seoHtmlIntro?: string | null, totalEntries?: number | null, totalPages?: number | null, currentPage?: number | null, blogPosts?: Array<{ __typename?: 'BlogPost', link: string, excerpt?: string | null, title: string, featuredMedia?: string | null }> | null, serviceType?: { __typename?: 'ServiceType', id: string, name?: string | null, pricePer?: string | null, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, routeServiceParam?: string | null } | null, city?: { __typename?: 'City', minServicePriceCents?: string | null, maxServicePriceCents?: string | null, avgCaregiverReviewsScore?: string | null, id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, zip?: string | null, slug?: string | null, seoLandingNoindexTag: boolean, sumCaregiverReviewsCount?: number | null, nearbyCities?: Array<{ __typename?: 'City', id: string, name?: string | null, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, activeCaregiversCount?: number | null }> | null, stats?: { __typename?: 'CityStats', activeSitters: number, boardingActiveSitters: number, walkingActiveSitters: number, daycareActiveSitters: number, completedBookings: number, boardingCompletedBookings: number, walkingCompletedBookings: number, daycareCompletedBookings: number, sitterReviews: number, boardingSitterReviews: number, walkingSitterReviews: number, daycareSitterReviews: number, boardingRequestDayInAdvance: number, walkingRequestDayInAdvance: number, daycareRequestDayInAdvance: number, boardingAvgPricePerNight: number, walkingAvgPricePerWalk: number, daycareAvgPricePerDay: number, minSitterRate: number, boardingMinSitterRate: number, walkingMinSitterRate: number, daycareMinSitterRate: number, boardingRatePlusSecondDog: number, walkingRatePlusSecondDog: number, daycareRatePlusSecondDog: number, boardingAvgNights: number, walkingAvgWalks: number, daycareAvgDays: number, boardingAvgBookingPrice: number, walkingAvgBookingPrice: number, daycareAvgBookingPrice: number } | null, country?: { __typename?: 'Country', locale: string, currency: Currency, iso3661Alpha2?: string | null } | null } | null, caregivers: Array<{ __typename?: 'Caregiver', id: string, isSuperCaregiver?: boolean | null, caregiverHeadline?: string | null, name?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, currency?: Currency | null, repeatCustomersCount?: number | null, latitude?: string | null, longitude?: string | null, searchDistanceAwayKm?: string | null, publicAddress?: string | null, availableHolidays?: string | null, calendarUpToDate?: boolean | null, slug?: string | null, price?: string | null, featuredReview?: { __typename?: 'Review', id: string, content?: string | null, author: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, city?: { __typename?: 'City', id: string, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null } | null, bookingEstimation?: { __typename?: 'Money', currency: Currency, amount: number, toS: string } | null, availablePromotions?: Array<{ __typename?: 'CaregiverPromotion', id: string, tLabel: string }> | null }> } | null, country?: { __typename?: 'Country', id: string, iso3661Alpha2?: string | null, countryServiceTypes?: Array<{ __typename?: 'CountryServiceType', id: string, name?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null }> | null } | null, currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | null };

export type SearchServiceTypeQueryVariables = Exact<{
  service: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
  neLat?: InputMaybe<Scalars['String']['input']>;
  neLng?: InputMaybe<Scalars['String']['input']>;
  swLat?: InputMaybe<Scalars['String']['input']>;
  swLng?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  serviceTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceDates?: InputMaybe<Scalars['DateArray']['input']>;
  includePrice?: InputMaybe<Scalars['Boolean']['input']>;
  dogIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dogs?: InputMaybe<Array<DogFilter> | DogFilter>;
  withDogs?: InputMaybe<Scalars['Boolean']['input']>;
  withOutsideArea?: InputMaybe<Scalars['Boolean']['input']>;
  withoutKids?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchServiceTypeQuery = { __typename?: 'Query', searchServiceType?: { __typename?: 'SearchResult', totalEntries?: number | null, totalPages?: number | null, currentPage?: number | null, city?: { __typename?: 'City', id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', id: string, name?: string | null, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, activeCaregiversCount?: number | null }> | null } | null, serviceType?: { __typename?: 'ServiceType', id: string, name?: string | null, pricePer?: string | null, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, routeServiceParam?: string | null } | null, topCities?: Array<{ __typename?: 'City', id: string, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null, slug?: string | null, activeCaregiversCount?: number | null }> | null, caregivers: Array<{ __typename?: 'Caregiver', id: string, isSuperCaregiver?: boolean | null, caregiverHeadline?: string | null, name?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, currency?: Currency | null, repeatCustomersCount?: number | null, latitude?: string | null, longitude?: string | null, searchDistanceAwayKm?: string | null, publicAddress?: string | null, availableHolidays?: string | null, calendarUpToDate?: boolean | null, slug?: string | null, price?: string | null, featuredReview?: { __typename?: 'Review', id: string, content?: string | null, author: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, city?: { __typename?: 'City', id: string, slug?: string | null, placeId?: string | null, latitude?: number | null, longitude?: number | null, name?: string | null } | null, bookingEstimation?: { __typename?: 'Money', currency: Currency, amount: number, toS: string } | null, availablePromotions?: Array<{ __typename?: 'CaregiverPromotion', id: string, tLabel: string }> | null }> } | null, country?: { __typename?: 'Country', id: string, iso3661Alpha2?: string | null, countryServiceTypes?: Array<{ __typename?: 'CountryServiceType', id: string, name?: string | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null }> | null } | null, currentUser?: { __typename?: 'CurrentCaregiver', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, surname?: string | null, email?: string | null, type: string, canCreateABillingProfile?: boolean | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, billingProfile?: { __typename?: 'BillingProfile', id?: string | null, identityStatus: string } | null } | null };

export type GetCurrentUserForContactQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForContactQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, phone?: string | null, type: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null } | { __typename?: 'CurrentOwner', id: string, phone?: string | null, type: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, birthday?: any | null, tAge?: string | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null } | null };

export type GetCaregiverForContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCaregiverForContactQuery = { __typename?: 'Query', caregiver?: { __typename?: 'Caregiver', id: string, name?: string | null, type: string, latitude?: string | null, longitude?: string | null, slug?: string | null, services?: Array<{ __typename?: 'Service', id: string, currency?: string | null, pickUpDropOff?: boolean | null, pickUpDropOffDistance?: number | null, pickUpDropOffPrice?: number | null, meetAndGreet?: boolean | null, meetAndGreetPrice?: number | null, countryServiceType?: { __typename?: 'CountryServiceType', id: string, name?: string | null, description?: string | null, meetAndGreet?: boolean | null, serviceType?: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, pricePer?: string | null } | null } | null }> | null } | null };

export type ContactCaregiverMutationVariables = Exact<{
  caregiverId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  serviceTypeId: Scalars['ID']['input'];
  dogIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pickUpDropOff?: InputMaybe<PickUpDropOffInput>;
  bookingDatesInput: BookingDatesInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactCaregiverMutation = { __typename?: 'Mutation', contactCaregiver?: { __typename?: 'ContactCaregiverPayload', potentialJob?: { __typename?: 'PotentialJob', bookingId?: string | null, startDate?: any | null, endDate?: any | null, serviceDates?: Array<any> | null, serviceTypeId: string, cityName?: string | null, dogs: Array<{ __typename?: 'Dog', name?: string | null }> } | null, booking?: { __typename?: 'Booking', id?: string | null, serviceQuantity?: number | null, caregiver?: { __typename?: 'Caregiver', id: string, name?: string | null, city?: { __typename?: 'City', name?: string | null } | null } | null, service?: { __typename?: 'Service', id: string, price?: number | null } | null, total: { __typename?: 'Money', currency: Currency }, serviceType: { __typename?: 'ServiceType', name?: string | null } } | null, conversation?: { __typename?: 'Conversation', id?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobFromBookingInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJobFromBooking?: { __typename?: 'CreateJobFromBookingPayload', errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type BookingPriceCalculationQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  dogIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  bookingDates: BookingDatesInput;
  pickUpDropOff?: InputMaybe<PickUpDropOffInput>;
  meetAndGreet?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BookingPriceCalculationQuery = { __typename?: 'Query', bookingPrice?: { __typename?: 'BookingPriceEstimation', pricePer: string, duration: number, fee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, holidayServicePrice?: { __typename?: 'PriceForDogs', count: number, price: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, standardServicePrice?: { __typename?: 'PriceForDogs', count: number, price: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, puppyServicePrice?: { __typename?: 'PriceForDogs', count: number, price: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, additionalDogServicePrice?: { __typename?: 'PriceForDogs', count: number, price: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, pickUpDropOffPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, meetAndGreetPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, latePickUpPrice?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null } | null };

export type GetCaregiverQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCaregiverQuery = { __typename?: 'Query', caregiver?: { __typename?: 'Caregiver', id: string, isSuperCaregiver?: boolean | null, name?: string | null, cleanHeadline?: string | null, caregiverStatus?: CaregiverStatus | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, repeatCustomersCount?: number | null, publicAddress?: string | null, caregiverDescription?: string | null, latitude?: string | null, longitude?: string | null, caregiverXpAcommodatingDogs?: boolean | null, caregiverXpAsDogWalker?: boolean | null, caregiverCalendarUpdatedAt?: any | null, caregiverHasAnimalCertificate?: boolean | null, caregiverHasKidsUnder18?: boolean | null, caregiverHasPppLicense?: boolean | null, caregiverProvideCustomerReviews?: boolean | null, caregiverOwnVehicle?: boolean | null, caregiverCanAdministerOralMeds?: boolean | null, caregiverCanAdministerInjectedMeds?: boolean | null, caregiverVolunteerAnimalGroups?: boolean | null, slug?: string | null, bookmarked?: string | null, lastSeenAt?: any | null, responseTime?: number | null, bookingsRatio?: string | null, answerRatio?: string | null, availablePromotions?: Array<{ __typename?: 'CaregiverPromotion', id: string, tLabel: string }> | null, property?: { __typename?: 'Property', id?: string | null, type?: PropertyType | null, garden?: boolean | null, balcony?: boolean | null, terrace?: boolean | null, outdoorSize?: number | null } | null, services?: Array<{ __typename?: 'Service', id: string, serviceTypeId?: string | null, currency?: string | null, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOff?: boolean | null, pickUpDropOffPrice?: number | null, pickUpDropOffDistance?: number | null, meetAndGreet?: boolean | null, meetAndGreetPrice?: number | null, acceptsDogs?: { __typename?: 'AcceptsDogs', puppy: boolean, small: boolean, medium: boolean, large: boolean, giant: boolean } | null }> | null, avatar?: { __typename?: 'UserAvatar', profile: string } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null } | null }> | null, reviews?: { __typename?: 'PaginatedReviews', currentPage?: number | null, totalPages?: number | null, results?: Array<{ __typename?: 'Review', id: string, score: number, content?: string | null, createdAt: any, author: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } | { __typename?: 'Owner', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', thumb?: string | null } | null } }> | null } | null, country?: { __typename?: 'Country', locale: string } | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null, nearbyCities?: Array<{ __typename?: 'City', name?: string | null, slug?: string | null, placeId?: string | null, activeCaregiversCount?: number | null }> | null } | null, photos?: Array<{ __typename?: 'UserPhoto', id: string, slider: string, thumb: string, title?: string | null }> | null } | null };

export type GetTopReviewsByCountryQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
}>;


export type GetTopReviewsByCountryQuery = { __typename?: 'Query', topReviewsByCountry: Array<{ __typename?: 'Review', score: number, content?: string | null, createdAt: any, author: { __typename?: 'Caregiver', id: string, name?: string | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null } | { __typename?: 'Owner', id: string, name?: string | null }, reviewable: { __typename?: 'Caregiver', id: string, name?: string | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | { __typename?: 'Dog' } }> };

export type GetOwnerBookingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOwnerBookingsQuery = { __typename?: 'Query', ownerBookings: { __typename?: 'PaginatedBookings', currentPage?: number | null, totalPages?: number | null, results: Array<{ __typename?: 'Booking', id?: string | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, conversationId?: string | null, numberOfTrips?: number | null, refundAmount?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, transferAmount?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, dogReviews?: Array<{ __typename?: 'Review', id: string, content?: string | null, score: number, reviewable: { __typename?: 'Caregiver' } | { __typename?: 'Dog', id: string, name?: string | null } }> | null, caregiverReview?: { __typename?: 'Review', id: string, content?: string | null, score: number, reviewable: { __typename?: 'Caregiver', id: string, name?: string | null } | { __typename?: 'Dog' } } | null, bankWire?: { __typename?: 'BillingBankWire', id: string, createdAt: any, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, caregiver?: { __typename?: 'Caregiver', id: string, name?: string | null, latitude?: string | null, longitude?: string | null, cleanHeadline?: string | null, caregiverHeadline?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, repeatCustomersCount?: number | null, publicAddress?: string | null, slug?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | null, user?: { __typename?: 'Caregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'Owner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | null, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null } | null }> | null, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }>, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, currency?: string | null, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null } | null, countryServiceType: { __typename?: 'CountryServiceType', id: string, name?: string | null } }> } };

export type OwnerBookingFieldsFragment = { __typename?: 'Booking', id?: string | null, canBeTransferredToBankAccount?: boolean | null, availableEvents?: Array<BookingEvent> | null, serviceDates?: Array<any> | null, startDate?: any | null, endDate?: any | null, serviceQuantity?: number | null, createdAt: any, updatedAt: any, status: string, dogIds: Array<string>, canCaregiverBeReviewed?: boolean | null, conversationId?: string | null, numberOfTrips?: number | null, refundAmount?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, transferAmount?: { __typename?: 'Money', amount: number, currency: Currency, toS: string } | null, dogReviews?: Array<{ __typename?: 'Review', id: string, content?: string | null, score: number, reviewable: { __typename?: 'Caregiver' } | { __typename?: 'Dog', id: string, name?: string | null } }> | null, caregiverReview?: { __typename?: 'Review', id: string, content?: string | null, score: number, reviewable: { __typename?: 'Caregiver', id: string, name?: string | null } | { __typename?: 'Dog' } } | null, bankWire?: { __typename?: 'BillingBankWire', id: string, createdAt: any, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string } } | null, total: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, totalFee: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceTotal: { __typename?: 'Money', amount: number, currency: Currency, toS: string }, serviceType: { __typename?: 'ServiceType', id: string, alwaysPickUpDropOff?: boolean | null, fullDayAvailability?: boolean | null, name?: string | null, pricePer?: string | null }, caregiver?: { __typename?: 'Caregiver', id: string, name?: string | null, latitude?: string | null, longitude?: string | null, cleanHeadline?: string | null, caregiverHeadline?: string | null, caregiverReviewsCount?: number | null, caregiverReviewsScore?: number | null, caregiverCompletedBookingsCount?: number | null, repeatCustomersCount?: number | null, publicAddress?: string | null, slug?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } | null, user?: { __typename?: 'Caregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'CurrentCaregiver', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'CurrentOwner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | { __typename?: 'Owner', id: string, name?: string | null, city?: { __typename?: 'City', id: string, name?: string | null, slug?: string | null } | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }> | null } | null, bookingDogs?: Array<{ __typename?: 'BookingDog', id: string, dogId: string, bookingId: string, priceType?: PriceTypeEnum | null, canDogBeReviewed?: boolean | null, price?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, dog?: { __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null } | null }> | null, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, size?: string | null, tAge?: string | null, birthday?: any | null, slug?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null }>, pickUpDropOffPrice?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, costAdjustment?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, couponRedemption?: { __typename?: 'CouponRedemption', id: string, coupon: { __typename?: 'Coupon', id: string, code: string, percentageDiscount?: number | null, currency: Currency, startsAt?: any | null, expiresAt?: any | null, fixedDiscount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null, minimumAmount?: { __typename?: 'Money', toS: string, amount: number, currency: Currency } | null } } | null, service?: { __typename?: 'Service', id: string, currency?: string | null, price?: number | null, holidayPrice?: number | null, puppyPrice?: number | null, additionalDogPrice?: number | null, pickUpDropOffPrice?: number | null } | null, countryServiceType: { __typename?: 'CountryServiceType', id: string, name?: string | null } };

export type GetDogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDogQuery = { __typename?: 'Query', dog: { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null } };

export type GetCurrentUserForEditDogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForEditDogQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null }> | null } | { __typename?: 'CurrentOwner', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, photos?: Array<{ __typename?: 'DogPhoto', id: string, miniThumb: string, original: string, slider: string, thumb: string, title?: string | null }> | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null }> | null } | null };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job: { __typename?: 'JobAuthor', id: string, status: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, playsDogs: boolean, playsCats: boolean, playsChildren: boolean, description?: string | null, applications?: Array<{ __typename?: 'Application', id: string, estimatedPaymentTotal?: { __typename?: 'Money', toS: string } | null, caregiver: { __typename?: 'Caregiver', id: string, lastSeenAt?: any | null, latitude?: string | null, longitude?: string | null, name?: string | null, caregiverReviewsScore?: number | null, caregiverReviewsCount?: number | null, caregiverCompletedBookingsCount?: number | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } }> | null, user: { __typename?: 'Caregiver', name?: string | null } | { __typename?: 'CurrentCaregiver', name?: string | null } | { __typename?: 'CurrentOwner', name?: string | null } | { __typename?: 'Owner', name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, tAgeShort?: string | null, tSize?: string | null, tGender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, slider: string } | null, breed?: { __typename?: 'Breed', tName?: string | null } | null }>, city: { __typename?: 'City', id: string, latitude?: number | null, longitude?: number | null, name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, pricePer?: string | null }, countryServiceType: { __typename?: 'CountryServiceType', name?: string | null } } | { __typename?: 'JobPublic', id: string, status: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, playsDogs: boolean, playsCats: boolean, playsChildren: boolean, description?: string | null, user: { __typename?: 'Caregiver', name?: string | null } | { __typename?: 'CurrentCaregiver', name?: string | null } | { __typename?: 'CurrentOwner', name?: string | null } | { __typename?: 'Owner', name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, tAgeShort?: string | null, tSize?: string | null, tGender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, slider: string } | null, breed?: { __typename?: 'Breed', tName?: string | null } | null }>, city: { __typename?: 'City', id: string, latitude?: number | null, longitude?: number | null, name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, pricePer?: string | null }, countryServiceType: { __typename?: 'CountryServiceType', name?: string | null } } };

export type GetOwnerJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOwnerJobsQuery = { __typename?: 'Query', ownerJobs: Array<{ __typename?: 'JobAuthor', id: string, status: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, playsDogs: boolean, playsCats: boolean, playsChildren: boolean, description?: string | null, applications?: Array<{ __typename?: 'Application', id: string, estimatedPaymentTotal?: { __typename?: 'Money', toS: string } | null, caregiver: { __typename?: 'Caregiver', id: string, lastSeenAt?: any | null, latitude?: string | null, longitude?: string | null, name?: string | null, caregiverReviewsScore?: number | null, caregiverReviewsCount?: number | null, caregiverCompletedBookingsCount?: number | null, avatar?: { __typename?: 'UserAvatar', circle?: string | null } | null } }> | null, user: { __typename?: 'Caregiver', name?: string | null } | { __typename?: 'CurrentCaregiver', name?: string | null } | { __typename?: 'CurrentOwner', name?: string | null } | { __typename?: 'Owner', name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, tAgeShort?: string | null, tSize?: string | null, tGender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, slider: string } | null, breed?: { __typename?: 'Breed', tName?: string | null } | null }>, city: { __typename?: 'City', id: string, latitude?: number | null, longitude?: number | null, name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, pricePer?: string | null }, countryServiceType: { __typename?: 'CountryServiceType', name?: string | null } } | { __typename?: 'JobPublic', id: string, status: string, startDate: any, endDate: any, serviceDates?: Array<any> | null, datesRequested: number, playsDogs: boolean, playsCats: boolean, playsChildren: boolean, description?: string | null, user: { __typename?: 'Caregiver', name?: string | null } | { __typename?: 'CurrentCaregiver', name?: string | null } | { __typename?: 'CurrentOwner', name?: string | null } | { __typename?: 'Owner', name?: string | null }, dogs: Array<{ __typename?: 'Dog', id: string, name?: string | null, tAgeShort?: string | null, tSize?: string | null, tGender?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, slider: string } | null, breed?: { __typename?: 'Breed', tName?: string | null } | null }>, city: { __typename?: 'City', id: string, latitude?: number | null, longitude?: number | null, name?: string | null }, serviceType: { __typename?: 'ServiceType', id: string, pricePer?: string | null }, countryServiceType: { __typename?: 'CountryServiceType', name?: string | null } }> };

export type DeleteJobMutationVariables = Exact<{
  input: DeleteJobInput;
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob?: { __typename?: 'DeleteJobPayload', errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type GetCurrentUserForRegistrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserForRegistrationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'CurrentCaregiver', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null }> | null } | { __typename?: 'CurrentOwner', id: string, dogs?: Array<{ __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null }> | null } | null };

export type AddDogForRegistrationMutationVariables = Exact<{
  input: AddDogInput;
}>;


export type AddDogForRegistrationMutation = { __typename?: 'Mutation', addDog?: { __typename?: 'AddDogPayload', dog?: { __typename?: 'Dog', id: string, name?: string | null, gender?: string | null, size?: string | null, slug?: string | null, birthday?: any | null, spayedNeutered?: boolean | null, chip?: string | null, playsDogs?: boolean | null, playsDogsDesc?: string | null, playsCats?: boolean | null, playsCatsDesc?: string | null, playsChildren?: boolean | null, playsChildrenDesc?: string | null, observations?: string | null, tGender?: string | null, tAge?: string | null, tAgeShort?: string | null, tSize?: string | null, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, avatar?: { __typename?: 'DogAvatar', circle?: string | null, big?: string | null } | null, breed?: { __typename?: 'Breed', id: string, name?: string | null, tName?: string | null } | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EditDogForRegistrationMutationVariables = Exact<{
  input: EditDogInput;
}>;


export type EditDogForRegistrationMutation = { __typename?: 'Mutation', editDog?: { __typename?: 'EditDogPayload', dog?: { __typename?: 'Dog', id: string, activityLevel?: DogActivityLevel | null, dailyFood?: string | null, walkingInstructions?: string | null, homeAlone?: string | null, healthInfo?: string | null, indoorPrecautions?: string | null, dailyFoodServings?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null, dailyWalks?: { __typename?: 'DayPeriod', morning: boolean, afternoon: boolean, night: boolean } | null } | null } | null };

export const BookingPartsFragmentDoc = gql`
    fragment BookingParts on Booking {
  id
  fromDogley
  canBeTransferredToBankAccount
  availableEvents
  serviceDates
  startDate
  endDate
  serviceQuantity
  createdAt
  updatedAt
  serviceDates
  status
  dogIds
  canCaregiverBeReviewed
  caregiverId
  userId
  conversationId
  numberOfTrips
  total {
    amount
    currency
    toS
  }
  totalFee {
    amount
    currency
    toS
  }
  serviceTotal {
    amount
    currency
    toS
  }
  serviceType {
    id
    alwaysPickUpDropOff
    fullDayAvailability
    name
    pricePer
  }
  bookingDogs {
    id
    dogId
    bookingId
    price {
      toS
      amount
      currency
    }
    priceType
    canDogBeReviewed
    dog {
      id
      name
      size
      tAge
      gender
      avatar {
        circle
      }
    }
  }
  pickUpDropOff
  pickUpDropOffPrice {
    toS
    amount
    currency
  }
  meetAndGreet
  meetAndGreetPrice {
    toS
    amount
    currency
  }
  latePickUpPrice {
    amount
    currency
    toS
  }
  costAdjustment {
    toS
    amount
    currency
  }
  couponRedemption {
    id
    coupon {
      id
      code
      fixedDiscount {
        toS
        amount
        currency
      }
      percentageDiscount
      minimumAmount {
        toS
        amount
        currency
      }
      currency
      startsAt
      expiresAt
    }
  }
  service {
    id
    price
    holidayPrice
    puppyPrice
    additionalDogPrice
    pickUpDropOffPrice
    currency
    meetAndGreetPrice
    meetAndGreet
  }
}
    `;
export const BookingPartsForPaymentFragmentDoc = gql`
    fragment BookingPartsForPayment on Booking {
  id
  fromDogley
  canBeTransferredToBankAccount
  availableEvents
  serviceDates
  startDate
  endDate
  serviceQuantity
  createdAt
  updatedAt
  serviceDates
  status
  dogIds
  canCaregiverBeReviewed
  caregiverId
  userId
  conversationId
  numberOfTrips
  total {
    amount
    currency
    toS
  }
  totalFee {
    amount
    currency
    toS
  }
  serviceTotal {
    amount
    currency
    toS
  }
  serviceType {
    id
    alwaysPickUpDropOff
    fullDayAvailability
    name
    pricePer
  }
  bookingDogs {
    id
    dogId
    bookingId
    price {
      toS
      amount
      currency
    }
    priceType
    canDogBeReviewed
    dog {
      id
      name
      size
      tAge
      gender
      avatar {
        circle
      }
    }
  }
  pickUpDropOff
  pickUpDropOffPrice {
    toS
    amount
    currency
  }
  meetAndGreet
  meetAndGreetPrice {
    toS
    amount
    currency
  }
  latePickUpPrice {
    toS
    amount
    currency
  }
  costAdjustment {
    toS
    amount
    currency
  }
  couponRedemption {
    id
    coupon {
      id
      code
      fixedDiscount {
        toS
        amount
        currency
      }
      percentageDiscount
      minimumAmount {
        toS
        amount
        currency
      }
      currency
      startsAt
      expiresAt
    }
  }
  service {
    id
    price
    holidayPrice
    puppyPrice
    additionalDogPrice
    pickUpDropOffPrice
    meetAndGreetPrice
    currency
    meetAndGreet
  }
}
    `;
export const DogProfilePartsFragmentDoc = gql`
    fragment DogProfileParts on Dog {
  id
  name
  gender
  size
  slug
  birthday
  spayedNeutered
  chip
  playsDogs
  playsDogsDesc
  playsCats
  playsCatsDesc
  playsChildren
  playsChildrenDesc
  observations
  avatar {
    circle
    big
  }
  tGender
  tAge
  tAgeShort
  tSize
  breed {
    id
    name
    tName
  }
  photos {
    id
    miniThumb
    original
    slider
    thumb
    title
  }
  activityLevel
  dailyFood
  dailyFoodServings {
    morning
    afternoon
    night
  }
  dailyWalks {
    morning
    afternoon
    night
  }
  walkingInstructions
  homeAlone
  healthInfo
  indoorPrecautions
}
    `;
export const ConversationSummaryPartsFragmentDoc = gql`
    fragment ConversationSummaryParts on ConversationSummary {
  id
  partner {
    id
    name
    avatar {
      circle
    }
    dogs {
      name
    }
  }
  lastMessage {
    id
    createdAt
    content
    type
    booking {
      id
      user {
        id
      }
      caregiver {
        id
      }
    }
  }
  unreadMessages
  bookingHistory {
    requests
    upcoming
    past
  }
}
    `;
export const CurrentUserPartsFragmentDoc = gql`
    fragment currentUserParts on CurrentUser {
  id
  name
  surname
  email
  type
  avatar {
    circle
  }
  canCreateABillingProfile
  billingProfile {
    id
    identityStatus
  }
}
    `;
export const OwnerBookingFieldsFragmentDoc = gql`
    fragment OwnerBookingFields on Booking {
  id
  canBeTransferredToBankAccount
  availableEvents
  serviceDates
  startDate
  endDate
  serviceQuantity
  createdAt
  updatedAt
  serviceDates
  status
  dogIds
  canCaregiverBeReviewed
  conversationId
  numberOfTrips
  refundAmount {
    amount
    currency
    toS
  }
  transferAmount {
    amount
    currency
    toS
  }
  dogReviews {
    id
    content
    score
    reviewable {
      ... on Dog {
        id
        name
      }
    }
  }
  caregiverReview {
    id
    content
    score
    reviewable {
      ... on Caregiver {
        id
        name
      }
    }
  }
  bankWire {
    id
    createdAt
    total {
      amount
      currency
      toS
    }
  }
  total {
    amount
    currency
    toS
  }
  totalFee {
    amount
    currency
    toS
  }
  serviceTotal {
    amount
    currency
    toS
  }
  serviceType {
    id
    alwaysPickUpDropOff
    fullDayAvailability
    name
    pricePer
  }
  caregiver {
    id
    name
    latitude
    longitude
    cleanHeadline
    caregiverHeadline
    caregiverReviewsCount
    caregiverReviewsScore
    caregiverCompletedBookingsCount
    repeatCustomersCount
    publicAddress
    city {
      id
      name
      slug
    }
    avatar {
      circle
    }
    slug
  }
  user {
    id
    name
    city {
      id
      name
      slug
    }
    avatar {
      circle
    }
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      avatar {
        circle
        big
      }
      size
      tAge
      birthday
      slug
    }
  }
  bookingDogs {
    id
    dogId
    bookingId
    price {
      toS
      amount
      currency
    }
    priceType
    canDogBeReviewed
    dog {
      id
      name
      avatar {
        circle
        big
      }
      size
      tAge
      birthday
      slug
    }
  }
  dogs {
    id
    name
    avatar {
      circle
      big
    }
    size
    tAge
    birthday
    slug
  }
  pickUpDropOffPrice {
    toS
    amount
    currency
  }
  costAdjustment {
    toS
    amount
    currency
  }
  couponRedemption {
    id
    coupon {
      id
      code
      fixedDiscount {
        toS
        amount
        currency
      }
      percentageDiscount
      minimumAmount {
        toS
        amount
        currency
      }
      currency
      startsAt
      expiresAt
    }
  }
  service {
    id
    currency
    price
    holidayPrice
    puppyPrice
    additionalDogPrice
    pickUpDropOffPrice
  }
  countryServiceType {
    id
    name
  }
}
    `;
export const OwnerRejectBookingDocument = gql`
    mutation ownerRejectBooking($id: ID!, $rejectionReasonType: OwnerRejectionReason!, $rejectionReason: String) {
  ownerRejectBooking(
    input: {id: $id, rejectionReasonType: $rejectionReasonType, rejectionReason: $rejectionReason}
  ) {
    booking {
      id
      conversationId
    }
    errors {
      message
      path
    }
  }
}
    `;
export type OwnerRejectBookingMutationFn = Apollo.MutationFunction<OwnerRejectBookingMutation, OwnerRejectBookingMutationVariables>;

/**
 * __useOwnerRejectBookingMutation__
 *
 * To run a mutation, you first call `useOwnerRejectBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerRejectBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerRejectBookingMutation, { data, loading, error }] = useOwnerRejectBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rejectionReasonType: // value for 'rejectionReasonType'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useOwnerRejectBookingMutation(baseOptions?: Apollo.MutationHookOptions<OwnerRejectBookingMutation, OwnerRejectBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerRejectBookingMutation, OwnerRejectBookingMutationVariables>(OwnerRejectBookingDocument, options);
      }
export type OwnerRejectBookingMutationHookResult = ReturnType<typeof useOwnerRejectBookingMutation>;
export type OwnerRejectBookingMutationResult = Apollo.MutationResult<OwnerRejectBookingMutation>;
export type OwnerRejectBookingMutationOptions = Apollo.BaseMutationOptions<OwnerRejectBookingMutation, OwnerRejectBookingMutationVariables>;
export const CaregiverRejectBookingDocument = gql`
    mutation caregiverRejectBooking($id: ID!, $rejectionReasonType: CaregiverRejectionReason!, $rejectionReason: String, $shouldUpdateCalendar: Boolean) {
  caregiverRejectBooking(
    input: {id: $id, rejectionReasonType: $rejectionReasonType, rejectionReason: $rejectionReason, shouldUpdateCalendar: $shouldUpdateCalendar}
  ) {
    booking {
      id
      conversationId
    }
    errors {
      message
      path
    }
  }
}
    `;
export type CaregiverRejectBookingMutationFn = Apollo.MutationFunction<CaregiverRejectBookingMutation, CaregiverRejectBookingMutationVariables>;

/**
 * __useCaregiverRejectBookingMutation__
 *
 * To run a mutation, you first call `useCaregiverRejectBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaregiverRejectBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [caregiverRejectBookingMutation, { data, loading, error }] = useCaregiverRejectBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rejectionReasonType: // value for 'rejectionReasonType'
 *      rejectionReason: // value for 'rejectionReason'
 *      shouldUpdateCalendar: // value for 'shouldUpdateCalendar'
 *   },
 * });
 */
export function useCaregiverRejectBookingMutation(baseOptions?: Apollo.MutationHookOptions<CaregiverRejectBookingMutation, CaregiverRejectBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaregiverRejectBookingMutation, CaregiverRejectBookingMutationVariables>(CaregiverRejectBookingDocument, options);
      }
export type CaregiverRejectBookingMutationHookResult = ReturnType<typeof useCaregiverRejectBookingMutation>;
export type CaregiverRejectBookingMutationResult = Apollo.MutationResult<CaregiverRejectBookingMutation>;
export type CaregiverRejectBookingMutationOptions = Apollo.BaseMutationOptions<CaregiverRejectBookingMutation, CaregiverRejectBookingMutationVariables>;
export const GetDataForBookingInvoiceDocument = gql`
    query getDataForBookingInvoice($id: ID!) {
  booking(id: $id) {
    id
    status
    paymentConfirmedAt
    address
    total {
      toS
    }
    totalFee {
      toS
    }
    totalFeeVat {
      toS
    }
    baseFee {
      toS
    }
    country {
      iso3661Alpha2
      vat
    }
    user {
      id
    }
    caregiver {
      publicAddress
    }
  }
  currentUser {
    name
    surname
    address1
    address2
  }
}
    `;

/**
 * __useGetDataForBookingInvoiceQuery__
 *
 * To run a query within a React component, call `useGetDataForBookingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForBookingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForBookingInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataForBookingInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables> & ({ variables: GetDataForBookingInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>(GetDataForBookingInvoiceDocument, options);
      }
export function useGetDataForBookingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>(GetDataForBookingInvoiceDocument, options);
        }
export function useGetDataForBookingInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>(GetDataForBookingInvoiceDocument, options);
        }
export type GetDataForBookingInvoiceQueryHookResult = ReturnType<typeof useGetDataForBookingInvoiceQuery>;
export type GetDataForBookingInvoiceLazyQueryHookResult = ReturnType<typeof useGetDataForBookingInvoiceLazyQuery>;
export type GetDataForBookingInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetDataForBookingInvoiceSuspenseQuery>;
export type GetDataForBookingInvoiceQueryResult = Apollo.QueryResult<GetDataForBookingInvoiceQuery, GetDataForBookingInvoiceQueryVariables>;
export const GetCurrentUserForPaymentDocument = gql`
    query getCurrentUserForPayment {
  currentUser {
    id
    name
    surname
    address1
    address2
    zip
    birthday
    canCreateABillingProfile
    billingCards {
      id
      alias
      provider
      expirationYear
      expirationMonth
    }
    city {
      id
      slug
      name
      placeId
      latitude
      longitude
    }
    country {
      id
      name
      locale
      currency
      fullDomain
      iso3661Alpha2
      paymentMethods
    }
  }
}
    `;

/**
 * __useGetCurrentUserForPaymentQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserForPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserForPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserForPaymentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserForPaymentQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>(GetCurrentUserForPaymentDocument, options);
      }
export function useGetCurrentUserForPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>(GetCurrentUserForPaymentDocument, options);
        }
export function useGetCurrentUserForPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>(GetCurrentUserForPaymentDocument, options);
        }
export type GetCurrentUserForPaymentQueryHookResult = ReturnType<typeof useGetCurrentUserForPaymentQuery>;
export type GetCurrentUserForPaymentLazyQueryHookResult = ReturnType<typeof useGetCurrentUserForPaymentLazyQuery>;
export type GetCurrentUserForPaymentSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserForPaymentSuspenseQuery>;
export type GetCurrentUserForPaymentQueryResult = Apollo.QueryResult<GetCurrentUserForPaymentQuery, GetCurrentUserForPaymentQueryVariables>;
export const GetBookingForPaymentDocument = gql`
    query getBookingForPayment($id: ID!) {
  booking(id: $id) {
    ...BookingParts
  }
}
    ${BookingPartsFragmentDoc}`;

/**
 * __useGetBookingForPaymentQuery__
 *
 * To run a query within a React component, call `useGetBookingForPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingForPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingForPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingForPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables> & ({ variables: GetBookingForPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>(GetBookingForPaymentDocument, options);
      }
export function useGetBookingForPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>(GetBookingForPaymentDocument, options);
        }
export function useGetBookingForPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>(GetBookingForPaymentDocument, options);
        }
export type GetBookingForPaymentQueryHookResult = ReturnType<typeof useGetBookingForPaymentQuery>;
export type GetBookingForPaymentLazyQueryHookResult = ReturnType<typeof useGetBookingForPaymentLazyQuery>;
export type GetBookingForPaymentSuspenseQueryHookResult = ReturnType<typeof useGetBookingForPaymentSuspenseQuery>;
export type GetBookingForPaymentQueryResult = Apollo.QueryResult<GetBookingForPaymentQuery, GetBookingForPaymentQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($name: String!, $surname: String!, $birthday: ISO8601Date!, $address1: String!, $address2: String, $zip: String!, $city: CityInput!) {
  updateUser(
    input: {name: $name, surname: $surname, birthday: $birthday, address_1: $address1, address_2: $address2, zip: $zip, city: $city}
  ) {
    user {
      id
      name
      surname
      address1
      address2
      zip
      city {
        id
        slug
        name
        placeId
        latitude
        longitude
        name
        country {
          id
          name
        }
      }
      birthday
      currency
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      surname: // value for 'surname'
 *      birthday: // value for 'birthday'
 *      address1: // value for 'address1'
 *      address2: // value for 'address2'
 *      zip: // value for 'zip'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const InitBillingCardRegistrationDocument = gql`
    mutation initBillingCardRegistration($currency: Currency!, $cardType: CardType) {
  initBillingCardRegistration(input: {currency: $currency, cardType: $cardType}) {
    cardRegistrationData {
      accessKey
      cardRegistrationUrl
      id
      preregistrationData
    }
  }
}
    `;
export type InitBillingCardRegistrationMutationFn = Apollo.MutationFunction<InitBillingCardRegistrationMutation, InitBillingCardRegistrationMutationVariables>;

/**
 * __useInitBillingCardRegistrationMutation__
 *
 * To run a mutation, you first call `useInitBillingCardRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBillingCardRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBillingCardRegistrationMutation, { data, loading, error }] = useInitBillingCardRegistrationMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *      cardType: // value for 'cardType'
 *   },
 * });
 */
export function useInitBillingCardRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<InitBillingCardRegistrationMutation, InitBillingCardRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBillingCardRegistrationMutation, InitBillingCardRegistrationMutationVariables>(InitBillingCardRegistrationDocument, options);
      }
export type InitBillingCardRegistrationMutationHookResult = ReturnType<typeof useInitBillingCardRegistrationMutation>;
export type InitBillingCardRegistrationMutationResult = Apollo.MutationResult<InitBillingCardRegistrationMutation>;
export type InitBillingCardRegistrationMutationOptions = Apollo.BaseMutationOptions<InitBillingCardRegistrationMutation, InitBillingCardRegistrationMutationVariables>;
export const CreateBillingCardMutationDocument = gql`
    mutation createBillingCardMutation($token: String!) {
  createBillingCard(input: {token: $token}) {
    billingCard {
      id
      alias
      expirationMonth
      expirationYear
      provider
      currency
    }
  }
}
    `;
export type CreateBillingCardMutationMutationFn = Apollo.MutationFunction<CreateBillingCardMutationMutation, CreateBillingCardMutationMutationVariables>;

/**
 * __useCreateBillingCardMutationMutation__
 *
 * To run a mutation, you first call `useCreateBillingCardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingCardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingCardMutationMutation, { data, loading, error }] = useCreateBillingCardMutationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateBillingCardMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingCardMutationMutation, CreateBillingCardMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingCardMutationMutation, CreateBillingCardMutationMutationVariables>(CreateBillingCardMutationDocument, options);
      }
export type CreateBillingCardMutationMutationHookResult = ReturnType<typeof useCreateBillingCardMutationMutation>;
export type CreateBillingCardMutationMutationResult = Apollo.MutationResult<CreateBillingCardMutationMutation>;
export type CreateBillingCardMutationMutationOptions = Apollo.BaseMutationOptions<CreateBillingCardMutationMutation, CreateBillingCardMutationMutationVariables>;
export const DeleteBillingCardDocument = gql`
    mutation deleteBillingCard($billingCardId: ID!) {
  deleteBillingCard(input: {billingCardId: $billingCardId}) {
    billingCards {
      id
      alias
      provider
      expirationYear
      expirationMonth
    }
    errors {
      message
    }
  }
}
    `;
export type DeleteBillingCardMutationFn = Apollo.MutationFunction<DeleteBillingCardMutation, DeleteBillingCardMutationVariables>;

/**
 * __useDeleteBillingCardMutation__
 *
 * To run a mutation, you first call `useDeleteBillingCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillingCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBillingCardMutation, { data, loading, error }] = useDeleteBillingCardMutation({
 *   variables: {
 *      billingCardId: // value for 'billingCardId'
 *   },
 * });
 */
export function useDeleteBillingCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBillingCardMutation, DeleteBillingCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBillingCardMutation, DeleteBillingCardMutationVariables>(DeleteBillingCardDocument, options);
      }
export type DeleteBillingCardMutationHookResult = ReturnType<typeof useDeleteBillingCardMutation>;
export type DeleteBillingCardMutationResult = Apollo.MutationResult<DeleteBillingCardMutation>;
export type DeleteBillingCardMutationOptions = Apollo.BaseMutationOptions<DeleteBillingCardMutation, DeleteBillingCardMutationVariables>;
export const OwnerConfirmBookingDocument = gql`
    mutation ownerConfirmBooking($id: ID!, $billingCardId: ID, $browserInfo: BrowserInfoInput, $directDebitMethod: DirectDebitMethod) {
  ownerConfirmBooking(
    input: {id: $id, browserInfo: $browserInfo, billingCardId: $billingCardId, directDebitMethod: $directDebitMethod}
  ) {
    booking {
      id
      conversationId
    }
    payment {
      id
      status
      redirectUrl
    }
    errors {
      message
      path
    }
  }
}
    `;
export type OwnerConfirmBookingMutationFn = Apollo.MutationFunction<OwnerConfirmBookingMutation, OwnerConfirmBookingMutationVariables>;

/**
 * __useOwnerConfirmBookingMutation__
 *
 * To run a mutation, you first call `useOwnerConfirmBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerConfirmBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerConfirmBookingMutation, { data, loading, error }] = useOwnerConfirmBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      billingCardId: // value for 'billingCardId'
 *      browserInfo: // value for 'browserInfo'
 *      directDebitMethod: // value for 'directDebitMethod'
 *   },
 * });
 */
export function useOwnerConfirmBookingMutation(baseOptions?: Apollo.MutationHookOptions<OwnerConfirmBookingMutation, OwnerConfirmBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerConfirmBookingMutation, OwnerConfirmBookingMutationVariables>(OwnerConfirmBookingDocument, options);
      }
export type OwnerConfirmBookingMutationHookResult = ReturnType<typeof useOwnerConfirmBookingMutation>;
export type OwnerConfirmBookingMutationResult = Apollo.MutationResult<OwnerConfirmBookingMutation>;
export type OwnerConfirmBookingMutationOptions = Apollo.BaseMutationOptions<OwnerConfirmBookingMutation, OwnerConfirmBookingMutationVariables>;
export const OwnerPreapproveBookingDocument = gql`
    mutation ownerPreapproveBooking($id: ID!, $billingCardId: ID!, $browserInfo: BrowserInfoInput!) {
  ownerPreapproveBooking(
    input: {id: $id, billingCardId: $billingCardId, browserInfo: $browserInfo}
  ) {
    booking {
      ...BookingParts
    }
    payment {
      id
      status
      redirectUrl
    }
    errors {
      message
      path
    }
  }
}
    ${BookingPartsFragmentDoc}`;
export type OwnerPreapproveBookingMutationFn = Apollo.MutationFunction<OwnerPreapproveBookingMutation, OwnerPreapproveBookingMutationVariables>;

/**
 * __useOwnerPreapproveBookingMutation__
 *
 * To run a mutation, you first call `useOwnerPreapproveBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerPreapproveBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerPreapproveBookingMutation, { data, loading, error }] = useOwnerPreapproveBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      billingCardId: // value for 'billingCardId'
 *      browserInfo: // value for 'browserInfo'
 *   },
 * });
 */
export function useOwnerPreapproveBookingMutation(baseOptions?: Apollo.MutationHookOptions<OwnerPreapproveBookingMutation, OwnerPreapproveBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerPreapproveBookingMutation, OwnerPreapproveBookingMutationVariables>(OwnerPreapproveBookingDocument, options);
      }
export type OwnerPreapproveBookingMutationHookResult = ReturnType<typeof useOwnerPreapproveBookingMutation>;
export type OwnerPreapproveBookingMutationResult = Apollo.MutationResult<OwnerPreapproveBookingMutation>;
export type OwnerPreapproveBookingMutationOptions = Apollo.BaseMutationOptions<OwnerPreapproveBookingMutation, OwnerPreapproveBookingMutationVariables>;
export const UpdateBookingDocument = gql`
    mutation updateBooking($id: ID!, $meetAndGreet: Boolean) {
  updateBooking(input: {id: $id, meetAndGreet: $meetAndGreet}) {
    booking {
      ...BookingPartsForPayment
    }
    errors {
      message
      path
    }
  }
}
    ${BookingPartsForPaymentFragmentDoc}`;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      meetAndGreet: // value for 'meetAndGreet'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const GetDataForBookingReceiptDocument = gql`
    query getDataForBookingReceipt($id: ID!) {
  booking(id: $id) {
    id
    status
    startDate
    endDate
    serviceDates
    serviceQuantity
    paymentConfirmedAt
    freeCancellationLimit
    couponRedemption {
      coupon {
        id
        code
        percentageDiscount
        fixedDiscount {
          amount
          currency
        }
      }
      id
    }
    unitPrice {
      toS
    }
    total {
      toS
    }
    totalFee {
      toS
    }
    service {
      price
      currency
    }
    countryServiceType {
      name
      serviceType {
        pricePer
      }
    }
    bookingDogs {
      dog {
        name
      }
    }
    user {
      id
      name
      publicFullName
    }
    caregiver {
      name
      publicAddress
      publicFullName
    }
    payment {
      paymentMethod {
        type
        alias
        provider
      }
    }
  }
  currentUser {
    id
  }
}
    `;

/**
 * __useGetDataForBookingReceiptQuery__
 *
 * To run a query within a React component, call `useGetDataForBookingReceiptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForBookingReceiptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForBookingReceiptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataForBookingReceiptQuery(baseOptions: Apollo.QueryHookOptions<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables> & ({ variables: GetDataForBookingReceiptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>(GetDataForBookingReceiptDocument, options);
      }
export function useGetDataForBookingReceiptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>(GetDataForBookingReceiptDocument, options);
        }
export function useGetDataForBookingReceiptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>(GetDataForBookingReceiptDocument, options);
        }
export type GetDataForBookingReceiptQueryHookResult = ReturnType<typeof useGetDataForBookingReceiptQuery>;
export type GetDataForBookingReceiptLazyQueryHookResult = ReturnType<typeof useGetDataForBookingReceiptLazyQuery>;
export type GetDataForBookingReceiptSuspenseQueryHookResult = ReturnType<typeof useGetDataForBookingReceiptSuspenseQuery>;
export type GetDataForBookingReceiptQueryResult = Apollo.QueryResult<GetDataForBookingReceiptQuery, GetDataForBookingReceiptQueryVariables>;
export const GetCurrenUserWithMagicLinkDocument = gql`
    query getCurrenUserWithMagicLink {
  currentUser {
    ...currentUserParts
    appMagicLink
  }
}
    ${CurrentUserPartsFragmentDoc}`;

/**
 * __useGetCurrenUserWithMagicLinkQuery__
 *
 * To run a query within a React component, call `useGetCurrenUserWithMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenUserWithMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenUserWithMagicLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenUserWithMagicLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>(GetCurrenUserWithMagicLinkDocument, options);
      }
export function useGetCurrenUserWithMagicLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>(GetCurrenUserWithMagicLinkDocument, options);
        }
export function useGetCurrenUserWithMagicLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>(GetCurrenUserWithMagicLinkDocument, options);
        }
export type GetCurrenUserWithMagicLinkQueryHookResult = ReturnType<typeof useGetCurrenUserWithMagicLinkQuery>;
export type GetCurrenUserWithMagicLinkLazyQueryHookResult = ReturnType<typeof useGetCurrenUserWithMagicLinkLazyQuery>;
export type GetCurrenUserWithMagicLinkSuspenseQueryHookResult = ReturnType<typeof useGetCurrenUserWithMagicLinkSuspenseQuery>;
export type GetCurrenUserWithMagicLinkQueryResult = Apollo.QueryResult<GetCurrenUserWithMagicLinkQuery, GetCurrenUserWithMagicLinkQueryVariables>;
export const SmsMagicLinkDocument = gql`
    mutation smsMagicLink($input: SendSMSWithAppMagicLinkInput!) {
  sendSmsWithAppMagicLink(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;
export type SmsMagicLinkMutationFn = Apollo.MutationFunction<SmsMagicLinkMutation, SmsMagicLinkMutationVariables>;

/**
 * __useSmsMagicLinkMutation__
 *
 * To run a mutation, you first call `useSmsMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSmsMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [smsMagicLinkMutation, { data, loading, error }] = useSmsMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSmsMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<SmsMagicLinkMutation, SmsMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SmsMagicLinkMutation, SmsMagicLinkMutationVariables>(SmsMagicLinkDocument, options);
      }
export type SmsMagicLinkMutationHookResult = ReturnType<typeof useSmsMagicLinkMutation>;
export type SmsMagicLinkMutationResult = Apollo.MutationResult<SmsMagicLinkMutation>;
export type SmsMagicLinkMutationOptions = Apollo.BaseMutationOptions<SmsMagicLinkMutation, SmsMagicLinkMutationVariables>;
export const GetCountryServiceTypesDocument = gql`
    query getCountryServiceTypes {
  country {
    id
    iso3661Alpha2
    countryServiceTypes {
      id
      seoName
      description
      serviceType {
        id
        alwaysPickUpDropOff
        fullDayAvailability
        pricePer
      }
    }
  }
}
    `;

/**
 * __useGetCountryServiceTypesQuery__
 *
 * To run a query within a React component, call `useGetCountryServiceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryServiceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryServiceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryServiceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>(GetCountryServiceTypesDocument, options);
      }
export function useGetCountryServiceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>(GetCountryServiceTypesDocument, options);
        }
export function useGetCountryServiceTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>(GetCountryServiceTypesDocument, options);
        }
export type GetCountryServiceTypesQueryHookResult = ReturnType<typeof useGetCountryServiceTypesQuery>;
export type GetCountryServiceTypesLazyQueryHookResult = ReturnType<typeof useGetCountryServiceTypesLazyQuery>;
export type GetCountryServiceTypesSuspenseQueryHookResult = ReturnType<typeof useGetCountryServiceTypesSuspenseQuery>;
export type GetCountryServiceTypesQueryResult = Apollo.QueryResult<GetCountryServiceTypesQuery, GetCountryServiceTypesQueryVariables>;
export const AddDogDocument = gql`
    mutation addDog($input: AddDogInput!) {
  addDog(input: $input) {
    dog {
      ...DogProfileParts
    }
    errors {
      message
      path
    }
  }
}
    ${DogProfilePartsFragmentDoc}`;
export type AddDogMutationFn = Apollo.MutationFunction<AddDogMutation, AddDogMutationVariables>;

/**
 * __useAddDogMutation__
 *
 * To run a mutation, you first call `useAddDogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDogMutation, { data, loading, error }] = useAddDogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDogMutation(baseOptions?: Apollo.MutationHookOptions<AddDogMutation, AddDogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDogMutation, AddDogMutationVariables>(AddDogDocument, options);
      }
export type AddDogMutationHookResult = ReturnType<typeof useAddDogMutation>;
export type AddDogMutationResult = Apollo.MutationResult<AddDogMutation>;
export type AddDogMutationOptions = Apollo.BaseMutationOptions<AddDogMutation, AddDogMutationVariables>;
export const EditDogDocument = gql`
    mutation editDog($input: EditDogInput!) {
  editDog(input: $input) {
    dog {
      ...DogProfileParts
    }
    errors {
      message
      path
    }
  }
}
    ${DogProfilePartsFragmentDoc}`;
export type EditDogMutationFn = Apollo.MutationFunction<EditDogMutation, EditDogMutationVariables>;

/**
 * __useEditDogMutation__
 *
 * To run a mutation, you first call `useEditDogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDogMutation, { data, loading, error }] = useEditDogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDogMutation(baseOptions?: Apollo.MutationHookOptions<EditDogMutation, EditDogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDogMutation, EditDogMutationVariables>(EditDogDocument, options);
      }
export type EditDogMutationHookResult = ReturnType<typeof useEditDogMutation>;
export type EditDogMutationResult = Apollo.MutationResult<EditDogMutation>;
export type EditDogMutationOptions = Apollo.BaseMutationOptions<EditDogMutation, EditDogMutationVariables>;
export const DeleteDogDocument = gql`
    mutation deleteDog($id: ID!) {
  deleteDog(input: {id: $id}) {
    errors {
      message
      path
    }
  }
}
    `;
export type DeleteDogMutationFn = Apollo.MutationFunction<DeleteDogMutation, DeleteDogMutationVariables>;

/**
 * __useDeleteDogMutation__
 *
 * To run a mutation, you first call `useDeleteDogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDogMutation, { data, loading, error }] = useDeleteDogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDogMutation, DeleteDogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDogMutation, DeleteDogMutationVariables>(DeleteDogDocument, options);
      }
export type DeleteDogMutationHookResult = ReturnType<typeof useDeleteDogMutation>;
export type DeleteDogMutationResult = Apollo.MutationResult<DeleteDogMutation>;
export type DeleteDogMutationOptions = Apollo.BaseMutationOptions<DeleteDogMutation, DeleteDogMutationVariables>;
export const GetInboxDocument = gql`
    query getInbox($cursor: String, $first: Int, $type: InboxType) {
  inbox(first: $first, after: $cursor, type: $type) {
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      ...ConversationSummaryParts
    }
  }
  potentialJobs {
    bookingId
    startDate
    endDate
    serviceDates
    serviceTypeId
    cityName
    dogs {
      name
    }
  }
}
    ${ConversationSummaryPartsFragmentDoc}`;

/**
 * __useGetInboxQuery__
 *
 * To run a query within a React component, call `useGetInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInboxQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetInboxQuery(baseOptions?: Apollo.QueryHookOptions<GetInboxQuery, GetInboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInboxQuery, GetInboxQueryVariables>(GetInboxDocument, options);
      }
export function useGetInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInboxQuery, GetInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInboxQuery, GetInboxQueryVariables>(GetInboxDocument, options);
        }
export function useGetInboxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInboxQuery, GetInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInboxQuery, GetInboxQueryVariables>(GetInboxDocument, options);
        }
export type GetInboxQueryHookResult = ReturnType<typeof useGetInboxQuery>;
export type GetInboxLazyQueryHookResult = ReturnType<typeof useGetInboxLazyQuery>;
export type GetInboxSuspenseQueryHookResult = ReturnType<typeof useGetInboxSuspenseQuery>;
export type GetInboxQueryResult = Apollo.QueryResult<GetInboxQuery, GetInboxQueryVariables>;
export const InboxUpdatedDocument = gql`
    subscription inboxUpdated {
  inboxUpdated {
    conversation {
      ...ConversationSummaryParts
    }
  }
}
    ${ConversationSummaryPartsFragmentDoc}`;

/**
 * __useInboxUpdatedSubscription__
 *
 * To run a query within a React component, call `useInboxUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useInboxUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InboxUpdatedSubscription, InboxUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxUpdatedSubscription, InboxUpdatedSubscriptionVariables>(InboxUpdatedDocument, options);
      }
export type InboxUpdatedSubscriptionHookResult = ReturnType<typeof useInboxUpdatedSubscription>;
export type InboxUpdatedSubscriptionResult = Apollo.SubscriptionResult<InboxUpdatedSubscription>;
export const GetOwnerJobsForConversationsDocument = gql`
    query getOwnerJobsForConversations {
  ownerJobs {
    id
    startDate
    endDate
    serviceDates
    datesRequested
    city {
      name
    }
    serviceType {
      id
      name
    }
    dogs {
      id
      name
    }
    ... on JobAuthor {
      applications {
        id
        estimatedPaymentTotal {
          toS
        }
        caregiver {
          id
          name
          avatar {
            circle
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOwnerJobsForConversationsQuery__
 *
 * To run a query within a React component, call `useGetOwnerJobsForConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerJobsForConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerJobsForConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnerJobsForConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>(GetOwnerJobsForConversationsDocument, options);
      }
export function useGetOwnerJobsForConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>(GetOwnerJobsForConversationsDocument, options);
        }
export function useGetOwnerJobsForConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>(GetOwnerJobsForConversationsDocument, options);
        }
export type GetOwnerJobsForConversationsQueryHookResult = ReturnType<typeof useGetOwnerJobsForConversationsQuery>;
export type GetOwnerJobsForConversationsLazyQueryHookResult = ReturnType<typeof useGetOwnerJobsForConversationsLazyQuery>;
export type GetOwnerJobsForConversationsSuspenseQueryHookResult = ReturnType<typeof useGetOwnerJobsForConversationsSuspenseQuery>;
export type GetOwnerJobsForConversationsQueryResult = Apollo.QueryResult<GetOwnerJobsForConversationsQuery, GetOwnerJobsForConversationsQueryVariables>;
export const OwnerDeclineJobApplicationDocument = gql`
    mutation ownerDeclineJobApplication($input: OwnerDeclineJobApplicationInput!) {
  ownerDeclineJobApplication(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type OwnerDeclineJobApplicationMutationFn = Apollo.MutationFunction<OwnerDeclineJobApplicationMutation, OwnerDeclineJobApplicationMutationVariables>;

/**
 * __useOwnerDeclineJobApplicationMutation__
 *
 * To run a mutation, you first call `useOwnerDeclineJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerDeclineJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerDeclineJobApplicationMutation, { data, loading, error }] = useOwnerDeclineJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOwnerDeclineJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OwnerDeclineJobApplicationMutation, OwnerDeclineJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerDeclineJobApplicationMutation, OwnerDeclineJobApplicationMutationVariables>(OwnerDeclineJobApplicationDocument, options);
      }
export type OwnerDeclineJobApplicationMutationHookResult = ReturnType<typeof useOwnerDeclineJobApplicationMutation>;
export type OwnerDeclineJobApplicationMutationResult = Apollo.MutationResult<OwnerDeclineJobApplicationMutation>;
export type OwnerDeclineJobApplicationMutationOptions = Apollo.BaseMutationOptions<OwnerDeclineJobApplicationMutation, OwnerDeclineJobApplicationMutationVariables>;
export const OwnerAcceptJobApplicationDocument = gql`
    mutation ownerAcceptJobApplication($input: OwnerAcceptJobApplicationInput!) {
  ownerAcceptJobApplication(input: $input) {
    conversation {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type OwnerAcceptJobApplicationMutationFn = Apollo.MutationFunction<OwnerAcceptJobApplicationMutation, OwnerAcceptJobApplicationMutationVariables>;

/**
 * __useOwnerAcceptJobApplicationMutation__
 *
 * To run a mutation, you first call `useOwnerAcceptJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOwnerAcceptJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ownerAcceptJobApplicationMutation, { data, loading, error }] = useOwnerAcceptJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOwnerAcceptJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<OwnerAcceptJobApplicationMutation, OwnerAcceptJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OwnerAcceptJobApplicationMutation, OwnerAcceptJobApplicationMutationVariables>(OwnerAcceptJobApplicationDocument, options);
      }
export type OwnerAcceptJobApplicationMutationHookResult = ReturnType<typeof useOwnerAcceptJobApplicationMutation>;
export type OwnerAcceptJobApplicationMutationResult = Apollo.MutationResult<OwnerAcceptJobApplicationMutation>;
export type OwnerAcceptJobApplicationMutationOptions = Apollo.BaseMutationOptions<OwnerAcceptJobApplicationMutation, OwnerAcceptJobApplicationMutationVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser {
  currentUser {
    id
    name
    surname
    email
    type
    avatar {
      circle
    }
    intercomUserHash
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentUserIdDocument = gql`
    query getCurrentUserId {
  currentUser {
    id
  }
}
    `;

/**
 * __useGetCurrentUserIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>(GetCurrentUserIdDocument, options);
      }
export function useGetCurrentUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>(GetCurrentUserIdDocument, options);
        }
export function useGetCurrentUserIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>(GetCurrentUserIdDocument, options);
        }
export type GetCurrentUserIdQueryHookResult = ReturnType<typeof useGetCurrentUserIdQuery>;
export type GetCurrentUserIdLazyQueryHookResult = ReturnType<typeof useGetCurrentUserIdLazyQuery>;
export type GetCurrentUserIdSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserIdSuspenseQuery>;
export type GetCurrentUserIdQueryResult = Apollo.QueryResult<GetCurrentUserIdQuery, GetCurrentUserIdQueryVariables>;
export const GetCurrentCaregiverDac7ReportDocument = gql`
    query getCurrentCaregiverDac7Report($year: String!) {
  dac7Report(year: $year) {
    id
    fullName
    address
    addressCountryCode
    dateOfBirth
    taxIdentificationNumber
    totalActivitiesCompleted
    activitiesCompletedQ1
    activitiesCompletedQ2
    activitiesCompletedQ3
    activitiesCompletedQ4
    considerationCredited
    considerationCreditedQ1
    considerationCreditedQ2
    considerationCreditedQ3
    considerationCreditedQ4
    totalCaregiverPlatformCommissions
    caregiverPlatformCommissionsQ1
    caregiverPlatformCommissionsQ2
    caregiverPlatformCommissionsQ3
    caregiverPlatformCommissionsQ4
    countryCurrency
    bankAccount {
      id
      iban
      accountNumber
      sortCode
    }
  }
}
    `;

/**
 * __useGetCurrentCaregiverDac7ReportQuery__
 *
 * To run a query within a React component, call `useGetCurrentCaregiverDac7ReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCaregiverDac7ReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCaregiverDac7ReportQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetCurrentCaregiverDac7ReportQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables> & ({ variables: GetCurrentCaregiverDac7ReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>(GetCurrentCaregiverDac7ReportDocument, options);
      }
export function useGetCurrentCaregiverDac7ReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>(GetCurrentCaregiverDac7ReportDocument, options);
        }
export function useGetCurrentCaregiverDac7ReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>(GetCurrentCaregiverDac7ReportDocument, options);
        }
export type GetCurrentCaregiverDac7ReportQueryHookResult = ReturnType<typeof useGetCurrentCaregiverDac7ReportQuery>;
export type GetCurrentCaregiverDac7ReportLazyQueryHookResult = ReturnType<typeof useGetCurrentCaregiverDac7ReportLazyQuery>;
export type GetCurrentCaregiverDac7ReportSuspenseQueryHookResult = ReturnType<typeof useGetCurrentCaregiverDac7ReportSuspenseQuery>;
export type GetCurrentCaregiverDac7ReportQueryResult = Apollo.QueryResult<GetCurrentCaregiverDac7ReportQuery, GetCurrentCaregiverDac7ReportQueryVariables>;
export const GetDogProfileDocument = gql`
    query getDogProfile($id: ID!) {
  dog(id: $id) {
    id
    name
    gender
    size
    slug
    birthday
    spayedNeutered
    chip
    playsDogs
    playsDogsDesc
    playsCats
    playsCatsDesc
    playsChildren
    playsChildrenDesc
    observations
    avatar {
      circle
      big
    }
    tGender
    tAge
    tAgeShort
    tSize
    breed {
      id
      name
      tName
    }
    photos {
      id
      miniThumb
      original
      slider
      thumb
      title
    }
    activityLevel
    dailyFood
    dailyFoodServings {
      morning
      afternoon
      night
    }
    dailyWalks {
      morning
      afternoon
      night
    }
    walkingInstructions
    homeAlone
    healthInfo
    indoorPrecautions
    user {
      id
      name
      city {
        id
        name
        slug
        nearbyCities {
          name
          slug
          placeId
          activeCaregiversCount
        }
      }
      avatar {
        circle
      }
    }
    stats {
      serviceType {
        alwaysPickUpDropOff
        fullDayAvailability
        id
        name
        pricePer
      }
      bookingsCount
    }
    sameBreedDogs {
      id
      name
      tAgeShort
      gender
      slug
      avatar {
        circle
      }
    }
    reviews {
      id
      content
      createdAt
      score
      author {
        id
        name
        avatar {
          circle
          thumb
        }
        ... on Caregiver {
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetDogProfileQuery__
 *
 * To run a query within a React component, call `useGetDogProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDogProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDogProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDogProfileQuery(baseOptions: Apollo.QueryHookOptions<GetDogProfileQuery, GetDogProfileQueryVariables> & ({ variables: GetDogProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDogProfileQuery, GetDogProfileQueryVariables>(GetDogProfileDocument, options);
      }
export function useGetDogProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDogProfileQuery, GetDogProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDogProfileQuery, GetDogProfileQueryVariables>(GetDogProfileDocument, options);
        }
export function useGetDogProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDogProfileQuery, GetDogProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDogProfileQuery, GetDogProfileQueryVariables>(GetDogProfileDocument, options);
        }
export type GetDogProfileQueryHookResult = ReturnType<typeof useGetDogProfileQuery>;
export type GetDogProfileLazyQueryHookResult = ReturnType<typeof useGetDogProfileLazyQuery>;
export type GetDogProfileSuspenseQueryHookResult = ReturnType<typeof useGetDogProfileSuspenseQuery>;
export type GetDogProfileQueryResult = Apollo.QueryResult<GetDogProfileQuery, GetDogProfileQueryVariables>;
export const UpdateTaxpayerIdNumberDocument = gql`
    mutation updateTaxpayerIdNumber($input: UpdateTaxpayerIdNumberInput!) {
  updateTaxpayerIdNumber(input: $input) {
    user {
      id
      billingProfile {
        taxpayerIdNumber
        taxpayerIdNumberCountry
      }
    }
    errors {
      message
      path
    }
  }
}
    `;
export type UpdateTaxpayerIdNumberMutationFn = Apollo.MutationFunction<UpdateTaxpayerIdNumberMutation, UpdateTaxpayerIdNumberMutationVariables>;

/**
 * __useUpdateTaxpayerIdNumberMutation__
 *
 * To run a mutation, you first call `useUpdateTaxpayerIdNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxpayerIdNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxpayerIdNumberMutation, { data, loading, error }] = useUpdateTaxpayerIdNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaxpayerIdNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxpayerIdNumberMutation, UpdateTaxpayerIdNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxpayerIdNumberMutation, UpdateTaxpayerIdNumberMutationVariables>(UpdateTaxpayerIdNumberDocument, options);
      }
export type UpdateTaxpayerIdNumberMutationHookResult = ReturnType<typeof useUpdateTaxpayerIdNumberMutation>;
export type UpdateTaxpayerIdNumberMutationResult = Apollo.MutationResult<UpdateTaxpayerIdNumberMutation>;
export type UpdateTaxpayerIdNumberMutationOptions = Apollo.BaseMutationOptions<UpdateTaxpayerIdNumberMutation, UpdateTaxpayerIdNumberMutationVariables>;
export const GetCurrentUserForLayoutDocument = gql`
    query getCurrentUserForLayout {
  currentUser {
    id
    name
    surname
    email
    type
    avatar {
      circle
    }
    canCreateABillingProfile
    billingProfile {
      id
      identityStatus
      taxpayerIdNumber
      taxpayerIdNumberCountry
    }
    intercomUserHash
    notifications {
      unreadMessagesCountUser
      unreadMessagesCountCaregiver
    }
  }
}
    `;

/**
 * __useGetCurrentUserForLayoutQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserForLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserForLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserForLayoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserForLayoutQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>(GetCurrentUserForLayoutDocument, options);
      }
export function useGetCurrentUserForLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>(GetCurrentUserForLayoutDocument, options);
        }
export function useGetCurrentUserForLayoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>(GetCurrentUserForLayoutDocument, options);
        }
export type GetCurrentUserForLayoutQueryHookResult = ReturnType<typeof useGetCurrentUserForLayoutQuery>;
export type GetCurrentUserForLayoutLazyQueryHookResult = ReturnType<typeof useGetCurrentUserForLayoutLazyQuery>;
export type GetCurrentUserForLayoutSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserForLayoutSuspenseQuery>;
export type GetCurrentUserForLayoutQueryResult = Apollo.QueryResult<GetCurrentUserForLayoutQuery, GetCurrentUserForLayoutQueryVariables>;
export const GetCurrentUserNotificationsDocument = gql`
    query getCurrentUserNotifications {
  currentUser {
    notifications {
      unreadMessagesCountUser
      unreadMessagesCountCaregiver
    }
  }
}
    `;

/**
 * __useGetCurrentUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>(GetCurrentUserNotificationsDocument, options);
      }
export function useGetCurrentUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>(GetCurrentUserNotificationsDocument, options);
        }
export function useGetCurrentUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>(GetCurrentUserNotificationsDocument, options);
        }
export type GetCurrentUserNotificationsQueryHookResult = ReturnType<typeof useGetCurrentUserNotificationsQuery>;
export type GetCurrentUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserNotificationsLazyQuery>;
export type GetCurrentUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserNotificationsSuspenseQuery>;
export type GetCurrentUserNotificationsQueryResult = Apollo.QueryResult<GetCurrentUserNotificationsQuery, GetCurrentUserNotificationsQueryVariables>;
export const GetPaymentDocument = gql`
    query getPayment($id: ID!) {
  payment(id: $id) {
    id
    status
    booking {
      id
      conversationId
    }
  }
}
    `;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables> & ({ variables: GetPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export function useGetPaymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentSuspenseQueryHookResult = ReturnType<typeof useGetPaymentSuspenseQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const UpdateCaregiverDeactivateDocument = gql`
    mutation updateCaregiverDeactivate($input: UpdateCaregiverDeactivateInput!) {
  updateCaregiverDeactivate(input: $input) {
    caregiver {
      id
      caregiverStatus
      caregiverDeactivatedAt
    }
    errors {
      message
      path
    }
  }
}
    `;
export type UpdateCaregiverDeactivateMutationFn = Apollo.MutationFunction<UpdateCaregiverDeactivateMutation, UpdateCaregiverDeactivateMutationVariables>;

/**
 * __useUpdateCaregiverDeactivateMutation__
 *
 * To run a mutation, you first call `useUpdateCaregiverDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaregiverDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaregiverDeactivateMutation, { data, loading, error }] = useUpdateCaregiverDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaregiverDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaregiverDeactivateMutation, UpdateCaregiverDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaregiverDeactivateMutation, UpdateCaregiverDeactivateMutationVariables>(UpdateCaregiverDeactivateDocument, options);
      }
export type UpdateCaregiverDeactivateMutationHookResult = ReturnType<typeof useUpdateCaregiverDeactivateMutation>;
export type UpdateCaregiverDeactivateMutationResult = Apollo.MutationResult<UpdateCaregiverDeactivateMutation>;
export type UpdateCaregiverDeactivateMutationOptions = Apollo.BaseMutationOptions<UpdateCaregiverDeactivateMutation, UpdateCaregiverDeactivateMutationVariables>;
export const GetCurrentUserReferralDocument = gql`
    query getCurrentUserReferral {
  currentUser {
    type
    ... on CurrentCaregiver {
      caregiverStatus
    }
  }
  referral {
    referralCode
    referredBookings {
      booking {
        user {
          publicFullName
          avatar {
            circle
          }
        }
        id
        status
        endDate
        createdAt
      }
      reward {
        ... on Coupon {
          __typename
          id
          percentageDiscount
          fixedDiscount {
            amount
          }
        }
        ... on BillingCaregiverReward {
          __typename
          id
          bankRewardWire {
            status
          }
          amount {
            amount
            currency
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserReferralQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserReferralQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserReferralQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>(GetCurrentUserReferralDocument, options);
      }
export function useGetCurrentUserReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>(GetCurrentUserReferralDocument, options);
        }
export function useGetCurrentUserReferralSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>(GetCurrentUserReferralDocument, options);
        }
export type GetCurrentUserReferralQueryHookResult = ReturnType<typeof useGetCurrentUserReferralQuery>;
export type GetCurrentUserReferralLazyQueryHookResult = ReturnType<typeof useGetCurrentUserReferralLazyQuery>;
export type GetCurrentUserReferralSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserReferralSuspenseQuery>;
export type GetCurrentUserReferralQueryResult = Apollo.QueryResult<GetCurrentUserReferralQuery, GetCurrentUserReferralQueryVariables>;
export const CaregiverPayoutRewardDocument = gql`
    mutation caregiverPayoutReward($input: CaregiverPayoutRewardInput!) {
  caregiverPayoutReward(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;
export type CaregiverPayoutRewardMutationFn = Apollo.MutationFunction<CaregiverPayoutRewardMutation, CaregiverPayoutRewardMutationVariables>;

/**
 * __useCaregiverPayoutRewardMutation__
 *
 * To run a mutation, you first call `useCaregiverPayoutRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaregiverPayoutRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [caregiverPayoutRewardMutation, { data, loading, error }] = useCaregiverPayoutRewardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCaregiverPayoutRewardMutation(baseOptions?: Apollo.MutationHookOptions<CaregiverPayoutRewardMutation, CaregiverPayoutRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaregiverPayoutRewardMutation, CaregiverPayoutRewardMutationVariables>(CaregiverPayoutRewardDocument, options);
      }
export type CaregiverPayoutRewardMutationHookResult = ReturnType<typeof useCaregiverPayoutRewardMutation>;
export type CaregiverPayoutRewardMutationResult = Apollo.MutationResult<CaregiverPayoutRewardMutation>;
export type CaregiverPayoutRewardMutationOptions = Apollo.BaseMutationOptions<CaregiverPayoutRewardMutation, CaregiverPayoutRewardMutationVariables>;
export const GetCountryAndCurrentUserDocument = gql`
    query getCountryAndCurrentUser {
  country {
    id
    iso3661Alpha2
    countryServiceTypes {
      id
      seoName
      description
      name
      serviceType {
        id
        alwaysPickUpDropOff
        fullDayAvailability
        pricePer
      }
    }
  }
  currentUser {
    ...currentUserParts
    dogs {
      id
      name
      breed {
        id
        name
      }
      avatar {
        circle
      }
      size
      birthday
      tAge
      slug
    }
  }
}
    ${CurrentUserPartsFragmentDoc}`;

/**
 * __useGetCountryAndCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCountryAndCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryAndCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryAndCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryAndCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>(GetCountryAndCurrentUserDocument, options);
      }
export function useGetCountryAndCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>(GetCountryAndCurrentUserDocument, options);
        }
export function useGetCountryAndCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>(GetCountryAndCurrentUserDocument, options);
        }
export type GetCountryAndCurrentUserQueryHookResult = ReturnType<typeof useGetCountryAndCurrentUserQuery>;
export type GetCountryAndCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCountryAndCurrentUserLazyQuery>;
export type GetCountryAndCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCountryAndCurrentUserSuspenseQuery>;
export type GetCountryAndCurrentUserQueryResult = Apollo.QueryResult<GetCountryAndCurrentUserQuery, GetCountryAndCurrentUserQueryVariables>;
export const SearchDocument = gql`
    query search($page: Int, $pid: String, $neLat: String, $neLng: String, $swLat: String, $swLng: String, $lat: String, $lng: String, $serviceTypeId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $serviceDates: DateArray, $includePrice: Boolean = false, $dogIds: [ID!], $dogs: [DogFilter!], $withDogs: Boolean, $withOutsideArea: Boolean, $withoutKids: Boolean, $sortBy: String) {
  search(
    page: $page
    pid: $pid
    neLat: $neLat
    neLng: $neLng
    swLat: $swLat
    swLng: $swLng
    lat: $lat
    lng: $lng
    serviceTypeId: $serviceTypeId
    startDate: $startDate
    endDate: $endDate
    serviceDates: $serviceDates
    dogIds: $dogIds
    dogs: $dogs
    withDogs: $withDogs
    withOutsideArea: $withOutsideArea
    withoutKids: $withoutKids
    sortBy: $sortBy
  ) {
    totalPages
    totalEntries
    currentPage
    serviceType {
      id
      name
      pricePer
      alwaysPickUpDropOff
      fullDayAvailability
      routeServiceParam
    }
    city {
      id
      placeId
      latitude
      longitude
      name
      slug
      nearbyCities {
        id
        placeId
        latitude
        longitude
        name
        slug
        activeCaregiversCount
      }
    }
    topCities {
      id
      placeId
      latitude
      longitude
      name
      slug
      activeCaregiversCount
    }
    caregivers {
      id
      isSuperCaregiver
      caregiverHeadline
      name
      caregiverReviewsCount
      caregiverReviewsScore
      caregiverCompletedBookingsCount
      currency
      repeatCustomersCount
      latitude
      longitude
      searchDistanceAwayKm
      publicAddress
      availableHolidays
      calendarUpToDate
      services {
        serviceTypeId
      }
      featuredReview {
        id
        author {
          id
          name
          avatar {
            thumb
          }
        }
        content
      }
      avatar {
        circle
      }
      city {
        id
        slug
        name
      }
      slug
      price(serviceTypeId: $serviceTypeId) @include(if: $includePrice)
      minPrice
      bookingEstimation(
        serviceTypeId: $serviceTypeId
        startDate: $startDate
        endDate: $endDate
        serviceDates: $serviceDates
        dogIds: $dogIds
        dogs: $dogs
      ) {
        currency
        amount
        toS
      }
      availablePromotions {
        id
        tLabel
      }
      caregiverCalendarUpdatedAt
      reviews(page: 1, perPage: 1) {
        results {
          author {
            avatar {
              thumb
            }
          }
          content
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pid: // value for 'pid'
 *      neLat: // value for 'neLat'
 *      neLng: // value for 'neLng'
 *      swLat: // value for 'swLat'
 *      swLng: // value for 'swLng'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      serviceDates: // value for 'serviceDates'
 *      includePrice: // value for 'includePrice'
 *      dogIds: // value for 'dogIds'
 *      dogs: // value for 'dogs'
 *      withDogs: // value for 'withDogs'
 *      withOutsideArea: // value for 'withOutsideArea'
 *      withoutKids: // value for 'withoutKids'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useSearchQuery(baseOptions?: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SearchCityDocument = gql`
    query searchCity($city: String!, $page: Int, $pid: String, $neLat: String, $neLng: String, $swLat: String, $swLng: String, $lat: String, $lng: String, $serviceTypeId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $serviceDates: DateArray, $includePrice: Boolean = false, $dogIds: [ID!], $dogs: [DogFilter!], $withDogs: Boolean, $withOutsideArea: Boolean, $withoutKids: Boolean) {
  searchCity(
    city: $city
    page: $page
    pid: $pid
    neLat: $neLat
    neLng: $neLng
    swLat: $swLat
    swLng: $swLng
    lat: $lat
    lng: $lng
    serviceTypeId: $serviceTypeId
    startDate: $startDate
    endDate: $endDate
    serviceDates: $serviceDates
    dogIds: $dogIds
    dogs: $dogs
    withDogs: $withDogs
    withOutsideArea: $withOutsideArea
    withoutKids: $withoutKids
  ) {
    metaTitle
    metaDescription
    richSnippets
    subtitle
    seoTitle
    seoHtmlContent
    seoHtmlIntro
    blogPosts {
      link
      excerpt
      title
      featuredMedia
    }
    title
    totalEntries
    totalPages
    currentPage
    serviceType {
      id
      name
      pricePer
      alwaysPickUpDropOff
      fullDayAvailability
      routeServiceParam
    }
    city {
      minServicePriceCents
      maxServicePriceCents
      avgCaregiverReviewsScore
      id
      placeId
      latitude
      longitude
      name
      zip
      slug
      seoLandingNoindexTag
      sumCaregiverReviewsCount
      nearbyCities {
        id
        name
        slug
        placeId
        latitude
        longitude
        activeCaregiversCount
      }
      stats {
        activeSitters
        boardingActiveSitters
        walkingActiveSitters
        daycareActiveSitters
        completedBookings
        boardingCompletedBookings
        walkingCompletedBookings
        daycareCompletedBookings
        sitterReviews
        boardingSitterReviews
        walkingSitterReviews
        daycareSitterReviews
        boardingRequestDayInAdvance
        walkingRequestDayInAdvance
        daycareRequestDayInAdvance
        boardingAvgPricePerNight
        walkingAvgPricePerWalk
        daycareAvgPricePerDay
        minSitterRate
        boardingMinSitterRate
        walkingMinSitterRate
        daycareMinSitterRate
        boardingRatePlusSecondDog
        walkingRatePlusSecondDog
        daycareRatePlusSecondDog
        boardingAvgNights
        walkingAvgWalks
        daycareAvgDays
        boardingAvgBookingPrice
        walkingAvgBookingPrice
        daycareAvgBookingPrice
      }
      country {
        locale
        currency
        iso3661Alpha2
      }
    }
    caregivers {
      id
      isSuperCaregiver
      caregiverHeadline
      name
      caregiverReviewsCount
      caregiverReviewsScore
      caregiverCompletedBookingsCount
      currency
      repeatCustomersCount
      latitude
      longitude
      searchDistanceAwayKm
      publicAddress
      availableHolidays
      calendarUpToDate
      services {
        serviceTypeId
      }
      featuredReview {
        id
        author {
          id
          name
          avatar {
            thumb
          }
        }
        content
      }
      avatar {
        circle
      }
      city {
        id
        slug
        placeId
        latitude
        longitude
        name
      }
      slug
      price(serviceTypeId: $serviceTypeId) @include(if: $includePrice)
      minPrice
      bookingEstimation(
        serviceTypeId: $serviceTypeId
        startDate: $startDate
        endDate: $endDate
        serviceDates: $serviceDates
        dogIds: $dogIds
        dogs: $dogs
      ) {
        currency
        amount
        toS
      }
      availablePromotions {
        id
        tLabel
      }
    }
  }
  country {
    id
    iso3661Alpha2
    countryServiceTypes {
      id
      name
      serviceType {
        id
        alwaysPickUpDropOff
        fullDayAvailability
        pricePer
      }
    }
  }
  currentUser {
    ...currentUserParts
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      avatar {
        circle
      }
      size
      birthday
      tAge
      slug
    }
  }
}
    ${CurrentUserPartsFragmentDoc}`;

/**
 * __useSearchCityQuery__
 *
 * To run a query within a React component, call `useSearchCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCityQuery({
 *   variables: {
 *      city: // value for 'city'
 *      page: // value for 'page'
 *      pid: // value for 'pid'
 *      neLat: // value for 'neLat'
 *      neLng: // value for 'neLng'
 *      swLat: // value for 'swLat'
 *      swLng: // value for 'swLng'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      serviceDates: // value for 'serviceDates'
 *      includePrice: // value for 'includePrice'
 *      dogIds: // value for 'dogIds'
 *      dogs: // value for 'dogs'
 *      withDogs: // value for 'withDogs'
 *      withOutsideArea: // value for 'withOutsideArea'
 *      withoutKids: // value for 'withoutKids'
 *   },
 * });
 */
export function useSearchCityQuery(baseOptions: Apollo.QueryHookOptions<SearchCityQuery, SearchCityQueryVariables> & ({ variables: SearchCityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCityQuery, SearchCityQueryVariables>(SearchCityDocument, options);
      }
export function useSearchCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCityQuery, SearchCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCityQuery, SearchCityQueryVariables>(SearchCityDocument, options);
        }
export function useSearchCitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCityQuery, SearchCityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCityQuery, SearchCityQueryVariables>(SearchCityDocument, options);
        }
export type SearchCityQueryHookResult = ReturnType<typeof useSearchCityQuery>;
export type SearchCityLazyQueryHookResult = ReturnType<typeof useSearchCityLazyQuery>;
export type SearchCitySuspenseQueryHookResult = ReturnType<typeof useSearchCitySuspenseQuery>;
export type SearchCityQueryResult = Apollo.QueryResult<SearchCityQuery, SearchCityQueryVariables>;
export const SearchCityServiceTypeDocument = gql`
    query searchCityServiceType($service: String!, $city: String!, $page: Int, $pid: String, $neLat: String, $neLng: String, $swLat: String, $swLng: String, $lat: String, $lng: String, $serviceTypeId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $serviceDates: DateArray, $includePrice: Boolean = false, $dogIds: [ID!], $dogs: [DogFilter!], $withDogs: Boolean, $withOutsideArea: Boolean, $withoutKids: Boolean) {
  searchCityServiceType(
    service: $service
    city: $city
    page: $page
    pid: $pid
    neLat: $neLat
    neLng: $neLng
    swLat: $swLat
    swLng: $swLng
    lat: $lat
    lng: $lng
    serviceTypeId: $serviceTypeId
    startDate: $startDate
    endDate: $endDate
    serviceDates: $serviceDates
    dogIds: $dogIds
    dogs: $dogs
    withDogs: $withDogs
    withOutsideArea: $withOutsideArea
    withoutKids: $withoutKids
  ) {
    metaTitle
    metaDescription
    richSnippets
    title
    subtitle
    seoTitle
    seoHtmlContent
    seoHtmlIntro
    blogPosts {
      link
      excerpt
      title
      featuredMedia
    }
    totalEntries
    totalPages
    currentPage
    serviceType {
      id
      name
      pricePer
      alwaysPickUpDropOff
      fullDayAvailability
      routeServiceParam
    }
    city {
      minServicePriceCents(serviceTypeId: $serviceTypeId)
      maxServicePriceCents(serviceTypeId: $serviceTypeId)
      avgCaregiverReviewsScore
      id
      placeId
      latitude
      longitude
      name
      zip
      slug
      seoLandingNoindexTag
      sumCaregiverReviewsCount
      nearbyCities {
        id
        name
        slug
        placeId
        latitude
        longitude
        activeCaregiversCount
      }
      stats {
        activeSitters
        boardingActiveSitters
        walkingActiveSitters
        daycareActiveSitters
        completedBookings
        boardingCompletedBookings
        walkingCompletedBookings
        daycareCompletedBookings
        sitterReviews
        boardingSitterReviews
        walkingSitterReviews
        daycareSitterReviews
        boardingRequestDayInAdvance
        walkingRequestDayInAdvance
        daycareRequestDayInAdvance
        boardingAvgPricePerNight
        walkingAvgPricePerWalk
        daycareAvgPricePerDay
        minSitterRate
        boardingMinSitterRate
        walkingMinSitterRate
        daycareMinSitterRate
        boardingRatePlusSecondDog
        walkingRatePlusSecondDog
        daycareRatePlusSecondDog
        boardingAvgNights
        walkingAvgWalks
        daycareAvgDays
        boardingAvgBookingPrice
        walkingAvgBookingPrice
        daycareAvgBookingPrice
      }
      country {
        locale
        currency
        iso3661Alpha2
      }
    }
    caregivers {
      id
      isSuperCaregiver
      caregiverHeadline
      name
      caregiverReviewsCount
      caregiverReviewsScore
      caregiverCompletedBookingsCount
      currency
      repeatCustomersCount
      latitude
      longitude
      searchDistanceAwayKm
      publicAddress
      availableHolidays
      calendarUpToDate
      featuredReview {
        id
        author {
          id
          name
          avatar {
            thumb
          }
        }
        content
      }
      avatar {
        circle
      }
      city {
        id
        slug
        placeId
        latitude
        longitude
        name
      }
      slug
      price(serviceTypeId: $serviceTypeId) @include(if: $includePrice)
      bookingEstimation(
        serviceTypeId: $serviceTypeId
        startDate: $startDate
        endDate: $endDate
        serviceDates: $serviceDates
        dogIds: $dogIds
        dogs: $dogs
      ) {
        currency
        amount
        toS
      }
      availablePromotions {
        id
        tLabel
      }
    }
  }
  country {
    id
    iso3661Alpha2
    countryServiceTypes {
      id
      name
      serviceType {
        id
        alwaysPickUpDropOff
        fullDayAvailability
        pricePer
      }
    }
  }
  currentUser {
    ...currentUserParts
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      avatar {
        circle
      }
      size
      birthday
      tAge
      slug
    }
  }
}
    ${CurrentUserPartsFragmentDoc}`;

/**
 * __useSearchCityServiceTypeQuery__
 *
 * To run a query within a React component, call `useSearchCityServiceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCityServiceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCityServiceTypeQuery({
 *   variables: {
 *      service: // value for 'service'
 *      city: // value for 'city'
 *      page: // value for 'page'
 *      pid: // value for 'pid'
 *      neLat: // value for 'neLat'
 *      neLng: // value for 'neLng'
 *      swLat: // value for 'swLat'
 *      swLng: // value for 'swLng'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      serviceDates: // value for 'serviceDates'
 *      includePrice: // value for 'includePrice'
 *      dogIds: // value for 'dogIds'
 *      dogs: // value for 'dogs'
 *      withDogs: // value for 'withDogs'
 *      withOutsideArea: // value for 'withOutsideArea'
 *      withoutKids: // value for 'withoutKids'
 *   },
 * });
 */
export function useSearchCityServiceTypeQuery(baseOptions: Apollo.QueryHookOptions<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables> & ({ variables: SearchCityServiceTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>(SearchCityServiceTypeDocument, options);
      }
export function useSearchCityServiceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>(SearchCityServiceTypeDocument, options);
        }
export function useSearchCityServiceTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>(SearchCityServiceTypeDocument, options);
        }
export type SearchCityServiceTypeQueryHookResult = ReturnType<typeof useSearchCityServiceTypeQuery>;
export type SearchCityServiceTypeLazyQueryHookResult = ReturnType<typeof useSearchCityServiceTypeLazyQuery>;
export type SearchCityServiceTypeSuspenseQueryHookResult = ReturnType<typeof useSearchCityServiceTypeSuspenseQuery>;
export type SearchCityServiceTypeQueryResult = Apollo.QueryResult<SearchCityServiceTypeQuery, SearchCityServiceTypeQueryVariables>;
export const SearchServiceTypeDocument = gql`
    query searchServiceType($service: String!, $page: Int, $pid: String, $neLat: String, $neLng: String, $swLat: String, $swLng: String, $lat: String, $lng: String, $serviceTypeId: ID, $startDate: ISO8601Date, $endDate: ISO8601Date, $serviceDates: DateArray, $includePrice: Boolean = false, $dogIds: [ID!], $dogs: [DogFilter!], $withDogs: Boolean, $withOutsideArea: Boolean, $withoutKids: Boolean) {
  searchServiceType(
    service: $service
    page: $page
    pid: $pid
    neLat: $neLat
    neLng: $neLng
    swLat: $swLat
    swLng: $swLng
    lat: $lat
    lng: $lng
    serviceTypeId: $serviceTypeId
    startDate: $startDate
    endDate: $endDate
    serviceDates: $serviceDates
    dogIds: $dogIds
    dogs: $dogs
    withDogs: $withDogs
    withOutsideArea: $withOutsideArea
    withoutKids: $withoutKids
  ) {
    totalEntries
    totalPages
    currentPage
    city {
      id
      placeId
      latitude
      longitude
      name
      slug
      nearbyCities {
        id
        name
        slug
        placeId
        latitude
        longitude
        activeCaregiversCount
      }
    }
    serviceType {
      id
      name
      pricePer
      alwaysPickUpDropOff
      fullDayAvailability
      routeServiceParam
    }
    topCities {
      id
      placeId
      latitude
      longitude
      name
      slug
      activeCaregiversCount
    }
    caregivers {
      id
      isSuperCaregiver
      caregiverHeadline
      name
      caregiverReviewsCount
      caregiverReviewsScore
      caregiverCompletedBookingsCount
      currency
      repeatCustomersCount
      latitude
      longitude
      searchDistanceAwayKm
      publicAddress
      availableHolidays
      calendarUpToDate
      featuredReview {
        id
        author {
          id
          name
          avatar {
            thumb
          }
        }
        content
      }
      avatar {
        circle
      }
      city {
        id
        slug
        placeId
        latitude
        longitude
        name
      }
      slug
      price(serviceTypeId: $serviceTypeId) @include(if: $includePrice)
      bookingEstimation(
        serviceTypeId: $serviceTypeId
        startDate: $startDate
        endDate: $endDate
        serviceDates: $serviceDates
        dogIds: $dogIds
        dogs: $dogs
      ) {
        currency
        amount
        toS
      }
      availablePromotions {
        id
        tLabel
      }
    }
  }
  country {
    id
    iso3661Alpha2
    countryServiceTypes {
      id
      name
      serviceType {
        id
        alwaysPickUpDropOff
        fullDayAvailability
        pricePer
      }
    }
  }
  currentUser {
    ...currentUserParts
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      avatar {
        circle
      }
      size
      birthday
      tAge
      slug
    }
  }
}
    ${CurrentUserPartsFragmentDoc}`;

/**
 * __useSearchServiceTypeQuery__
 *
 * To run a query within a React component, call `useSearchServiceTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchServiceTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchServiceTypeQuery({
 *   variables: {
 *      service: // value for 'service'
 *      page: // value for 'page'
 *      pid: // value for 'pid'
 *      neLat: // value for 'neLat'
 *      neLng: // value for 'neLng'
 *      swLat: // value for 'swLat'
 *      swLng: // value for 'swLng'
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      serviceDates: // value for 'serviceDates'
 *      includePrice: // value for 'includePrice'
 *      dogIds: // value for 'dogIds'
 *      dogs: // value for 'dogs'
 *      withDogs: // value for 'withDogs'
 *      withOutsideArea: // value for 'withOutsideArea'
 *      withoutKids: // value for 'withoutKids'
 *   },
 * });
 */
export function useSearchServiceTypeQuery(baseOptions: Apollo.QueryHookOptions<SearchServiceTypeQuery, SearchServiceTypeQueryVariables> & ({ variables: SearchServiceTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>(SearchServiceTypeDocument, options);
      }
export function useSearchServiceTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>(SearchServiceTypeDocument, options);
        }
export function useSearchServiceTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>(SearchServiceTypeDocument, options);
        }
export type SearchServiceTypeQueryHookResult = ReturnType<typeof useSearchServiceTypeQuery>;
export type SearchServiceTypeLazyQueryHookResult = ReturnType<typeof useSearchServiceTypeLazyQuery>;
export type SearchServiceTypeSuspenseQueryHookResult = ReturnType<typeof useSearchServiceTypeSuspenseQuery>;
export type SearchServiceTypeQueryResult = Apollo.QueryResult<SearchServiceTypeQuery, SearchServiceTypeQueryVariables>;
export const GetCurrentUserForContactDocument = gql`
    query getCurrentUserForContact {
  currentUser {
    id
    phone
    type
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      avatar {
        circle
      }
      size
      birthday
      tAge
      slug
    }
  }
}
    `;

/**
 * __useGetCurrentUserForContactQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserForContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserForContactQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>(GetCurrentUserForContactDocument, options);
      }
export function useGetCurrentUserForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>(GetCurrentUserForContactDocument, options);
        }
export function useGetCurrentUserForContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>(GetCurrentUserForContactDocument, options);
        }
export type GetCurrentUserForContactQueryHookResult = ReturnType<typeof useGetCurrentUserForContactQuery>;
export type GetCurrentUserForContactLazyQueryHookResult = ReturnType<typeof useGetCurrentUserForContactLazyQuery>;
export type GetCurrentUserForContactSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserForContactSuspenseQuery>;
export type GetCurrentUserForContactQueryResult = Apollo.QueryResult<GetCurrentUserForContactQuery, GetCurrentUserForContactQueryVariables>;
export const GetCaregiverForContactDocument = gql`
    query getCaregiverForContact($id: ID!) {
  caregiver(id: $id) {
    id
    name
    type
    latitude
    longitude
    slug
    services {
      id
      currency
      pickUpDropOff
      pickUpDropOffDistance
      pickUpDropOffPrice
      meetAndGreet
      meetAndGreetPrice
      countryServiceType {
        id
        name
        description
        meetAndGreet
        serviceType {
          id
          alwaysPickUpDropOff
          fullDayAvailability
          pricePer
        }
      }
    }
  }
}
    `;

/**
 * __useGetCaregiverForContactQuery__
 *
 * To run a query within a React component, call `useGetCaregiverForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverForContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaregiverForContactQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables> & ({ variables: GetCaregiverForContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>(GetCaregiverForContactDocument, options);
      }
export function useGetCaregiverForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>(GetCaregiverForContactDocument, options);
        }
export function useGetCaregiverForContactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>(GetCaregiverForContactDocument, options);
        }
export type GetCaregiverForContactQueryHookResult = ReturnType<typeof useGetCaregiverForContactQuery>;
export type GetCaregiverForContactLazyQueryHookResult = ReturnType<typeof useGetCaregiverForContactLazyQuery>;
export type GetCaregiverForContactSuspenseQueryHookResult = ReturnType<typeof useGetCaregiverForContactSuspenseQuery>;
export type GetCaregiverForContactQueryResult = Apollo.QueryResult<GetCaregiverForContactQuery, GetCaregiverForContactQueryVariables>;
export const ContactCaregiverDocument = gql`
    mutation contactCaregiver($caregiverId: ID!, $message: String!, $serviceTypeId: ID!, $dogIds: [ID!]!, $pickUpDropOff: PickUpDropOffInput, $bookingDatesInput: BookingDatesInput!, $phone: String, $recaptchaToken: String!, $meetAndGreet: Boolean) {
  contactCaregiver(
    input: {caregiverId: $caregiverId, message: $message, serviceTypeId: $serviceTypeId, dogIds: $dogIds, pickUpDropOff: $pickUpDropOff, bookingDates: $bookingDatesInput, phone: $phone, recaptchaToken: $recaptchaToken, meetAndGreet: $meetAndGreet}
  ) {
    potentialJob {
      bookingId
      startDate
      endDate
      serviceDates
      serviceTypeId
      cityName
      dogs {
        name
      }
    }
    booking {
      id
      serviceQuantity
      caregiver {
        id
        name
        city {
          name
        }
      }
      service {
        id
        price
      }
      total {
        currency
      }
      serviceType {
        name
      }
    }
    conversation {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;
export type ContactCaregiverMutationFn = Apollo.MutationFunction<ContactCaregiverMutation, ContactCaregiverMutationVariables>;

/**
 * __useContactCaregiverMutation__
 *
 * To run a mutation, you first call `useContactCaregiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactCaregiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactCaregiverMutation, { data, loading, error }] = useContactCaregiverMutation({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *      message: // value for 'message'
 *      serviceTypeId: // value for 'serviceTypeId'
 *      dogIds: // value for 'dogIds'
 *      pickUpDropOff: // value for 'pickUpDropOff'
 *      bookingDatesInput: // value for 'bookingDatesInput'
 *      phone: // value for 'phone'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      meetAndGreet: // value for 'meetAndGreet'
 *   },
 * });
 */
export function useContactCaregiverMutation(baseOptions?: Apollo.MutationHookOptions<ContactCaregiverMutation, ContactCaregiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactCaregiverMutation, ContactCaregiverMutationVariables>(ContactCaregiverDocument, options);
      }
export type ContactCaregiverMutationHookResult = ReturnType<typeof useContactCaregiverMutation>;
export type ContactCaregiverMutationResult = Apollo.MutationResult<ContactCaregiverMutation>;
export type ContactCaregiverMutationOptions = Apollo.BaseMutationOptions<ContactCaregiverMutation, ContactCaregiverMutationVariables>;
export const CreateJobDocument = gql`
    mutation createJob($input: CreateJobFromBookingInput!) {
  createJobFromBooking(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const BookingPriceCalculationDocument = gql`
    query bookingPriceCalculation($serviceId: ID!, $dogIds: [ID!]!, $bookingDates: BookingDatesInput!, $pickUpDropOff: PickUpDropOffInput, $meetAndGreet: Boolean) {
  bookingPrice(
    serviceId: $serviceId
    dogIds: $dogIds
    bookingDates: $bookingDates
    pickUpDropOff: $pickUpDropOff
    meetAndGreet: $meetAndGreet
  ) {
    fee {
      amount
      currency
      toS
    }
    total {
      amount
      currency
      toS
    }
    holidayServicePrice {
      count
      price {
        amount
        currency
        toS
      }
    }
    standardServicePrice {
      count
      price {
        amount
        currency
        toS
      }
    }
    puppyServicePrice {
      count
      price {
        amount
        currency
        toS
      }
    }
    additionalDogServicePrice {
      count
      price {
        amount
        currency
        toS
      }
    }
    serviceTotal {
      amount
      currency
      toS
    }
    pickUpDropOffPrice {
      amount
      currency
      toS
    }
    meetAndGreetPrice {
      amount
      currency
      toS
    }
    latePickUpPrice {
      amount
      currency
      toS
    }
    pricePer
    duration
  }
}
    `;

/**
 * __useBookingPriceCalculationQuery__
 *
 * To run a query within a React component, call `useBookingPriceCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingPriceCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingPriceCalculationQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      dogIds: // value for 'dogIds'
 *      bookingDates: // value for 'bookingDates'
 *      pickUpDropOff: // value for 'pickUpDropOff'
 *      meetAndGreet: // value for 'meetAndGreet'
 *   },
 * });
 */
export function useBookingPriceCalculationQuery(baseOptions: Apollo.QueryHookOptions<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables> & ({ variables: BookingPriceCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>(BookingPriceCalculationDocument, options);
      }
export function useBookingPriceCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>(BookingPriceCalculationDocument, options);
        }
export function useBookingPriceCalculationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>(BookingPriceCalculationDocument, options);
        }
export type BookingPriceCalculationQueryHookResult = ReturnType<typeof useBookingPriceCalculationQuery>;
export type BookingPriceCalculationLazyQueryHookResult = ReturnType<typeof useBookingPriceCalculationLazyQuery>;
export type BookingPriceCalculationSuspenseQueryHookResult = ReturnType<typeof useBookingPriceCalculationSuspenseQuery>;
export type BookingPriceCalculationQueryResult = Apollo.QueryResult<BookingPriceCalculationQuery, BookingPriceCalculationQueryVariables>;
export const GetCaregiverDocument = gql`
    query getCaregiver($id: ID!, $page: Int = 1) {
  caregiver(id: $id) {
    id
    isSuperCaregiver
    name
    availablePromotions {
      id
      tLabel
    }
    cleanHeadline
    caregiverStatus
    caregiverReviewsCount
    caregiverReviewsScore
    caregiverCompletedBookingsCount
    repeatCustomersCount
    publicAddress
    caregiverDescription
    latitude
    longitude
    caregiverXpAcommodatingDogs
    caregiverXpAsDogWalker
    caregiverCalendarUpdatedAt
    caregiverHasAnimalCertificate
    caregiverHasKidsUnder18
    caregiverHasPppLicense
    caregiverProvideCustomerReviews
    caregiverOwnVehicle
    caregiverCanAdministerOralMeds
    caregiverCanAdministerInjectedMeds
    caregiverVolunteerAnimalGroups
    property {
      id
      type
      garden
      balcony
      terrace
      outdoorSize
    }
    slug
    bookmarked
    lastSeenAt
    responseTime
    bookingsRatio
    answerRatio
    services {
      id
      serviceTypeId
      currency
      price
      holidayPrice
      puppyPrice
      additionalDogPrice
      pickUpDropOff
      pickUpDropOffPrice
      pickUpDropOffDistance
      meetAndGreet
      meetAndGreetPrice
      acceptsDogs {
        puppy
        small
        medium
        large
        giant
      }
    }
    avatar {
      profile
    }
    dogs {
      id
      name
      breed {
        id
        name
        tName
      }
      gender
      size
      tAge
      birthday
      avatar {
        circle
      }
      slug
    }
    reviews(page: $page, perPage: 3) {
      currentPage
      results {
        id
        author {
          id
          name
          avatar {
            thumb
          }
        }
        score
        content
        createdAt
      }
      totalPages
    }
    country {
      locale
    }
    city {
      id
      name
      slug
      nearbyCities {
        name
        slug
        placeId
        activeCaregiversCount
      }
    }
    photos {
      id
      slider
      thumb
      title
    }
  }
}
    `;

/**
 * __useGetCaregiverQuery__
 *
 * To run a query within a React component, call `useGetCaregiverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetCaregiverQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverQuery, GetCaregiverQueryVariables> & ({ variables: GetCaregiverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverQuery, GetCaregiverQueryVariables>(GetCaregiverDocument, options);
      }
export function useGetCaregiverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverQuery, GetCaregiverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverQuery, GetCaregiverQueryVariables>(GetCaregiverDocument, options);
        }
export function useGetCaregiverSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaregiverQuery, GetCaregiverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaregiverQuery, GetCaregiverQueryVariables>(GetCaregiverDocument, options);
        }
export type GetCaregiverQueryHookResult = ReturnType<typeof useGetCaregiverQuery>;
export type GetCaregiverLazyQueryHookResult = ReturnType<typeof useGetCaregiverLazyQuery>;
export type GetCaregiverSuspenseQueryHookResult = ReturnType<typeof useGetCaregiverSuspenseQuery>;
export type GetCaregiverQueryResult = Apollo.QueryResult<GetCaregiverQuery, GetCaregiverQueryVariables>;
export const GetTopReviewsByCountryDocument = gql`
    query getTopReviewsByCountry($countryId: ID!) {
  topReviewsByCountry(countryId: $countryId) {
    score
    content
    createdAt
    author {
      id
      name
    }
    reviewable {
      ... on Caregiver {
        id
        name
        avatar {
          circle
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopReviewsByCountryQuery__
 *
 * To run a query within a React component, call `useGetTopReviewsByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopReviewsByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopReviewsByCountryQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetTopReviewsByCountryQuery(baseOptions: Apollo.QueryHookOptions<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables> & ({ variables: GetTopReviewsByCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>(GetTopReviewsByCountryDocument, options);
      }
export function useGetTopReviewsByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>(GetTopReviewsByCountryDocument, options);
        }
export function useGetTopReviewsByCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>(GetTopReviewsByCountryDocument, options);
        }
export type GetTopReviewsByCountryQueryHookResult = ReturnType<typeof useGetTopReviewsByCountryQuery>;
export type GetTopReviewsByCountryLazyQueryHookResult = ReturnType<typeof useGetTopReviewsByCountryLazyQuery>;
export type GetTopReviewsByCountrySuspenseQueryHookResult = ReturnType<typeof useGetTopReviewsByCountrySuspenseQuery>;
export type GetTopReviewsByCountryQueryResult = Apollo.QueryResult<GetTopReviewsByCountryQuery, GetTopReviewsByCountryQueryVariables>;
export const GetOwnerBookingsDocument = gql`
    query getOwnerBookings($page: Int = 1, $perPage: Int) {
  ownerBookings(page: $page, perPage: $perPage) {
    results {
      ...OwnerBookingFields
    }
    currentPage
    totalPages
  }
}
    ${OwnerBookingFieldsFragmentDoc}`;

/**
 * __useGetOwnerBookingsQuery__
 *
 * To run a query within a React component, call `useGetOwnerBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerBookingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetOwnerBookingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>(GetOwnerBookingsDocument, options);
      }
export function useGetOwnerBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>(GetOwnerBookingsDocument, options);
        }
export function useGetOwnerBookingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>(GetOwnerBookingsDocument, options);
        }
export type GetOwnerBookingsQueryHookResult = ReturnType<typeof useGetOwnerBookingsQuery>;
export type GetOwnerBookingsLazyQueryHookResult = ReturnType<typeof useGetOwnerBookingsLazyQuery>;
export type GetOwnerBookingsSuspenseQueryHookResult = ReturnType<typeof useGetOwnerBookingsSuspenseQuery>;
export type GetOwnerBookingsQueryResult = Apollo.QueryResult<GetOwnerBookingsQuery, GetOwnerBookingsQueryVariables>;
export const GetDogDocument = gql`
    query getDog($id: ID!) {
  dog(id: $id) {
    ...DogProfileParts
  }
}
    ${DogProfilePartsFragmentDoc}`;

/**
 * __useGetDogQuery__
 *
 * To run a query within a React component, call `useGetDogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDogQuery(baseOptions: Apollo.QueryHookOptions<GetDogQuery, GetDogQueryVariables> & ({ variables: GetDogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDogQuery, GetDogQueryVariables>(GetDogDocument, options);
      }
export function useGetDogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDogQuery, GetDogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDogQuery, GetDogQueryVariables>(GetDogDocument, options);
        }
export function useGetDogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDogQuery, GetDogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDogQuery, GetDogQueryVariables>(GetDogDocument, options);
        }
export type GetDogQueryHookResult = ReturnType<typeof useGetDogQuery>;
export type GetDogLazyQueryHookResult = ReturnType<typeof useGetDogLazyQuery>;
export type GetDogSuspenseQueryHookResult = ReturnType<typeof useGetDogSuspenseQuery>;
export type GetDogQueryResult = Apollo.QueryResult<GetDogQuery, GetDogQueryVariables>;
export const GetCurrentUserForEditDogDocument = gql`
    query getCurrentUserForEditDog {
  currentUser {
    id
    dogs {
      ...DogProfileParts
    }
  }
}
    ${DogProfilePartsFragmentDoc}`;

/**
 * __useGetCurrentUserForEditDogQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserForEditDogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserForEditDogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserForEditDogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserForEditDogQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>(GetCurrentUserForEditDogDocument, options);
      }
export function useGetCurrentUserForEditDogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>(GetCurrentUserForEditDogDocument, options);
        }
export function useGetCurrentUserForEditDogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>(GetCurrentUserForEditDogDocument, options);
        }
export type GetCurrentUserForEditDogQueryHookResult = ReturnType<typeof useGetCurrentUserForEditDogQuery>;
export type GetCurrentUserForEditDogLazyQueryHookResult = ReturnType<typeof useGetCurrentUserForEditDogLazyQuery>;
export type GetCurrentUserForEditDogSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserForEditDogSuspenseQuery>;
export type GetCurrentUserForEditDogQueryResult = Apollo.QueryResult<GetCurrentUserForEditDogQuery, GetCurrentUserForEditDogQueryVariables>;
export const GetJobDocument = gql`
    query getJob($id: ID!) {
  job(id: $id) {
    id
    status
    startDate
    endDate
    serviceDates
    datesRequested
    playsDogs
    playsCats
    playsChildren
    description
    user {
      name
    }
    dogs {
      id
      name
      tAgeShort
      tSize
      tGender
      avatar {
        circle
        slider
      }
      breed {
        tName
      }
    }
    ... on JobAuthor {
      applications {
        id
        estimatedPaymentTotal {
          toS
        }
        caregiver {
          id
          lastSeenAt
          latitude
          longitude
          name
          caregiverReviewsScore
          caregiverReviewsCount
          caregiverCompletedBookingsCount
          avatar {
            circle
          }
        }
      }
    }
    city {
      id
      latitude
      longitude
      name
    }
    serviceType {
      id
      pricePer
    }
    countryServiceType {
      name
    }
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> & ({ variables: GetJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetOwnerJobsDocument = gql`
    query getOwnerJobs {
  ownerJobs {
    id
    status
    startDate
    endDate
    serviceDates
    datesRequested
    playsDogs
    playsCats
    playsChildren
    description
    user {
      name
    }
    dogs {
      id
      name
      tAgeShort
      tSize
      tGender
      avatar {
        circle
        slider
      }
      breed {
        tName
      }
    }
    ... on JobAuthor {
      applications {
        id
        estimatedPaymentTotal {
          toS
        }
        caregiver {
          id
          lastSeenAt
          latitude
          longitude
          name
          caregiverReviewsScore
          caregiverReviewsCount
          caregiverCompletedBookingsCount
          avatar {
            circle
          }
        }
      }
    }
    city {
      id
      latitude
      longitude
      name
    }
    serviceType {
      id
      pricePer
    }
    countryServiceType {
      name
    }
  }
}
    `;

/**
 * __useGetOwnerJobsQuery__
 *
 * To run a query within a React component, call `useGetOwnerJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOwnerJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>(GetOwnerJobsDocument, options);
      }
export function useGetOwnerJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>(GetOwnerJobsDocument, options);
        }
export function useGetOwnerJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>(GetOwnerJobsDocument, options);
        }
export type GetOwnerJobsQueryHookResult = ReturnType<typeof useGetOwnerJobsQuery>;
export type GetOwnerJobsLazyQueryHookResult = ReturnType<typeof useGetOwnerJobsLazyQuery>;
export type GetOwnerJobsSuspenseQueryHookResult = ReturnType<typeof useGetOwnerJobsSuspenseQuery>;
export type GetOwnerJobsQueryResult = Apollo.QueryResult<GetOwnerJobsQuery, GetOwnerJobsQueryVariables>;
export const DeleteJobDocument = gql`
    mutation deleteJob($input: DeleteJobInput!) {
  deleteJob(input: $input) {
    errors {
      message
    }
  }
}
    `;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const GetCurrentUserForRegistrationDocument = gql`
    query getCurrentUserForRegistration {
  currentUser {
    id
    dogs {
      id
      name
      gender
      size
      avatar {
        circle
        big
      }
      tGender
      tAge
      tAgeShort
      tSize
      breed {
        id
        name
        tName
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserForRegistrationQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserForRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserForRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserForRegistrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserForRegistrationQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>(GetCurrentUserForRegistrationDocument, options);
      }
export function useGetCurrentUserForRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>(GetCurrentUserForRegistrationDocument, options);
        }
export function useGetCurrentUserForRegistrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>(GetCurrentUserForRegistrationDocument, options);
        }
export type GetCurrentUserForRegistrationQueryHookResult = ReturnType<typeof useGetCurrentUserForRegistrationQuery>;
export type GetCurrentUserForRegistrationLazyQueryHookResult = ReturnType<typeof useGetCurrentUserForRegistrationLazyQuery>;
export type GetCurrentUserForRegistrationSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserForRegistrationSuspenseQuery>;
export type GetCurrentUserForRegistrationQueryResult = Apollo.QueryResult<GetCurrentUserForRegistrationQuery, GetCurrentUserForRegistrationQueryVariables>;
export const AddDogForRegistrationDocument = gql`
    mutation addDogForRegistration($input: AddDogInput!) {
  addDog(input: $input) {
    dog {
      id
      name
      gender
      size
      slug
      birthday
      spayedNeutered
      chip
      playsDogs
      playsDogsDesc
      playsCats
      playsCatsDesc
      playsChildren
      playsChildrenDesc
      observations
      avatar {
        circle
        big
      }
      tGender
      tAge
      tAgeShort
      tSize
      breed {
        id
        name
        tName
      }
      activityLevel
      dailyFood
      dailyFoodServings {
        morning
        afternoon
        night
      }
      dailyWalks {
        morning
        afternoon
        night
      }
      walkingInstructions
      homeAlone
      healthInfo
      indoorPrecautions
    }
    errors {
      message
      path
    }
  }
}
    `;
export type AddDogForRegistrationMutationFn = Apollo.MutationFunction<AddDogForRegistrationMutation, AddDogForRegistrationMutationVariables>;

/**
 * __useAddDogForRegistrationMutation__
 *
 * To run a mutation, you first call `useAddDogForRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDogForRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDogForRegistrationMutation, { data, loading, error }] = useAddDogForRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDogForRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<AddDogForRegistrationMutation, AddDogForRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDogForRegistrationMutation, AddDogForRegistrationMutationVariables>(AddDogForRegistrationDocument, options);
      }
export type AddDogForRegistrationMutationHookResult = ReturnType<typeof useAddDogForRegistrationMutation>;
export type AddDogForRegistrationMutationResult = Apollo.MutationResult<AddDogForRegistrationMutation>;
export type AddDogForRegistrationMutationOptions = Apollo.BaseMutationOptions<AddDogForRegistrationMutation, AddDogForRegistrationMutationVariables>;
export const EditDogForRegistrationDocument = gql`
    mutation editDogForRegistration($input: EditDogInput!) {
  editDog(input: $input) {
    dog {
      id
      activityLevel
      dailyFood
      dailyFoodServings {
        morning
        afternoon
        night
      }
      dailyWalks {
        morning
        afternoon
        night
      }
      walkingInstructions
      homeAlone
      healthInfo
      indoorPrecautions
    }
  }
}
    `;
export type EditDogForRegistrationMutationFn = Apollo.MutationFunction<EditDogForRegistrationMutation, EditDogForRegistrationMutationVariables>;

/**
 * __useEditDogForRegistrationMutation__
 *
 * To run a mutation, you first call `useEditDogForRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDogForRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDogForRegistrationMutation, { data, loading, error }] = useEditDogForRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDogForRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<EditDogForRegistrationMutation, EditDogForRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDogForRegistrationMutation, EditDogForRegistrationMutationVariables>(EditDogForRegistrationDocument, options);
      }
export type EditDogForRegistrationMutationHookResult = ReturnType<typeof useEditDogForRegistrationMutation>;
export type EditDogForRegistrationMutationResult = Apollo.MutationResult<EditDogForRegistrationMutation>;
export type EditDogForRegistrationMutationOptions = Apollo.BaseMutationOptions<EditDogForRegistrationMutation, EditDogForRegistrationMutationVariables>;